var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _g, _g2, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _g3, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _g4, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _g5, _path1105, _path1106, _path1107, _g6, _path1108, _path1109, _path1110, _g7, _path1111, _path1112, _path1113, _g8, _path1114, _path1115, _g9, _path1116, _path1117, _g0, _path1118, _path1119, _g1, _path1120, _path1121, _path1122, _path1123, _g10, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _g11, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _path1363, _path1364, _path1365, _path1366, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _g84, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _g85, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _g86, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _g87, _g88, _g89, _g90, _g91, _g92, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _g93, _path1464, _path1465, _path1466, _g94, _path1467, _path1468, _path1469, _g95, _path1470, _path1471, _path1472, _g96, _path1473, _path1474, _path1475, _path1476, _path1477, _g97, _path1478, _path1479, _path1480, _g98, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _g99, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _g100, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _g101, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _g102, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _g103, _path1841, _path1842, _path1843, _path1844, _g104, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _g105, _path1862, _g106, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _g107, _path1875, _path1876, _path1877, _path1878, _g108, _path1879, _path1880, _path1881, _path1882, _g109, _path1883, _path1884, _path1885, _path1886, _g110, _path1887, _path1888, _path1889, _path1890, _g111, _path1891, _path1892, _path1893, _path1894, _g112, _path1895, _path1896, _path1897, _path1898, _g113, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _g114, _path1923, _path1924, _path1925, _path1926, _g115, _path1927, _path1928, _path1929, _path1930, _g116, _path1931, _path1932, _path1933, _path1934, _g117, _path1935, _path1936, _path1937, _path1938, _g118, _path1939, _path1940, _path1941, _path1942, _g119, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _g120, _path1953, _path1954, _path1955, _path1956, _g121, _path1957, _path1958, _path1959, _path1960, _g122, _path1961, _path1962, _path1963, _path1964, _g123, _path1965, _path1966, _path1967, _path1968, _g124, _path1969, _path1970, _path1971, _path1972, _g125, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _g126, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _g127, _path2000, _g128, _path2001, _path2002, _g129, _path2003, _g130, _path2004, _path2005, _g131, _path2006, _g132, _path2007, _path2008, _g133, _path2009, _g134, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _ellipse, _path2060, _path2061, _path2062, _path2063, _path2064;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalContentCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1236,
    height: 407,
    viewBox: "0 0 795 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.63 160.379C416.518 160.379 364.342 160.73 361.062 160.625C360.826 160.625 360.702 160.261 360.933 160.142C363.004 159.095 365.347 159.304 367.494 158.562C368.76 158.106 369.538 157.277 370.414 156.284C371.139 155.433 372.079 154.803 373.13 154.462C374.09 154.167 375.109 154.134 376.086 154.367C377.144 154.626 378.064 155.246 379.073 155.637C381.58 156.608 384.016 155.688 385.807 153.788C387.283 152.221 388.737 150.741 390.741 149.898C391.561 149.518 392.448 149.316 393.348 149.303C394.247 149.291 395.139 149.469 395.969 149.826C397.885 150.714 399.196 152.499 400.996 153.574C403.125 154.849 405.677 154.549 408.028 154.941C410.38 155.332 412.189 157.359 414.251 158.53C414.924 158.972 415.702 159.219 416.501 159.245C416.945 159.245 417.416 159.104 417.87 159.044C418.581 158.953 419.257 158.976 419.737 159.582C419.857 159.75 419.83 160.379 419.63 160.379Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M556.82 125.039C554.558 125.039 516.459 125.299 514.063 125.217C513.894 125.217 513.801 124.953 513.97 124.866C515.481 124.101 517.193 124.256 518.762 123.714C519.686 123.395 520.251 122.776 520.891 122.07C521.422 121.451 522.107 120.991 522.873 120.74C523.575 120.524 524.32 120.5 525.034 120.671C525.779 120.928 526.508 121.232 527.216 121.582C529.043 122.288 530.821 121.619 532.128 120.216C533.208 119.073 534.266 117.993 535.733 117.378C536.331 117.1 536.978 116.952 537.634 116.943C538.291 116.933 538.942 117.063 539.547 117.324C540.947 117.97 541.907 119.278 543.219 120.056C544.774 120.99 546.637 120.767 548.353 121.049C550.068 121.332 551.393 122.812 552.9 123.668C553.391 123.993 553.96 124.172 554.545 124.188C554.878 124.188 555.211 124.088 555.545 124.047C555.785 123.978 556.038 123.978 556.278 124.047C556.518 124.116 556.735 124.252 556.905 124.438C556.967 124.584 556.967 125.039 556.82 125.039Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M358.368 124.474C356.101 124.474 318.003 124.734 315.611 124.652C315.438 124.652 315.344 124.388 315.518 124.301C317.025 123.536 318.736 123.691 320.305 123.149C321.23 122.83 321.794 122.21 322.434 121.504C322.966 120.885 323.651 120.426 324.417 120.174C325.119 119.959 325.864 119.935 326.577 120.106C327.323 120.362 328.052 120.667 328.76 121.017C330.591 121.723 332.369 121.054 333.676 119.651C334.752 118.507 335.814 117.428 337.276 116.813C337.875 116.535 338.523 116.387 339.18 116.377C339.837 116.368 340.489 116.498 341.095 116.758C342.491 117.405 343.451 118.712 344.762 119.491C346.318 120.402 348.18 120.202 349.901 120.484C351.621 120.767 352.937 122.247 354.443 123.103C354.929 123.436 355.495 123.627 356.079 123.654C356.415 123.624 356.749 123.575 357.079 123.509C357.32 123.441 357.574 123.442 357.813 123.512C358.053 123.582 358.27 123.718 358.44 123.905C358.533 124.014 358.515 124.474 358.368 124.474Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519.506 164.052C517.239 164.052 479.14 164.312 476.744 164.23C476.575 164.23 476.482 163.966 476.651 163.879C478.162 163.114 479.873 163.269 481.442 162.727C482.367 162.408 482.931 161.789 483.572 161.083C484.103 160.464 484.788 160.004 485.554 159.753C486.256 159.537 487.001 159.513 487.714 159.684C488.46 159.941 489.189 160.245 489.897 160.595C491.724 161.301 493.506 160.632 494.787 159.229C495.867 158.086 496.925 157.006 498.391 156.391C498.99 156.113 499.638 155.965 500.295 155.956C500.952 155.946 501.604 156.076 502.21 156.336C503.606 156.983 504.566 158.29 505.877 159.069C507.433 159.98 509.295 159.78 511.011 160.062C512.727 160.345 514.052 161.825 515.558 162.681C516.05 163.005 516.619 163.185 517.203 163.201C517.539 163.17 517.873 163.121 518.203 163.055C518.444 162.988 518.697 162.989 518.937 163.059C519.177 163.129 519.393 163.264 519.563 163.451C519.67 163.597 519.63 164.052 519.506 164.052Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M371.473 183.236C372.642 183.236 401.841 183.02 410.087 183.02C410.663 183.02 409.935 181.997 409.617 181.925C408.602 181.709 407.547 181.685 406.515 181.577C405.499 181.477 404.503 181.222 403.561 180.818C402.748 180.466 401.938 180.06 401.06 179.921C399.362 179.647 397.87 180.591 396.277 181.002C395.793 181.146 395.285 181.184 394.787 181.114C394.288 181.044 393.808 180.869 393.38 180.598C392.643 180.144 391.972 179.601 391.202 179.201C389.727 178.458 388.119 178.034 386.477 177.957C384.835 177.88 383.195 178.151 381.66 178.754C380.929 179.043 380.23 179.409 379.573 179.848C378.795 180.371 378.124 181.041 377.343 181.558C375.613 182.704 373.475 182.332 371.589 182.989C371.487 183.037 371.371 183.236 371.473 183.236Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.379 198.757C405.926 198.757 431.96 198.932 433.595 198.878C433.622 198.877 433.649 198.867 433.67 198.85C433.692 198.833 433.707 198.809 433.714 198.782C433.721 198.755 433.72 198.726 433.71 198.7C433.7 198.674 433.682 198.652 433.658 198.638C432.627 198.115 431.458 198.22 430.386 197.851C429.753 197.635 429.369 197.202 428.93 196.726C428.567 196.303 428.099 195.989 427.575 195.818C427.095 195.671 426.586 195.655 426.098 195.773C425.57 195.9 425.113 196.205 424.608 196.406C423.357 196.891 422.142 196.43 421.249 195.481C420.513 194.7 419.789 193.967 418.787 193.535C418.378 193.346 417.936 193.245 417.487 193.239C417.039 193.232 416.594 193.321 416.181 193.498C415.225 193.931 414.571 194.834 413.672 195.369C412.617 196.006 411.338 195.855 410.163 196.047C408.987 196.24 408.088 197.254 407.059 197.838C406.722 198.058 406.333 198.181 405.934 198.192C405.705 198.172 405.476 198.139 405.25 198.095C404.896 198.05 404.56 198.06 404.322 198.363C404.265 198.443 404.278 198.757 404.379 198.757Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.217 200.477C300.346 200.477 319.351 200.605 320.545 200.566C320.632 200.566 320.678 200.434 320.592 200.391C319.841 200.008 318.986 200.086 318.203 199.815C317.743 199.655 317.461 199.348 317.148 198.994C316.885 198.685 316.543 198.456 316.161 198.332C315.81 198.225 315.439 198.213 315.082 198.298C314.698 198.393 314.363 198.618 313.996 198.76C313.082 199.115 312.194 198.778 311.542 198.086C311.006 197.515 310.487 196.976 309.746 196.669C309.448 196.532 309.126 196.459 308.799 196.454C308.472 196.45 308.148 196.514 307.847 196.643C307.142 196.972 306.657 197.621 306.003 198.008C305.226 198.473 304.298 198.365 303.441 198.503C302.584 198.641 301.924 199.383 301.173 199.8C300.928 199.962 300.645 200.052 300.354 200.062C300.186 200.046 300.019 200.021 299.854 199.988C299.594 199.956 299.35 199.965 299.174 200.185C299.124 200.248 299.141 200.477 299.217 200.477Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M398.719 176.511C399.848 176.511 418.856 176.639 420.05 176.6C420.135 176.6 420.181 176.468 420.097 176.424C419.343 176.042 418.489 176.12 417.706 175.849C417.246 175.689 416.963 175.38 416.651 175.028C416.386 174.719 416.044 174.49 415.661 174.366C415.312 174.257 414.941 174.246 414.585 174.331C414.199 174.424 413.864 174.651 413.496 174.794C412.583 175.147 411.696 174.811 411.044 174.12C410.506 173.549 409.977 173.01 409.247 172.703C408.949 172.566 408.627 172.492 408.3 172.488C407.973 172.483 407.649 172.547 407.348 172.675C406.649 173 406.17 173.65 405.516 174.042C404.74 174.507 403.811 174.396 402.954 174.537C402.098 174.677 401.439 175.417 400.686 175.834C400.441 175.996 400.158 176.087 399.867 176.096C399.7 176.08 399.533 176.055 399.367 176.022C399.248 175.989 399.121 175.99 399.002 176.024C398.883 176.059 398.775 176.126 398.69 176.219C398.641 176.282 398.65 176.511 398.719 176.511Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.774 176.591C315.797 176.656 345.737 176.591 345.353 176.591C345.182 176.591 345.615 176.327 345.446 176.243C344.471 175.745 343.405 175.732 342.344 175.633C341.717 175.606 341.102 175.452 340.533 175.181C339.968 174.878 339.616 174.353 339.217 173.869C338.599 173.121 337.805 172.547 336.91 172.201C336.016 171.855 335.05 171.748 334.104 171.89C331.975 172.232 330.306 173.892 328.166 174.199C326.885 174.383 325.674 173.875 324.423 173.696C323.454 173.559 322.469 173.744 321.61 174.223C320.935 174.565 320.312 174.855 319.549 174.909C318.962 174.952 318.373 174.883 317.787 174.876C316.825 174.895 315.903 175.272 315.193 175.938C315.098 176.018 314.797 176.591 315.774 176.591Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M306.084 251.774H313.319V212.909H306.084V251.774Z",
    fill: "#DBDBDB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 215.655H312.2V214.172H310.793V215.655Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 215.655H310.397V214.172H308.99V215.655Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 218.173H312.2V216.69H310.793V218.173Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 218.173H310.397V216.69H308.99V218.173Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 220.692H312.2V219.209H310.793V220.692Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 220.692H310.397V219.209H308.99V220.692Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 223.215H312.2V221.732H310.793V223.215Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 223.215H310.397V221.732H308.99V223.215Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 225.732H312.2V224.249H310.793V225.732Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 225.732H310.397V224.249H308.99V225.732Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 228.252H312.2V226.769H310.793V228.252Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 228.252H310.397V226.769H308.99V228.252Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 230.771H312.2V229.287H310.793V230.771Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 230.771H310.397V229.287H308.99V230.771Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 233.294H312.2V231.811H310.793V233.294Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 233.294H310.397V231.811H308.99V233.294Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 235.811H312.2V234.327H310.793V235.811Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 235.811H310.397V234.327H308.99V235.811Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 238.33H312.2V236.847H310.793V238.33Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 238.33H310.397V236.847H308.99V238.33Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 240.849H312.2V239.365H310.793V240.849Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 240.849H310.397V239.365H308.99V240.849Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 243.37H312.2V241.887H310.793V243.37Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 243.37H310.397V241.887H308.99V243.37Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 245.886H312.2V244.402H310.793V245.886Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 245.886H310.397V244.402H308.99V245.886Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M310.793 248.408H312.2V246.925H310.793V248.408Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 246.925H307.208V248.408H308.615V246.925Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 244.405H307.208V245.889H308.615V244.405Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 241.884H307.208V243.367H308.615V241.884Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 239.367H307.208V240.85H308.615V239.367Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 236.847H307.208V238.33H308.615V236.847Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 234.325H307.208V235.808H308.615V234.325Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 231.806H307.208V233.289H308.615V231.806Z",
    fill: "#EBEBEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 229.287H307.208V230.77H308.615V229.287Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 226.77H307.208V228.253H308.615V226.77Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 224.247H307.208V225.73H308.615V224.247Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 221.729H307.208V223.212H308.615V221.729Z",
    fill: "#EBEBEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 219.209H307.208V220.692H308.615V219.209Z",
    fill: "#EBEBEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 216.691H307.208V218.175H308.615V216.691Z",
    fill: "#EBEBEB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 214.171H307.208V215.654H308.615V214.171Z",
    fill: "#EBEBEB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M308.99 248.408H310.397V246.925H308.99V248.408Z",
    fill: "#EBEBEB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M300.379 251.774H306.085V212.909H300.379V251.774Z",
    fill: "#A6A6A6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 246.925H300.969V248.408H302.129V246.925Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 246.925H302.454V248.408H303.615V246.925Z",
    fill: "#C7C7C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 244.405H300.969V245.889H302.129V244.405Z",
    fill: "#C7C7C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 244.405H302.454V245.889H303.615V244.405Z",
    fill: "#C7C7C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 241.884H300.969V243.367H302.129V241.884Z",
    fill: "#C7C7C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 241.884H302.454V243.367H303.615V241.884Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 239.367H300.969V240.85H302.129V239.367Z",
    fill: "#C7C7C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 239.367H302.454V240.85H303.615V239.367Z",
    fill: "#C7C7C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 236.847H300.969V238.33H302.129V236.847Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 236.847H302.454V238.33H303.615V236.847Z",
    fill: "#C7C7C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 234.325H300.969V235.808H302.129V234.325Z",
    fill: "#C7C7C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 234.325H302.454V235.808H303.615V234.325Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 231.806H300.969V233.289H302.129V231.806Z",
    fill: "#C7C7C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 231.806H302.454V233.289H303.615V231.806Z",
    fill: "#C7C7C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 229.287H300.969V230.77H302.129V229.287Z",
    fill: "#C7C7C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 229.287H302.454V230.77H303.615V229.287Z",
    fill: "#C7C7C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 226.77H300.969V228.253H302.129V226.77Z",
    fill: "#C7C7C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 226.77H302.454V228.253H303.615V226.77Z",
    fill: "#C7C7C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 224.247H300.969V225.73H302.129V224.247Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 224.247H302.454V225.73H303.615V224.247Z",
    fill: "#C7C7C7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 221.729H300.969V223.212H302.129V221.729Z",
    fill: "#C7C7C7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 221.729H302.454V223.212H303.615V221.729Z",
    fill: "#C7C7C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 219.209H300.969V220.692H302.129V219.209Z",
    fill: "#C7C7C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 219.209H302.454V220.692H303.615V219.209Z",
    fill: "#C7C7C7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 216.691H300.969V218.175H302.129V216.691Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 216.691H302.454V218.175H303.615V216.691Z",
    fill: "#C7C7C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 214.171H300.969V215.654H302.129V214.171Z",
    fill: "#C7C7C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 215.655H305.09V214.172H303.929V215.655Z",
    fill: "#C7C7C7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 218.173H305.09V216.69H303.929V218.173Z",
    fill: "#C7C7C7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 220.692H305.09V219.209H303.929V220.692Z",
    fill: "#C7C7C7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 223.215H305.09V221.732H303.929V223.215Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 225.732H305.09V224.249H303.929V225.732Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 228.252H305.09V226.769H303.929V228.252Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 230.771H305.09V229.287H303.929V230.771Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 233.294H305.09V231.811H303.929V233.294Z",
    fill: "#C7C7C7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 235.811H305.09V234.327H303.929V235.811Z",
    fill: "#C7C7C7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 238.33H305.09V236.847H303.929V238.33Z",
    fill: "#C7C7C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 240.849H305.09V239.365H303.929V240.849Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 243.37H305.09V241.887H303.929V243.37Z",
    fill: "#C7C7C7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 245.886H305.09V244.402H303.929V245.886Z",
    fill: "#C7C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M303.929 248.408H305.09V246.925H303.929V248.408Z",
    fill: "#C7C7C7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 214.171H302.454V215.654H303.615V214.171Z",
    fill: "#C7C7C7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M432.311 212.059H424.763V251.771H432.311V212.059Z",
    fill: "#EBEBEB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M424.761 212.062H432.49V211.27H424.761V212.062Z",
    fill: "#C7C7C7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M431.626 213.224H430.862V251.771H431.626V213.224Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M430.273 213.224H429.509V251.771H430.273V213.224Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M428.918 213.224H428.154V251.771H428.918V213.224Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M427.565 213.224H426.801V251.771H427.565V213.224Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M426.207 213.224H425.443V251.771H426.207V213.224Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 215.787H431.627V214.226H430.863V215.787Z",
    fill: "#EBEBEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 215.787H430.272V214.226H429.509V215.787Z",
    fill: "#EBEBEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 215.787H428.92V214.226H428.156V215.787Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 215.787H427.563V214.226H426.8V215.787Z",
    fill: "#EBEBEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 215.787H426.21V214.226H425.446V215.787Z",
    fill: "#EBEBEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 218.324H431.627V216.763H430.863V218.324Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 218.324H430.272V216.763H429.509V218.324Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 218.324H428.92V216.763H428.156V218.324Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 218.324H427.563V216.763H426.8V218.324Z",
    fill: "#EBEBEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 218.324H426.21V216.763H425.446V218.324Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 220.859H431.627V219.298H430.863V220.859Z",
    fill: "#EBEBEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 220.859H430.272V219.298H429.509V220.859Z",
    fill: "#EBEBEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 220.859H428.92V219.298H428.156V220.859Z",
    fill: "#EBEBEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 220.859H427.563V219.298H426.8V220.859Z",
    fill: "#EBEBEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 220.859H426.21V219.298H425.446V220.859Z",
    fill: "#EBEBEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 223.396H431.627V221.835H430.863V223.396Z",
    fill: "#EBEBEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 223.396H430.272V221.835H429.509V223.396Z",
    fill: "#EBEBEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 223.396H428.92V221.835H428.156V223.396Z",
    fill: "#EBEBEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 223.396H427.563V221.835H426.8V223.396Z",
    fill: "#EBEBEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 223.396H426.21V221.835H425.446V223.396Z",
    fill: "#EBEBEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 225.936H431.627V224.374H430.863V225.936Z",
    fill: "#EBEBEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 225.936H430.272V224.374H429.509V225.936Z",
    fill: "#EBEBEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 225.936H428.92V224.374H428.156V225.936Z",
    fill: "#EBEBEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 225.936H427.563V224.374H426.8V225.936Z",
    fill: "#EBEBEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 225.936H426.21V224.374H425.446V225.936Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 228.47H431.627V226.909H430.863V228.47Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 228.47H430.272V226.909H429.509V228.47Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 228.47H428.92V226.909H428.156V228.47Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 228.47H427.563V226.909H426.8V228.47Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 228.47H426.21V226.909H425.446V228.47Z",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 231.008H431.627V229.447H430.863V231.008Z",
    fill: "#EBEBEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 231.008H430.272V229.447H429.509V231.008Z",
    fill: "#EBEBEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 231.008H428.92V229.447H428.156V231.008Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 231.008H427.563V229.447H426.8V231.008Z",
    fill: "#EBEBEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 231.008H426.21V229.447H425.446V231.008Z",
    fill: "#EBEBEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 233.548H431.627V231.987H430.863V233.548Z",
    fill: "#EBEBEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 233.548H430.272V231.987H429.509V233.548Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 233.548H428.92V231.987H428.156V233.548Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 233.548H427.563V231.987H426.8V233.548Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 233.548H426.21V231.987H425.446V233.548Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 236.083H431.627V234.522H430.863V236.083Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 236.083H430.272V234.522H429.509V236.083Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 236.083H428.92V234.522H428.156V236.083Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 236.083H427.563V234.522H426.8V236.083Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 236.083H426.21V234.522H425.446V236.083Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 238.62H431.627V237.059H430.863V238.62Z",
    fill: "#EBEBEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 238.62H430.272V237.059H429.509V238.62Z",
    fill: "#EBEBEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 238.62H428.92V237.059H428.156V238.62Z",
    fill: "#EBEBEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 238.62H427.563V237.059H426.8V238.62Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 238.62H426.21V237.059H425.446V238.62Z",
    fill: "#EBEBEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 241.155H431.627V239.594H430.863V241.155Z",
    fill: "#EBEBEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 241.155H430.272V239.594H429.509V241.155Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 241.155H428.92V239.594H428.156V241.155Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 241.155H427.563V239.594H426.8V241.155Z",
    fill: "#EBEBEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 241.155H426.21V239.594H425.446V241.155Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 243.693H431.627V242.132H430.863V243.693Z",
    fill: "#EBEBEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 243.693H430.272V242.132H429.509V243.693Z",
    fill: "#EBEBEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 243.693H428.92V242.132H428.156V243.693Z",
    fill: "#EBEBEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 243.693H427.563V242.132H426.8V243.693Z",
    fill: "#EBEBEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 243.693H426.21V242.132H425.446V243.693Z",
    fill: "#EBEBEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M430.863 246.233H431.627V244.672H430.863V246.233Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M429.509 246.233H430.272V244.672H429.509V246.233Z",
    fill: "#EBEBEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M428.156 246.233H428.92V244.672H428.156V246.233Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8 246.233H427.563V244.672H426.8V246.233Z",
    fill: "#EBEBEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M425.446 246.233H426.21V244.672H425.446V246.233Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M431.626 247.207H430.862V251.774H431.626V247.207Z",
    fill: "#EBEBEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M430.273 247.207H429.509V251.774H430.273V247.207Z",
    fill: "#EBEBEB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M428.918 247.207H428.154V251.774H428.918V247.207Z",
    fill: "#EBEBEB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M427.565 247.207H426.801V251.774H427.565V247.207Z",
    fill: "#EBEBEB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M426.207 247.207H425.443V251.774H426.207V247.207Z",
    fill: "#EBEBEB"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M424.762 212.059H419.915V251.771H424.762V212.059Z",
    fill: "#DBDBDB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M419.705 212.062H424.761V211.27H419.705V212.062Z",
    fill: "#C7C7C7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M424.08 213.224H423.316V251.771H424.08V213.224Z",
    fill: "#C7C7C7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M422.724 213.224H421.96V251.771H422.724V213.224Z",
    fill: "#C7C7C7"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M421.37 213.224H420.606V251.771H421.37V213.224Z",
    fill: "#C7C7C7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 215.787H424.079V214.226H423.315V215.787Z",
    fill: "#DBDBDB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 215.787H422.723V214.226H421.959V215.787Z",
    fill: "#DBDBDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 215.787H421.371V214.226H420.607V215.787Z",
    fill: "#DBDBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 218.324H424.079V216.763H423.315V218.324Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 218.324H422.723V216.763H421.959V218.324Z",
    fill: "#DBDBDB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 218.324H421.371V216.763H420.607V218.324Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 220.859H424.079V219.298H423.315V220.859Z",
    fill: "#DBDBDB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 220.859H422.723V219.298H421.959V220.859Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 220.859H421.371V219.298H420.607V220.859Z",
    fill: "#DBDBDB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 223.396H424.079V221.835H423.315V223.396Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 223.396H422.723V221.835H421.959V223.396Z",
    fill: "#DBDBDB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 223.396H421.371V221.835H420.607V223.396Z",
    fill: "#DBDBDB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 225.936H424.079V224.374H423.315V225.936Z",
    fill: "#DBDBDB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 225.936H422.723V224.374H421.959V225.936Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 225.936H421.371V224.374H420.607V225.936Z",
    fill: "#DBDBDB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 228.47H424.079V226.909H423.315V228.47Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 228.47H422.723V226.909H421.959V228.47Z",
    fill: "#DBDBDB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 228.47H421.371V226.909H420.607V228.47Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 231.008H424.079V229.447H423.315V231.008Z",
    fill: "#DBDBDB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 231.008H422.723V229.447H421.959V231.008Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 231.008H421.371V229.447H420.607V231.008Z",
    fill: "#DBDBDB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 233.548H424.079V231.987H423.315V233.548Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 233.548H422.723V231.987H421.959V233.548Z",
    fill: "#DBDBDB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 233.548H421.371V231.987H420.607V233.548Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 236.083H424.079V234.522H423.315V236.083Z",
    fill: "#DBDBDB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 236.083H422.723V234.522H421.959V236.083Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 236.083H421.371V234.522H420.607V236.083Z",
    fill: "#DBDBDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 238.62H424.079V237.059H423.315V238.62Z",
    fill: "#DBDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 238.62H422.723V237.059H421.959V238.62Z",
    fill: "#DBDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 238.62H421.371V237.059H420.607V238.62Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 241.155H424.079V239.594H423.315V241.155Z",
    fill: "#DBDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 241.155H422.723V239.594H421.959V241.155Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 241.155H421.371V239.594H420.607V241.155Z",
    fill: "#DBDBDB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 243.693H424.079V242.132H423.315V243.693Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 243.693H422.723V242.132H421.959V243.693Z",
    fill: "#DBDBDB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 243.693H421.371V242.132H420.607V243.693Z",
    fill: "#DBDBDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M423.315 246.233H424.079V244.672H423.315V246.233Z",
    fill: "#DBDBDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M421.959 246.233H422.723V244.672H421.959V246.233Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M420.607 246.233H421.371V244.672H420.607V246.233Z",
    fill: "#DBDBDB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M424.08 247.207H423.316V251.774H424.08V247.207Z",
    fill: "#DBDBDB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M422.724 247.207H421.96V251.774H422.724V247.207Z",
    fill: "#DBDBDB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M421.37 247.207H420.606V251.774H421.37V247.207Z",
    fill: "#DBDBDB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M308.971 229.051H312.795V224.424H308.971V229.051Z",
    fill: "#DBDBDB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M306.543 229.221H308.968V224.423H306.543V229.221Z",
    fill: "#C7C7C7"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M306.385 229.221H308.79V226.466H306.385V229.221Z",
    fill: "#DBDBDB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M304.883 229.221H306.383V226.466H304.883V229.221Z",
    fill: "#C7C7C7"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M308.077 251.774H314.26V228.752H308.077V251.774Z",
    fill: "#EBEBEB"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 230.555H313.553V229.742H311.609V230.555Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 230.555H311.067V229.742H309.124V230.555Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 231.937H313.553V231.124H311.609V231.937Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 231.937H311.067V231.124H309.124V231.937Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 233.318H313.553V232.505H311.609V233.318Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 233.318H311.067V232.505H309.124V233.318Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 234.699H313.553V233.886H311.609V234.699Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 234.699H311.067V233.886H309.124V234.699Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 236.081H313.553V235.268H311.609V236.081Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 236.081H311.067V235.268H309.124V236.081Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 237.462H313.553V236.649H311.609V237.462Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 237.462H311.067V236.649H309.124V237.462Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 238.844H313.553V238.031H311.609V238.844Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 238.844H311.067V238.031H309.124V238.844Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 240.228H313.553V239.415H311.609V240.228Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 240.228H311.067V239.415H309.124V240.228Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 241.611H313.553V240.798H311.609V241.611Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 241.611H311.067V240.798H309.124V241.611Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 242.992H313.553V242.179H311.609V242.992Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 242.992H311.067V242.179H309.124V242.992Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 244.373H313.553V243.56H311.609V244.373Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 244.373H311.067V243.56H309.124V244.373Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 245.754H313.553V244.941H311.609V245.754Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 245.754H311.067V244.941H309.124V245.754Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 247.137H313.553V246.324H311.609V247.137Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 247.137H311.067V246.324H309.124V247.137Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M311.609 248.517H313.553V247.704H311.609V248.517Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M309.124 248.517H311.067V247.704H309.124V248.517Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M303.068 251.774H308.077V228.752H303.068V251.774Z",
    fill: "#C7C7C7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 247.705H303.569V248.518H305.165V247.705Z",
    fill: "#EBEBEB"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 247.705H305.613V248.518H307.209V247.705Z",
    fill: "#EBEBEB"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 246.324H303.569V247.137H305.165V246.324Z",
    fill: "#EBEBEB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 246.324H305.613V247.137H307.209V246.324Z",
    fill: "#EBEBEB"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 244.941H303.569V245.754H305.165V244.941Z",
    fill: "#EBEBEB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 244.941H305.613V245.754H307.209V244.941Z",
    fill: "#EBEBEB"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 243.562H303.569V244.375H305.165V243.562Z",
    fill: "#EBEBEB"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 243.562H305.613V244.375H307.209V243.562Z",
    fill: "#EBEBEB"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 242.175H303.569V242.988H305.165V242.175Z",
    fill: "#EBEBEB"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 242.175H305.613V242.988H307.209V242.175Z",
    fill: "#EBEBEB"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 240.795H303.569V241.608H305.165V240.795Z",
    fill: "#EBEBEB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 240.795H305.613V241.608H307.209V240.795Z",
    fill: "#EBEBEB"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 239.412H303.569V240.225H305.165V239.412Z",
    fill: "#EBEBEB"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 239.412H305.613V240.225H307.209V239.412Z",
    fill: "#EBEBEB"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 238.032H303.569V238.845H305.165V238.032Z",
    fill: "#EBEBEB"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 238.032H305.613V238.845H307.209V238.032Z",
    fill: "#EBEBEB"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 236.65H303.569V237.463H305.165V236.65Z",
    fill: "#EBEBEB"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 236.65H305.613V237.463H307.209V236.65Z",
    fill: "#EBEBEB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 235.27H303.569V236.083H305.165V235.27Z",
    fill: "#EBEBEB"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 235.27H305.613V236.083H307.209V235.27Z",
    fill: "#EBEBEB"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 233.888H303.569V234.701H305.165V233.888Z",
    fill: "#EBEBEB"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 233.888H305.613V234.701H307.209V233.888Z",
    fill: "#EBEBEB"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 232.503H303.569V233.316H305.165V232.503Z",
    fill: "#EBEBEB"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 232.503H305.613V233.316H307.209V232.503Z",
    fill: "#EBEBEB"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 231.12H303.569V231.933H305.165V231.12Z",
    fill: "#EBEBEB"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 231.12H305.613V231.933H307.209V231.12Z",
    fill: "#EBEBEB"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M305.165 229.739H303.569V230.552H305.165V229.739Z",
    fill: "#EBEBEB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M307.209 229.739H305.613V230.552H307.209V229.739Z",
    fill: "#EBEBEB"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M417.305 229.051H421.129V224.424H417.305V229.051Z",
    fill: "#DBDBDB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M414.882 229.221H417.307V224.423H414.882V229.221Z",
    fill: "#C7C7C7"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M414.72 229.221H417.125V226.466H414.72V229.221Z",
    fill: "#DBDBDB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M413.218 229.221H414.718V226.466H413.218V229.221Z",
    fill: "#C7C7C7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M416.416 251.774H422.599V228.752H416.416V251.774Z",
    fill: "#EBEBEB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 230.555H421.888V229.742H419.944V230.555Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 230.555H419.401V229.742H417.458V230.555Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 231.937H421.888V231.124H419.944V231.937Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 231.937H419.401V231.124H417.458V231.937Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 233.318H421.888V232.505H419.944V233.318Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 233.318H419.401V232.505H417.458V233.318Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 234.699H421.888V233.886H419.944V234.699Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 234.699H419.401V233.886H417.458V234.699Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 236.081H421.888V235.268H419.944V236.081Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 236.081H419.401V235.268H417.458V236.081Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 237.462H421.888V236.649H419.944V237.462Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 237.462H419.401V236.649H417.458V237.462Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 238.844H421.888V238.031H419.944V238.844Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 238.844H419.401V238.031H417.458V238.844Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 240.228H421.888V239.415H419.944V240.228Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 240.228H419.401V239.415H417.458V240.228Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 241.611H421.888V240.798H419.944V241.611Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 241.611H419.401V240.798H417.458V241.611Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 242.992H421.888V242.179H419.944V242.992Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 242.992H419.401V242.179H417.458V242.992Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 244.373H421.888V243.56H419.944V244.373Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 244.373H419.401V243.56H417.458V244.373Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 245.754H421.888V244.941H419.944V245.754Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 245.754H419.401V244.941H417.458V245.754Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 247.137H421.888V246.324H419.944V247.137Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 247.137H419.401V246.324H417.458V247.137Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M419.944 248.517H421.888V247.704H419.944V248.517Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M417.458 248.517H419.401V247.704H417.458V248.517Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M411.407 251.774H416.416V228.752H411.407V251.774Z",
    fill: "#C7C7C7"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 247.705H411.905V248.518H413.501V247.705Z",
    fill: "#EBEBEB"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 247.705H413.947V248.518H415.542V247.705Z",
    fill: "#EBEBEB"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 246.324H411.905V247.137H413.501V246.324Z",
    fill: "#EBEBEB"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 246.324H413.947V247.137H415.542V246.324Z",
    fill: "#EBEBEB"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 244.941H411.905V245.754H413.501V244.941Z",
    fill: "#EBEBEB"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 244.941H413.947V245.754H415.542V244.941Z",
    fill: "#EBEBEB"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 243.562H411.905V244.375H413.501V243.562Z",
    fill: "#EBEBEB"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 243.562H413.947V244.375H415.542V243.562Z",
    fill: "#EBEBEB"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 242.175H411.905V242.988H413.501V242.175Z",
    fill: "#EBEBEB"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 242.175H413.947V242.988H415.542V242.175Z",
    fill: "#EBEBEB"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 240.795H411.905V241.608H413.501V240.795Z",
    fill: "#EBEBEB"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 240.795H413.947V241.608H415.542V240.795Z",
    fill: "#EBEBEB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 239.412H411.905V240.225H413.501V239.412Z",
    fill: "#EBEBEB"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 239.412H413.947V240.225H415.542V239.412Z",
    fill: "#EBEBEB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 238.032H411.905V238.845H413.501V238.032Z",
    fill: "#EBEBEB"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 238.032H413.947V238.845H415.542V238.032Z",
    fill: "#EBEBEB"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 236.65H411.905V237.463H413.501V236.65Z",
    fill: "#EBEBEB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 236.65H413.947V237.463H415.542V236.65Z",
    fill: "#EBEBEB"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 235.27H411.905V236.083H413.501V235.27Z",
    fill: "#EBEBEB"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 235.27H413.947V236.083H415.542V235.27Z",
    fill: "#EBEBEB"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 233.888H411.905V234.701H413.501V233.888Z",
    fill: "#EBEBEB"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 233.888H413.947V234.701H415.542V233.888Z",
    fill: "#EBEBEB"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 232.503H411.905V233.316H413.501V232.503Z",
    fill: "#EBEBEB"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 232.503H413.947V233.316H415.542V232.503Z",
    fill: "#EBEBEB"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 231.12H411.905V231.933H413.501V231.12Z",
    fill: "#EBEBEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 231.12H413.947V231.933H415.542V231.12Z",
    fill: "#EBEBEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M413.501 229.739H411.905V230.552H413.501V229.739Z",
    fill: "#EBEBEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M415.542 229.739H413.947V230.552H415.542V229.739Z",
    fill: "#EBEBEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M423.838 251.774H431.131V236.773H423.838V251.774Z",
    fill: "#C7C7C7"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 238.988H429.984V238.069H428.693V238.988Z",
    fill: "#DBDBDB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 240.951H429.984V240.032H428.693V240.951Z",
    fill: "#DBDBDB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 242.914H429.984V241.995H428.693V242.914Z",
    fill: "#DBDBDB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 244.877H429.984V243.958H428.693V244.877Z",
    fill: "#DBDBDB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 246.841H429.984V245.922H428.693V246.841Z",
    fill: "#DBDBDB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 248.804H429.984V247.885H428.693V248.804Z",
    fill: "#DBDBDB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 250.768H429.984V249.849H428.693V250.768Z",
    fill: "#DBDBDB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 238.988H428.128V238.069H426.837V238.988Z",
    fill: "#DBDBDB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 240.951H428.128V240.032H426.837V240.951Z",
    fill: "#DBDBDB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 242.914H428.128V241.995H426.837V242.914Z",
    fill: "#DBDBDB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 244.877H428.128V243.958H426.837V244.877Z",
    fill: "#DBDBDB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 246.841H428.128V245.922H426.837V246.841Z",
    fill: "#DBDBDB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 248.804H428.128V247.885H426.837V248.804Z",
    fill: "#DBDBDB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M426.837 250.768H428.128V249.849H426.837V250.768Z",
    fill: "#DBDBDB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 238.988H426.277V238.069H424.986V238.988Z",
    fill: "#DBDBDB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 240.951H426.277V240.032H424.986V240.951Z",
    fill: "#DBDBDB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 242.914H426.277V241.995H424.986V242.914Z",
    fill: "#DBDBDB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 244.877H426.277V243.958H424.986V244.877Z",
    fill: "#DBDBDB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 246.841H426.277V245.922H424.986V246.841Z",
    fill: "#DBDBDB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 248.804H426.277V247.885H424.986V248.804Z",
    fill: "#DBDBDB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M424.986 250.768H426.277V249.849H424.986V250.768Z",
    fill: "#DBDBDB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M423.835 236.771H428.69V235.207H423.835V236.771Z",
    fill: "#DBDBDB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M423.835 235.207H426.914V234.238H423.835V235.207Z",
    fill: "#EBEBEB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M418.723 251.774H423.84V236.773H418.723V251.774Z",
    fill: "#A6A6A6"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 249.703H419.244V250.622H420.295V249.703Z",
    fill: "#C7C7C7"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 247.74H419.244V248.659H420.295V247.74Z",
    fill: "#C7C7C7"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 245.777H419.244V246.696H420.295V245.777Z",
    fill: "#C7C7C7"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 243.813H419.244V244.732H420.295V243.813Z",
    fill: "#C7C7C7"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 241.851H419.244V242.77H420.295V241.851Z",
    fill: "#C7C7C7"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 239.887H419.244V240.806H420.295V239.887Z",
    fill: "#C7C7C7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M420.295 237.923H419.244V238.842H420.295V237.923Z",
    fill: "#C7C7C7"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 249.703H420.757V250.622H421.808V249.703Z",
    fill: "#C7C7C7"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 247.74H420.757V248.659H421.808V247.74Z",
    fill: "#C7C7C7"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 245.777H420.757V246.696H421.808V245.777Z",
    fill: "#C7C7C7"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 243.813H420.757V244.732H421.808V243.813Z",
    fill: "#C7C7C7"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 241.851H420.757V242.77H421.808V241.851Z",
    fill: "#C7C7C7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 239.887H420.757V240.806H421.808V239.887Z",
    fill: "#C7C7C7"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M421.808 237.923H420.757V238.842H421.808V237.923Z",
    fill: "#C7C7C7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 249.703H422.264V250.622H423.314V249.703Z",
    fill: "#C7C7C7"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 247.74H422.264V248.659H423.314V247.74Z",
    fill: "#C7C7C7"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 245.777H422.264V246.696H423.314V245.777Z",
    fill: "#C7C7C7"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 243.813H422.264V244.732H423.314V243.813Z",
    fill: "#C7C7C7"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 241.851H422.264V242.77H423.314V241.851Z",
    fill: "#C7C7C7"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 239.887H422.264V240.806H423.314V239.887Z",
    fill: "#C7C7C7"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 237.923H422.264V238.842H423.314V237.923Z",
    fill: "#C7C7C7"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M419.496 236.771H423.837V235.207H419.496V236.771Z",
    fill: "#C7C7C7"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M421.487 235.207H423.84V234.238H421.487V235.207Z",
    fill: "#DBDBDB"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M421.001 194.822H311.873V202.2H421.001V194.822Z",
    fill: "#FFC727"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M421.001 194.822H311.873V202.2H421.001V194.822Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M421.001 194.822H311.873V196.915L421.001 196.141V194.822Z",
    fill: "#FFC727"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M422.182 193.265H310.693V194.824H422.182V193.265Z",
    fill: "#FFC727"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M331.18 190.974H321.216V193.263H331.18V190.974Z",
    fill: "#C7C7C7"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M324.131 189.621H322.722V190.972H324.131V189.621Z",
    fill: "#C7C7C7"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M329.672 189.621H328.263V190.972H329.672V189.621Z",
    fill: "#C7C7C7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M416.453 190.974H406.489V193.263H416.453V190.974Z",
    fill: "#C7C7C7"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M409.404 189.621H407.994V190.972H409.404V189.621Z",
    fill: "#C7C7C7"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M414.946 189.621H413.536V190.972H414.946V189.621Z",
    fill: "#C7C7C7"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M404.098 190.974H394.134V193.263H404.098V190.974Z",
    fill: "#C7C7C7"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M397.052 189.621H395.643V190.972H397.052V189.621Z",
    fill: "#C7C7C7"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M402.59 189.621H401.181V190.972H402.59V189.621Z",
    fill: "#C7C7C7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M428.031 203.759H304.848V251.768H428.031V203.759Z",
    fill: "#FFC727"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M428.031 203.759H304.848V251.768H428.031V203.759Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.031 244.931H304.848V251.767H428.031V244.931Z",
    fill: "#FFC727"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M429.208 202.201H303.664V203.76H429.208V202.201Z",
    fill: "#FFC727"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.031 203.759H304.848V205.852L428.031 205.078V203.759Z",
    fill: "#FFC727"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M312.492 208.277H307.086V216.388H312.492V208.277Z",
    fill: "#37474F"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M318.298 208.277H312.892V216.388H318.298V208.277Z",
    fill: "#37474F"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M324.109 208.277H318.703V216.388H324.109V208.277Z",
    fill: "#37474F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M331.478 208.277H326.072V216.388H331.478V208.277Z",
    fill: "#37474F"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M337.289 208.277H331.883V216.388H337.289V208.277Z",
    fill: "#37474F"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M343.098 208.277H337.692V216.388H343.098V208.277Z",
    fill: "#37474F"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M312.492 219.229H307.086V227.34H312.492V219.229Z",
    fill: "#37474F"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M318.298 219.229H312.892V227.34H318.298V219.229Z",
    fill: "#37474F"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M324.109 219.229H318.703V227.34H324.109V219.229Z",
    fill: "#37474F"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M331.478 219.229H326.072V227.34H331.478V219.229Z",
    fill: "#37474F"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M337.289 219.229H331.883V227.34H337.289V219.229Z",
    fill: "#37474F"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M343.098 219.229H337.692V227.34H343.098V219.229Z",
    fill: "#37474F"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M312.492 230.184H307.086V238.294H312.492V230.184Z",
    fill: "#37474F"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M318.298 230.184H312.892V238.294H318.298V230.184Z",
    fill: "#37474F"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M324.109 230.184H318.703V238.294H324.109V230.184Z",
    fill: "#37474F"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M331.478 230.184H326.072V238.294H331.478V230.184Z",
    fill: "#37474F"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M337.289 230.184H331.883V238.294H337.289V230.184Z",
    fill: "#37474F"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M343.098 230.184H337.692V238.294H343.098V230.184Z",
    fill: "#37474F"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M395.183 208.277H389.777V216.388H395.183V208.277Z",
    fill: "#37474F"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M400.994 208.277H395.588V216.388H400.994V208.277Z",
    fill: "#37474F"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M406.802 208.277H401.396V216.388H406.802V208.277Z",
    fill: "#37474F"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M414.173 208.277H408.767V216.388H414.173V208.277Z",
    fill: "#37474F"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M419.981 208.277H414.575V216.388H419.981V208.277Z",
    fill: "#37474F"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M425.79 208.277H420.384V216.388H425.79V208.277Z",
    fill: "#37474F"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M395.183 219.229H389.777V227.34H395.183V219.229Z",
    fill: "#37474F"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M400.994 219.229H395.588V227.34H400.994V219.229Z",
    fill: "#37474F"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M406.802 219.229H401.396V227.34H406.802V219.229Z",
    fill: "#37474F"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M414.173 219.229H408.767V227.34H414.173V219.229Z",
    fill: "#37474F"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M419.981 219.229H414.575V227.34H419.981V219.229Z",
    fill: "#37474F"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M425.79 219.229H420.384V227.34H425.79V219.229Z",
    fill: "#37474F"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M395.183 230.184H389.777V238.294H395.183V230.184Z",
    fill: "#37474F"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M400.994 230.184H395.588V238.294H400.994V230.184Z",
    fill: "#37474F"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M406.802 230.184H401.396V238.294H406.802V230.184Z",
    fill: "#37474F"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M414.173 230.184H408.767V238.294H414.173V230.184Z",
    fill: "#37474F"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M419.981 230.184H414.575V238.294H419.981V230.184Z",
    fill: "#37474F"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M425.79 230.184H420.384V238.294H425.79V230.184Z",
    fill: "#37474F"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M428.031 217.329H304.848V218.265H428.031V217.329Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M428.031 228.279H304.848V229.216H428.031V228.279Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M428.031 239.233H304.848V240.17H428.031V239.233Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.031 218.265H304.848V218.939L428.031 218.602V218.265Z",
    fill: "#FFC727"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.031 229.215H304.848V229.889L428.031 229.552V229.215Z",
    fill: "#FFC727"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.031 240.17H304.848V240.842L428.031 240.507V240.17Z",
    fill: "#FFC727"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.086 215.086L312.492 209.547V212.003L308.213 216.388H307.086V215.086ZM313.731 208.277L312.887 209.142V211.598L316.121 208.286L313.731 208.277ZM328.208 238.293H330.607L337.29 231.445V230.182H336.123L328.208 238.293ZM337.703 231.032L338.533 230.182H337.703V231.032ZM338.908 227.339H341.307L343.109 225.493V223.034L338.908 227.339ZM391.625 208.277L389.789 210.158V212.615L394.024 208.277H391.625ZM395.195 238.293V237.689L394.606 238.293H395.195ZM395.598 238.293H397.005L401.015 234.195V231.737L395.609 237.277L395.598 238.293ZM402.521 230.182L401.407 231.324V233.782L404.92 230.182H402.521ZM406.813 227.339V225.785L405.296 227.339H406.813ZM408.767 223.782V226.241L414.173 220.701V219.242H413.198L408.767 223.782ZM414.576 220.288L415.604 219.242H414.583L414.576 220.288ZM418.374 216.396L419.984 214.747V212.28L415.975 216.388L418.374 216.396ZM423.89 208.286L420.387 211.875V214.334L425.793 208.794V208.286H423.89ZM423.154 238.301H425.553L425.793 238.055V235.588L423.154 238.301ZM307.099 219.728V220.959L308.787 219.24H307.567L307.099 219.728ZM311.551 216.396L312.505 215.419V214.189L310.338 216.388L311.551 216.396ZM318.265 208.286L312.908 213.776V215.006L318.314 209.467V208.286H318.265ZM318.717 208.286V209.054L319.466 208.286H318.717ZM389.791 222.442V223.672L394.117 219.24H392.916L389.791 222.442ZM396.892 216.388L401.006 212.171V210.941L395.678 216.388H396.892ZM403.606 208.277L401.397 210.528V211.758L404.796 208.277H403.606ZM416.218 238.293L419.995 234.422V233.192L415.017 238.293H416.218ZM422.932 230.182L420.4 232.777V234.007L424.135 230.18L422.932 230.182ZM425.707 227.339H425.804V227.242L425.707 227.339ZM400.994 238.293V237.136L399.865 238.293H400.994ZM401.397 237.953L406.803 232.414V231.183L401.397 236.723V237.953ZM408.767 230.401L408.978 230.185H408.767V230.401ZM411.755 227.339L414.173 224.863V223.631L410.554 227.339H411.755ZM418.467 219.242L414.576 223.229V224.459L419.668 219.242H418.467ZM421.242 216.398H422.443L425.791 212.967V211.737L421.242 216.398ZM307.086 223.134V223.415L311.154 219.242H310.88L307.086 223.134ZM321.576 208.286L313.661 216.388H313.935L318.301 211.914L318.704 211.501L321.85 208.277L321.576 208.286ZM332.937 238.301L337.29 233.841V233.56L332.662 238.301H332.937ZM340.577 230.191L337.693 233.147V233.428L340.858 230.185L340.577 230.191ZM319.08 238.293L324.11 233.138V232.864L318.805 238.299L319.08 238.293ZM326.72 230.182L326.075 230.844V231.134L326.995 230.191L326.72 230.182ZM329.769 227.339L331.481 225.586V225.296L329.495 227.33L329.769 227.339ZM331.88 224.892V225.173L337.286 219.633V219.352L331.88 224.892ZM340.179 216.388H340.453L343.095 213.681V213.404L340.179 216.388ZM308.949 238.293L312.492 234.662V233.432L307.749 238.293H308.949ZM315.663 230.182L312.895 233.019V234.249L316.864 230.182H315.663ZM318.704 227.339H319.639L324.11 222.757V221.527L318.704 227.067V227.339ZM326.347 219.242L326.07 219.525V220.755L327.548 219.242H326.347ZM330.322 216.398L331.477 215.216V213.985L329.126 216.388L330.322 216.398ZM337.037 208.288L331.88 213.573V214.803L337.286 209.265V208.288H337.037ZM337.689 208.288V208.852L338.239 208.288H337.689ZM334.64 238.293L337.29 235.577V234.347L333.439 238.293H334.64ZM341.354 230.182L337.693 233.945V235.175L342.546 230.202L341.354 230.182ZM341.381 238.293H341.656L343.099 236.814V236.539L341.381 238.293ZM392.884 238.293L395.184 235.936V235.655L392.604 238.293H392.884ZM400.525 230.182L395.587 235.242V235.523L400.799 230.182H400.525ZM403.576 227.339L406.805 224.031V223.75L403.302 227.339H403.576ZM411.215 219.231L408.767 221.737V222.018L411.487 219.242L411.215 219.231ZM414.169 216.388V216.197L413.983 216.388H414.169ZM414.572 216.066L419.978 210.528V210.247L414.576 215.782L414.572 216.066ZM421.9 208.282L420.381 209.838V210.12L422.175 208.282H421.9ZM414.576 233.975L414.173 234.388L410.362 238.293H410.637L414.173 234.669L414.576 234.256L418.558 230.182H418.284L414.576 233.975ZM421.052 227.339H421.326L425.791 222.764V222.485L421.052 227.339ZM421.751 238.293H422.025L425.791 234.433V234.161L421.751 238.293Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.465 251.774H345.204V194.822H343.657L344.465 251.774Z",
    fill: "#FFC727"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.411 251.774H387.673V194.822H389.22L388.411 251.774Z",
    fill: "#FFC727"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M381.245 171.656H351.626V177.719H381.245V171.656Z",
    fill: "#FFC727"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M381.245 171.656H351.626V177.719H381.245V171.656Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M381.247 171.656H351.626V173.749L381.247 172.975V171.656Z",
    fill: "#FFC727"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M382.428 170.101H350.447V171.66H382.428V170.101Z",
    fill: "#FFC727"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M387.672 183.092H345.2V251.767H387.672V183.092Z",
    fill: "#FFC727"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M387.672 183.092H345.2V251.767H387.672V183.092Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M349.127 179.023H345.2V251.768H349.127V179.023Z",
    fill: "#FFC727"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M349.127 179.023H345.2V251.768H349.127V179.023Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M387.675 179.023H383.748V251.768H387.675V179.023Z",
    fill: "#FFC727"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M387.675 179.023H383.748V251.768H387.675V179.023Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M383.743 176.506H349.127V183.09H383.743V176.506Z",
    fill: "#FFC727"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M353.036 181.619V178.094C353.036 178.051 353.044 178.008 353.059 177.968C353.075 177.928 353.099 177.891 353.129 177.861C353.159 177.83 353.194 177.806 353.233 177.79C353.273 177.773 353.315 177.765 353.357 177.766C353.4 177.765 353.442 177.773 353.482 177.789C353.521 177.805 353.557 177.829 353.588 177.86C353.618 177.89 353.642 177.927 353.659 177.967C353.675 178.007 353.684 178.051 353.684 178.094V179.528H355.193V178.094C355.192 178.051 355.2 178.008 355.216 177.968C355.232 177.928 355.255 177.891 355.285 177.861C355.315 177.83 355.351 177.806 355.39 177.79C355.429 177.773 355.471 177.765 355.513 177.766C355.556 177.765 355.598 177.773 355.638 177.789C355.678 177.805 355.714 177.829 355.744 177.86C355.775 177.89 355.799 177.927 355.815 177.967C355.832 178.007 355.84 178.051 355.84 178.094V181.619C355.84 181.662 355.832 181.705 355.815 181.746C355.798 181.786 355.774 181.822 355.744 181.853C355.713 181.883 355.677 181.907 355.638 181.924C355.598 181.94 355.556 181.948 355.513 181.947C355.471 181.948 355.429 181.939 355.39 181.923C355.351 181.906 355.316 181.882 355.286 181.852C355.256 181.821 355.233 181.785 355.217 181.745C355.201 181.705 355.192 181.662 355.193 181.619V180.185H353.684V181.619C353.684 181.662 353.675 181.705 353.658 181.746C353.642 181.786 353.618 181.822 353.587 181.853C353.557 181.883 353.521 181.907 353.481 181.924C353.442 181.94 353.399 181.948 353.357 181.947C353.315 181.948 353.273 181.939 353.234 181.923C353.195 181.906 353.159 181.882 353.129 181.852C353.1 181.821 353.076 181.785 353.06 181.745C353.044 181.705 353.036 181.662 353.036 181.619Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M360.212 178.287C360.591 178.695 360.802 179.237 360.802 179.801C360.802 180.364 360.591 180.906 360.212 181.314C360.036 181.516 359.822 181.677 359.582 181.789C359.342 181.9 359.082 181.96 358.819 181.963C358.55 181.961 358.285 181.902 358.039 181.791C357.793 181.679 357.572 181.517 357.39 181.314C357.018 180.903 356.811 180.362 356.811 179.801C356.811 179.239 357.018 178.699 357.39 178.287C357.572 178.084 357.792 177.921 358.038 177.809C358.284 177.698 358.55 177.64 358.819 177.639C359.082 177.642 359.342 177.701 359.582 177.813C359.822 177.925 360.036 178.086 360.212 178.287ZM360.136 179.801C360.135 179.414 359.994 179.042 359.739 178.757C359.623 178.623 359.481 178.516 359.323 178.442C359.165 178.368 358.993 178.327 358.819 178.324C358.64 178.324 358.464 178.362 358.301 178.437C358.138 178.511 357.993 178.62 357.874 178.757C357.616 179.04 357.474 179.414 357.477 179.801C357.473 180.187 357.615 180.56 357.874 180.841C357.99 180.976 358.134 181.085 358.295 181.159C358.456 181.233 358.63 181.272 358.806 181.272C358.983 181.272 359.157 181.233 359.318 181.159C359.479 181.085 359.622 180.976 359.739 180.841C359.995 180.557 360.137 180.185 360.136 179.799V179.801Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M361.796 180.91C361.847 180.848 361.92 180.809 361.999 180.801C362.078 180.793 362.157 180.818 362.218 180.869C362.532 181.141 362.922 181.302 363.332 181.327C363.591 181.334 363.845 181.259 364.06 181.111C364.133 181.065 364.195 181.002 364.238 180.927C364.282 180.851 364.307 180.766 364.312 180.679C364.312 180.611 364.294 180.545 364.259 180.488C364.214 180.416 364.155 180.354 364.084 180.309C363.837 180.166 363.566 180.071 363.286 180.028H363.273C363.014 179.983 362.762 179.904 362.522 179.794C362.301 179.697 362.113 179.535 361.98 179.33C361.89 179.183 361.843 179.014 361.845 178.841C361.852 178.67 361.898 178.502 361.979 178.352C362.06 178.202 362.173 178.073 362.311 177.976C362.607 177.766 362.96 177.655 363.32 177.66C363.779 177.686 364.22 177.852 364.586 178.138C364.619 178.161 364.648 178.19 364.671 178.224C364.693 178.258 364.709 178.296 364.716 178.337C364.724 178.377 364.724 178.418 364.715 178.459C364.707 178.499 364.691 178.537 364.668 178.571C364.647 178.606 364.619 178.637 364.586 178.661C364.553 178.685 364.516 178.701 364.476 178.71C364.436 178.718 364.395 178.718 364.356 178.709C364.316 178.7 364.279 178.683 364.246 178.659C363.978 178.437 363.651 178.304 363.307 178.279C363.075 178.274 362.847 178.345 362.655 178.48C362.591 178.52 362.537 178.575 362.499 178.641C362.46 178.707 362.438 178.781 362.434 178.858C362.43 178.917 362.444 178.975 362.474 179.025C362.516 179.086 362.57 179.139 362.632 179.18C362.856 179.315 363.103 179.404 363.36 179.442H363.373C363.649 179.493 363.919 179.577 364.176 179.693C364.412 179.798 364.614 179.97 364.759 180.188C364.849 180.341 364.898 180.517 364.898 180.696C364.893 180.88 364.845 181.06 364.758 181.221C364.671 181.382 364.547 181.519 364.398 181.621C364.083 181.85 363.705 181.969 363.32 181.963C362.772 181.936 362.248 181.727 361.828 181.366C361.796 181.339 361.77 181.305 361.751 181.267C361.732 181.229 361.721 181.188 361.718 181.145C361.715 181.103 361.72 181.06 361.734 181.019C361.747 180.979 361.768 180.942 361.796 180.91Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M367.171 180.321H366.453V181.619C366.453 181.706 366.419 181.791 366.359 181.853C366.298 181.915 366.216 181.949 366.13 181.949C366.045 181.949 365.963 181.915 365.902 181.853C365.842 181.791 365.808 181.706 365.808 181.619V178.094C365.807 178.051 365.815 178.008 365.831 177.968C365.847 177.928 365.871 177.892 365.901 177.861C365.931 177.831 365.966 177.806 366.005 177.79C366.044 177.774 366.086 177.765 366.128 177.766H367.171C367.501 177.766 367.819 177.9 368.053 178.14C368.286 178.38 368.418 178.705 368.418 179.043C368.418 179.382 368.286 179.707 368.053 179.947C367.819 180.187 367.501 180.321 367.171 180.321ZM366.453 179.66H367.171C367.253 179.665 367.335 179.652 367.412 179.624C367.489 179.595 367.559 179.551 367.619 179.493C367.678 179.435 367.726 179.366 367.758 179.289C367.791 179.212 367.808 179.129 367.808 179.045C367.808 178.961 367.791 178.877 367.758 178.8C367.726 178.723 367.678 178.654 367.619 178.596C367.559 178.539 367.489 178.494 367.412 178.465C367.335 178.437 367.253 178.424 367.171 178.429H366.453V179.66Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M369.248 178.097C369.248 178.054 369.255 178.011 369.271 177.971C369.287 177.931 369.311 177.894 369.341 177.864C369.371 177.833 369.406 177.809 369.445 177.792C369.485 177.776 369.527 177.768 369.569 177.769C369.655 177.768 369.737 177.802 369.798 177.864C369.86 177.925 369.895 178.009 369.896 178.097V181.619C369.894 181.707 369.859 181.791 369.798 181.852C369.737 181.914 369.654 181.948 369.569 181.948C369.527 181.948 369.485 181.94 369.446 181.924C369.407 181.907 369.371 181.883 369.341 181.852C369.312 181.822 369.288 181.786 369.272 181.746C369.256 181.706 369.248 181.663 369.248 181.619V178.097Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M373.479 178.432H372.557V181.619C372.544 181.696 372.506 181.766 372.448 181.817C372.39 181.867 372.316 181.895 372.24 181.895C372.164 181.895 372.09 181.867 372.032 181.817C371.974 181.766 371.936 181.696 371.924 181.619V178.432H371.001C370.916 178.431 370.834 178.395 370.774 178.332C370.714 178.269 370.681 178.185 370.681 178.097C370.68 178.054 370.688 178.011 370.704 177.971C370.72 177.931 370.743 177.894 370.773 177.864C370.803 177.833 370.839 177.809 370.878 177.792C370.917 177.776 370.959 177.768 371.001 177.769H373.491C373.534 177.768 373.575 177.777 373.614 177.793C373.653 177.809 373.689 177.834 373.719 177.864C373.749 177.895 373.772 177.931 373.788 177.971C373.804 178.011 373.812 178.054 373.812 178.097C373.812 178.142 373.803 178.186 373.786 178.227C373.769 178.268 373.744 178.305 373.713 178.336C373.682 178.367 373.646 178.392 373.605 178.408C373.565 178.425 373.522 178.433 373.479 178.432Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M376.288 180.971H374.879L374.594 181.747C374.57 181.81 374.529 181.865 374.475 181.903C374.42 181.942 374.356 181.963 374.29 181.963C374.253 181.964 374.215 181.957 374.18 181.944C374.099 181.912 374.033 181.849 373.997 181.768C373.961 181.687 373.958 181.595 373.988 181.511L375.275 177.996C375.299 177.932 375.341 177.876 375.396 177.838C375.451 177.799 375.517 177.779 375.583 177.779C375.651 177.778 375.717 177.797 375.773 177.836C375.828 177.875 375.871 177.931 375.894 177.996L377.181 181.511C377.211 181.595 377.208 181.687 377.172 181.768C377.136 181.849 377.07 181.912 376.989 181.944C376.954 181.957 376.917 181.964 376.879 181.963C376.814 181.964 376.75 181.943 376.696 181.904C376.643 181.865 376.603 181.81 376.582 181.747L376.288 180.971ZM376.05 180.322L375.577 179.025L375.107 180.309L376.05 180.322Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M377.973 181.619V178.094C377.972 178.051 377.98 178.008 377.997 177.968C378.013 177.928 378.036 177.892 378.066 177.861C378.096 177.831 378.131 177.806 378.17 177.79C378.209 177.774 378.251 177.765 378.293 177.766C378.379 177.766 378.461 177.8 378.522 177.862C378.583 177.923 378.617 178.007 378.618 178.094V181.283H380.199C380.28 181.29 380.356 181.328 380.411 181.39C380.467 181.451 380.498 181.532 380.498 181.615C380.498 181.699 380.467 181.78 380.411 181.841C380.356 181.903 380.28 181.941 380.199 181.947H378.3C378.257 181.948 378.214 181.941 378.175 181.925C378.135 181.909 378.099 181.885 378.068 181.854C378.038 181.823 378.013 181.787 377.997 181.746C377.981 181.706 377.972 181.662 377.973 181.619Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.008 251.767H383.747V183.092L382.204 185.343L383.008 251.767Z",
    fill: "#FFC727"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.865 251.767H349.127V183.092L350.669 185.343L349.865 251.767Z",
    fill: "#FFC727"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M383.743 195.228H349.127V196.164H383.743V195.228Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 196.164H349.127V196.839L383.745 196.501V196.164Z",
    fill: "#FFC727"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 208.742H349.127V209.417L383.745 209.079V208.742Z",
    fill: "#FFC727"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 221.318H349.127V221.993L383.745 221.656V221.318Z",
    fill: "#FFC727"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M383.743 207.806H349.127V208.742H383.743V207.806Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M357.969 185.352H352.562V193.462H357.969V185.352Z",
    fill: "#37474F"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M365.418 185.352H360.012V193.462H365.418V185.352Z",
    fill: "#37474F"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 185.352H367.459V193.462H372.865V185.352Z",
    fill: "#37474F"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M380.312 185.352H374.906V193.462H380.312V185.352Z",
    fill: "#37474F"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M357.969 197.932H352.562V206.042H357.969V197.932Z",
    fill: "#37474F"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M365.418 197.932H360.012V206.042H365.418V197.932Z",
    fill: "#37474F"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 197.932H367.459V206.042H372.865V197.932Z",
    fill: "#37474F"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M380.312 197.932H374.906V206.042H380.312V197.932Z",
    fill: "#37474F"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M357.969 210.509H352.562V218.619H357.969V210.509Z",
    fill: "#37474F"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M365.418 210.509H360.012V218.619H365.418V210.509Z",
    fill: "#37474F"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 210.509H367.459V218.619H372.865V210.509Z",
    fill: "#37474F"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M380.312 210.509H374.906V218.619H380.312V210.509Z",
    fill: "#37474F"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M357.969 223.084H352.562V231.194H357.969V223.084Z",
    fill: "#37474F"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M365.418 223.084H360.012V231.194H365.418V223.084Z",
    fill: "#37474F"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 223.084H367.459V231.194H372.865V223.084Z",
    fill: "#37474F"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M380.312 223.084H374.906V231.194H380.312V223.084Z",
    fill: "#37474F"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 221.318H349.127V221.991L383.745 221.656V221.318Z",
    fill: "#FFC727"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M383.743 220.384H349.127V221.32H383.743V220.384Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 233.896H349.127V234.571L383.745 234.234V233.896Z",
    fill: "#FFC727"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.745 233.895H349.127V234.569L383.745 234.232V233.895Z",
    fill: "#FFC727"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M383.743 232.957H349.127V233.893H383.743V232.957Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M373.101 238.664H359.468V251.767H373.101V238.664Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M365.935 239.528H359.468V251.768H365.935V239.528Z",
    fill: "#37474F"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M373.103 239.528H366.636V251.768H373.103V239.528Z",
    fill: "#37474F"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M359.469 238.664H357.384V251.767H359.469V238.664Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M376.578 238.665V236.528H356.3V238.665H376.578Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M375.186 238.664H373.102V251.767H375.186V238.664Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M357.384 238.664V239.029L375.189 239.161V238.664H357.384Z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.512 239.528L359.467 243.673V241.217L361.115 239.528H363.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.933 246.866V248.094L362.348 251.768H361.149L365.933 246.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.099 239.528V240.752L366.634 247.377V246.149L373.095 239.528H373.099Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.323 210.507H357.723L352.563 215.793V213.335L355.323 210.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.013 205.704L365.419 200.164V202.622L362.085 206.039H360.013V205.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.597 197.93H369.996L367.46 200.529V198.07L367.597 197.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.867 192.531V193.461H371.96L372.867 192.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25 231.192L372.867 227.486V229.943L371.647 231.192H369.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.561 223.083L374.908 227.851V225.394L377.164 223.083H379.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46 230.759L372.866 225.22V225.501L367.46 231.04V230.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.225 223.083L374.908 223.407V223.126L374.95 223.083H375.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.315 217.586V217.867L379.583 218.617H379.309L380.315 217.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.563 217.901L357.97 212.361V212.642L352.563 218.182V217.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.013 210.507H360.054L360.013 210.55V210.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.139 206.038L365.417 204.728V205.009L364.413 206.038H364.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.052 197.93H372.326L367.46 202.916V202.635L372.052 197.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.315 189.463V189.744L376.687 193.461H376.413L380.315 189.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.563 203.702L357.97 198.162V198.443L352.563 203.983V203.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.556 193.46L365.417 190.528V190.809L362.83 193.46H362.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.745 185.351L367.46 188.717V188.436L370.471 185.351H370.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.97 186.831V188.063L352.703 193.46H352.563V192.371L357.97 186.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.563 228.64L357.97 223.101V224.333L352.563 229.873V228.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.26 210.507H371.462L367.462 214.606L365.419 216.699L363.547 218.617H362.345L365.419 215.467L367.462 213.374L370.26 210.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.314 200.205V201.435L375.822 206.039H374.908V205.745L380.314 200.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.64 218.617L357.97 213.155V214.386L353.84 218.617H352.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.555 210.507H361.756L360.013 212.293V211.063L360.555 210.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.915 206.038L365.417 205.523V206.038H364.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.828 197.93H372.866V199.121L367.46 204.661V203.43L372.828 197.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.315 190.259V191.489L378.391 193.461H377.19L380.315 190.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.224 223.083H356.499L352.563 227.115V226.834L356.224 223.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.496 210.507H368.77L367.46 211.85L365.417 213.943L360.855 218.617H360.581L368.496 210.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.857 206.038L372.866 206.029V206.038H372.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.314 198.396V198.678L374.908 204.217V203.936L380.314 198.396Z",
    fill: "white"
  }))), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M366.44 174.221C368.661 174.221 370.462 172.376 370.462 170.1C370.462 167.824 368.661 165.979 366.44 165.979C364.219 165.979 362.418 167.824 362.418 170.1C362.418 172.376 364.219 174.221 366.44 174.221Z",
    fill: "#37474F"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M367.093 167.521H365.785V172.677H367.093V167.521Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M363.92 169.428V170.769H368.952V169.428H363.92Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M300.114 251.767C342.603 251.635 390.266 251.633 432.755 251.767C390.266 251.901 342.603 251.899 300.114 251.767Z",
    fill: "#263238"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M340.379 240.918H339.193L339.293 240.412L339.375 240.008C339.381 239.974 339.399 239.943 339.425 239.921C339.451 239.899 339.484 239.887 339.518 239.887H340.099C340.133 239.887 340.167 239.9 340.193 239.923C340.22 239.947 340.237 239.979 340.242 240.014V240.055L340.379 240.918Z",
    fill: "#FFC727"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M340.535 241.134L338.967 241.404L339.072 240.915L339.083 240.863H340.484L340.511 241.017L340.535 241.134Z",
    fill: "#EBEBEB"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M341.189 240.97L340.959 246.196L340.912 247.234L340.803 249.729H333.806L334.308 247.275L334.464 246.507C334.473 246.467 334.487 246.429 334.506 246.392C334.534 246.337 334.573 246.288 334.62 246.25C334.659 246.218 334.702 246.193 334.749 246.176L336.859 245.424C336.919 245.402 336.974 245.367 337.02 245.321C337.065 245.275 337.1 245.219 337.123 245.158L338.389 241.677C338.415 241.603 338.461 241.537 338.52 241.487C338.579 241.437 338.651 241.404 338.726 241.391L341.189 240.97Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M340.294 242.002L340.275 242.35L340.27 242.432L340.205 243.621L340.167 244.296L340.152 244.545L340.148 244.627L340.129 244.958L339.793 244.99L339.709 244.999L339.458 245.023L338.772 245.087L337.766 245.185L337.858 244.904L337.896 244.785L338.293 243.591L338.454 243.109L338.785 242.11L339.477 242.06L339.81 242.037L340.294 242.002Z",
    fill: "#37474F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.203 243.622L340.165 244.297L339.456 245.023L338.771 245.088L340.203 243.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.808 242.036L338.291 243.591L338.451 243.109L339.475 242.06L339.808 242.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.273 242.351L340.268 242.433L337.856 244.904L337.894 244.785L340.273 242.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.149 244.543L340.145 244.625L339.79 244.988L339.706 244.997L340.149 244.543Z",
    fill: "white"
  }))), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M337.766 245.185L338.785 242.11L340.294 242.002L338.88 242.279L337.766 245.185Z",
    fill: "#263238"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M336.992 245.489H336.943V249.582H336.992V245.489Z",
    fill: "#EBEBEB"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M340.938 246.198L340.889 247.234L334.308 247.264L334.464 246.497C334.473 246.457 334.487 246.418 334.506 246.382L340.938 246.198Z",
    fill: "#FFC727"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M334.222 246.242L334.789 246.151L334.458 247.349L334.165 247.317C334.133 247.313 334.105 247.298 334.085 247.273C334.065 247.249 334.055 247.217 334.057 247.185L334.12 246.355C334.122 246.327 334.133 246.301 334.152 246.28C334.17 246.26 334.195 246.246 334.222 246.242Z",
    fill: "#FFC727"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M337.401 244.44C337.538 244.559 337.413 245.632 337.316 245.612C337.18 245.595 337.049 245.553 336.928 245.487C336.844 245.418 336.371 244.551 336.487 244.371C336.603 244.192 337.295 244.349 337.401 244.44Z",
    fill: "#EBEBEB"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M352.592 240.735L341.888 240.339L342.238 239.596L342.449 239.144C342.506 239.021 342.596 238.918 342.708 238.845C342.82 238.772 342.949 238.732 343.082 238.731L351.423 238.538C351.58 238.534 351.733 238.583 351.86 238.677C351.986 238.771 352.079 238.906 352.124 239.059L352.189 239.289L352.592 240.735Z",
    fill: "#EBEBEB"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M342.601 239.753L342.708 239.469L343.499 239.463L343.476 239.787L342.601 239.753Z",
    fill: "#263238"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M351.048 239.887L351.069 239.493L352.016 239.565L352.023 239.88L351.048 239.887Z",
    fill: "#263238"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M353.725 249.728H340.775L340.889 247.243L340.938 246.208L341.189 240.75V240.651C341.193 240.57 341.212 240.491 341.246 240.418C341.28 240.345 341.328 240.28 341.387 240.226C341.446 240.172 341.515 240.131 341.59 240.105C341.664 240.079 341.743 240.068 341.822 240.074L352.508 240.374C352.651 240.384 352.786 240.446 352.888 240.549C352.991 240.652 353.053 240.79 353.065 240.936L353.434 245.909L353.529 247.174L353.725 249.728Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M346.705 242.18L346.701 242.319L346.678 243.023L346.676 243.103L346.663 243.519L346.642 244.176L346.619 244.889L345.937 244.898L345.308 244.907L344.914 244.911H344.836L344.163 244.92L343.85 244.924L342.46 244.941H342.382L341.955 244.948H341.82L341.844 244.427L341.873 243.685L341.877 243.605L341.892 243.235L341.907 242.904L341.947 241.953L342.795 241.994L343.091 242.007L343.42 242.024L343.492 242.027L344.154 242.059L344.747 242.087L345.148 242.107L345.222 242.109L346.534 242.174L346.705 242.18Z",
    fill: "#37474F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.749 242.088L341.957 244.948H341.822L341.845 244.427L344.156 242.06L344.749 242.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.666 243.52L346.645 244.177L345.94 244.899L345.312 244.908L346.666 243.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.707 242.181L346.702 242.32L344.164 244.921L343.852 244.925L346.536 242.175L346.707 242.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.089 242.007L341.891 243.235L341.905 242.904L342.794 241.994L343.089 242.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.493 242.027L341.875 243.685L341.879 243.605L343.422 242.024L343.493 242.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.225 242.109L342.463 244.941H342.385L345.151 242.106L345.225 242.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.68 243.022L346.678 243.102L344.916 244.91H344.838L346.68 243.022Z",
    fill: "white"
  }))), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M341.82 244.948L341.947 241.953L346.705 242.18L342.206 242.21L341.82 244.948Z",
    fill: "#263238"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M353.537 247.177L340.912 247.233H340.889L340.935 246.197L340.958 246.195L353.442 245.914L353.537 247.177Z",
    fill: "#FFC727"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M350.596 244.516H350.033L349.976 242.389H350.596V244.516Z",
    fill: "#FFC727"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M351.344 243.136L351.361 243.769L349.282 243.767L349.268 243.192L351.344 243.136Z",
    fill: "#FFC727"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M353.725 250.19H333.482V249.521H353.725V250.19Z",
    fill: "#EBEBEB"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M333.025 249.198L335.217 249.337V250.292H332.862L333.025 249.198Z",
    fill: "#DBDBDB"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M354.089 249.209L353.156 249.324C353.103 249.327 353.053 249.352 353.016 249.392C352.98 249.432 352.96 249.485 352.96 249.54V250.292H354.437L354.302 249.393C354.294 249.341 354.268 249.294 354.229 249.26C354.19 249.226 354.14 249.208 354.089 249.209Z",
    fill: "#DBDBDB"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M351.307 250.322C351.249 250.322 351.192 250.3 351.148 250.26C351.104 250.22 351.075 250.166 351.067 250.106C351.067 250.059 350.879 248.939 349.778 248.939C348.676 248.939 348.511 250.056 348.511 250.104C348.498 250.165 348.463 250.218 348.413 250.253C348.363 250.289 348.302 250.303 348.242 250.295C348.182 250.287 348.127 250.256 348.088 250.208C348.05 250.16 348.03 250.099 348.033 250.037C348.082 249.597 348.288 249.192 348.611 248.898C348.934 248.604 349.352 248.442 349.784 248.443C350.217 248.443 350.636 248.604 350.961 248.897C351.287 249.19 351.497 249.594 351.552 250.035C351.557 250.067 351.555 250.101 351.546 250.133C351.538 250.165 351.524 250.194 351.504 250.221C351.484 250.247 351.46 250.269 351.432 250.285C351.404 250.301 351.373 250.312 351.341 250.316L351.307 250.322Z",
    fill: "#DBDBDB"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M349.787 248.742C351.686 248.742 351.686 251.769 349.787 251.769C347.888 251.769 347.879 248.742 349.787 248.742Z",
    fill: "#263238"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M349.786 249.568C350.651 249.568 350.651 250.946 349.786 250.946C348.92 250.946 348.92 249.568 349.786 249.568Z",
    fill: "#EBEBEB"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M339.023 250.323C338.964 250.323 338.908 250.301 338.864 250.261C338.82 250.221 338.792 250.166 338.784 250.107C338.784 250.059 338.597 248.939 337.495 248.939C336.394 248.939 336.229 250.057 336.229 250.104C336.226 250.137 336.216 250.169 336.2 250.197C336.184 250.226 336.163 250.251 336.138 250.271C336.112 250.292 336.083 250.306 336.052 250.315C336.021 250.323 335.989 250.325 335.957 250.321C335.893 250.312 335.835 250.278 335.795 250.226C335.756 250.173 335.738 250.107 335.746 250.042C335.82 249.49 336.28 248.448 337.499 248.448C338.719 248.448 339.187 249.488 339.266 250.04C339.27 250.072 339.269 250.106 339.26 250.138C339.252 250.17 339.238 250.2 339.218 250.226C339.199 250.252 339.174 250.274 339.146 250.29C339.118 250.307 339.087 250.317 339.055 250.321L339.023 250.323Z",
    fill: "#DBDBDB"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M337.496 248.742C339.395 248.742 339.395 251.769 337.496 251.769C335.597 251.769 335.588 248.742 337.496 248.742Z",
    fill: "#263238"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M337.497 249.568C338.362 249.568 338.362 250.946 337.497 250.946C336.631 250.946 336.631 249.568 337.497 249.568Z",
    fill: "#EBEBEB"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M299.398 179.391H268.815C268.815 179.391 271.85 170.9 276.519 170.9C281.188 170.9 282.635 176.75 282.635 176.75C282.635 176.75 285.786 173.576 288.372 173.576C290.958 173.576 293.203 177.784 293.203 177.784C293.203 177.784 296.869 175.522 299.398 179.391Z",
    fill: "#EBEBEB"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M244.693 195.237H214.094C214.094 195.237 217.129 186.746 221.798 186.746C226.467 186.746 227.93 192.608 227.93 192.608C227.93 192.608 231.079 189.422 233.668 189.422C236.256 189.422 238.498 193.63 238.498 193.63C238.498 193.63 242.161 191.367 244.693 195.237Z",
    fill: "#EBEBEB"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.503 189.188H256.206C256.206 189.188 259.4 184.444 261.918 184.444C264.436 184.444 265.177 187.607 265.177 187.607C265.177 187.607 266.953 186.13 268.602 186.395C270.25 186.66 270.503 189.188 270.503 189.188Z",
    fill: "#EBEBEB"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M208.682 184.571H180.833C180.833 184.571 184.644 175.847 188.724 175.294C192.805 174.74 194.755 181.776 194.755 181.776C194.755 181.776 197.386 179.292 199.458 179.292C201.529 179.292 203.123 182.573 203.123 182.573C203.123 182.573 207.261 180.331 208.682 184.571Z",
    fill: "#EBEBEB"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.342 168.668H208.527C208.527 168.668 211.758 162.346 215.265 162.262C218.772 162.177 220.613 167.046 220.613 167.046C220.613 167.046 226.066 162.556 227.342 168.668Z",
    fill: "#EBEBEB"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M295.701 200.704H276.886C276.886 200.704 280.117 194.382 283.623 194.298C287.13 194.214 288.972 199.082 288.972 199.082C288.972 199.082 294.428 194.592 295.701 200.704Z",
    fill: "#EBEBEB"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M227.04 207.238H215.94V250.378H227.04V207.238Z",
    fill: "#EBEBEB"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M227.042 204.38H217.52V207.242H227.042V204.38Z",
    fill: "#C7C7C7"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 208.732H217.155V240.981H225.823V208.732Z",
    fill: "#DBDBDB"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 211.81H217.155V212.572H225.823V211.81Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 214.966H217.155V215.729H225.823V214.966Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 218.124H217.155V218.887H225.823V218.124Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 221.28H217.155V222.043H225.823V221.28Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 224.437H217.155V225.199H225.823V224.437Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 227.592H217.155V228.355H225.823V227.592Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 230.753H217.155V231.516H225.823V230.753Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 233.909H217.155V234.672H225.823V233.909Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 237.064H217.155V237.827H225.823V237.064Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M225.823 240.22H217.155V240.983H225.823V240.22Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M233.992 207.238H227.038V250.378H233.992V207.238Z",
    fill: "#DBDBDB"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M232.949 204.38H227.038V207.242H232.949V204.38Z",
    fill: "#A6A6A6"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 208.732H228.002V240.981H233.347V208.732Z",
    fill: "#C7C7C7"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 211.81H228.002V212.572H233.347V211.81Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 214.966H228.002V215.729H233.347V214.966Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 218.124H228.002V218.887H233.347V218.124Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 221.28H228.002V222.043H233.347V221.28Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 224.437H228.002V225.199H233.347V224.437Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 227.592H228.002V228.355H233.347V227.592Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 230.753H228.002V231.516H233.347V230.753Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 233.909H228.002V234.672H233.347V233.909Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 237.064H228.002V237.827H233.347V237.064Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M233.347 240.22H228.002V240.983H233.347V240.22Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M275.261 190.112H264.042V250.382H275.261V190.112Z",
    fill: "#DBDBDB"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 192.067H265.781V194.368H267.964V192.067Z",
    fill: "#EBEBEB"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 192.067H268.571V194.368H270.754V192.067Z",
    fill: "#EBEBEB"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 195.976H265.781V198.276H267.964V195.976Z",
    fill: "#EBEBEB"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 195.976H268.571V198.276H270.754V195.976Z",
    fill: "#EBEBEB"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 199.883H265.781V202.183H267.964V199.883Z",
    fill: "#EBEBEB"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 199.883H268.571V202.183H270.754V199.883Z",
    fill: "#EBEBEB"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 203.787H265.781V206.087H267.964V203.787Z",
    fill: "#EBEBEB"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 203.787H268.571V206.087H270.754V203.787Z",
    fill: "#EBEBEB"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 207.696H265.781V209.997H267.964V207.696Z",
    fill: "#EBEBEB"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 207.696H268.571V209.997H270.754V207.696Z",
    fill: "#EBEBEB"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 211.604H265.781V213.905H267.964V211.604Z",
    fill: "#EBEBEB"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 211.604H268.571V213.905H270.754V211.604Z",
    fill: "#EBEBEB"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 215.512H265.781V217.812H267.964V215.512Z",
    fill: "#EBEBEB"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 215.512H268.571V217.812H270.754V215.512Z",
    fill: "#EBEBEB"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 219.415H265.781V221.715H267.964V219.415Z",
    fill: "#EBEBEB"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 219.415H268.571V221.715H270.754V219.415Z",
    fill: "#EBEBEB"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 223.323H265.781V225.624H267.964V223.323Z",
    fill: "#EBEBEB"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 223.323H268.571V225.624H270.754V223.323Z",
    fill: "#EBEBEB"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 227.231H265.781V229.532H267.964V227.231Z",
    fill: "#EBEBEB"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 227.231H268.571V229.532H270.754V227.231Z",
    fill: "#EBEBEB"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 231.139H265.781V233.439H267.964V231.139Z",
    fill: "#EBEBEB"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 231.139H268.571V233.439H270.754V231.139Z",
    fill: "#EBEBEB"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 235.044H265.781V237.344H267.964V235.044Z",
    fill: "#EBEBEB"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 235.044H268.571V237.344H270.754V235.044Z",
    fill: "#EBEBEB"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 238.951H265.781V241.252H267.964V238.951Z",
    fill: "#EBEBEB"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 238.951H268.571V241.252H270.754V238.951Z",
    fill: "#EBEBEB"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M267.964 242.859H265.781V245.16H267.964V242.859Z",
    fill: "#EBEBEB"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 245.161H273.518V242.861H271.335V245.161Z",
    fill: "#EBEBEB"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 241.255H273.518V238.954H271.335V241.255Z",
    fill: "#EBEBEB"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 237.347H273.518V235.046H271.335V237.347Z",
    fill: "#EBEBEB"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 233.439H273.518V231.139H271.335V233.439Z",
    fill: "#EBEBEB"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 229.531H273.518V227.231H271.335V229.531Z",
    fill: "#EBEBEB"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 225.626H273.518V223.326H271.335V225.626Z",
    fill: "#EBEBEB"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 221.719H273.518V219.418H271.335V221.719Z",
    fill: "#EBEBEB"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 217.809H273.518V215.508H271.335V217.809Z",
    fill: "#EBEBEB"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 213.904H273.518V211.604H271.335V213.904Z",
    fill: "#EBEBEB"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 209.996H273.518V207.696H271.335V209.996Z",
    fill: "#EBEBEB"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 206.092H273.518V203.791H271.335V206.092Z",
    fill: "#EBEBEB"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 202.18H273.518V199.879H271.335V202.18Z",
    fill: "#EBEBEB"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 198.274H273.518V195.974H271.335V198.274Z",
    fill: "#EBEBEB"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M271.335 194.369H273.518V192.069H271.335V194.369Z",
    fill: "#EBEBEB"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 242.859H268.571V245.16H270.754V242.859Z",
    fill: "#EBEBEB"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M284.107 190.112H275.261V250.382H284.107V190.112Z",
    fill: "#A6A6A6"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 245.161H283.196V242.861H281.395V245.161Z",
    fill: "#C7C7C7"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 245.161H280.891V242.861H279.089V245.161Z",
    fill: "#C7C7C7"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 241.255H283.196V238.954H281.395V241.255Z",
    fill: "#C7C7C7"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 241.255H280.891V238.954H279.089V241.255Z",
    fill: "#C7C7C7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 237.347H283.196V235.046H281.395V237.347Z",
    fill: "#C7C7C7"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 237.347H280.891V235.046H279.089V237.347Z",
    fill: "#C7C7C7"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 233.439H283.196V231.139H281.395V233.439Z",
    fill: "#C7C7C7"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 233.439H280.891V231.139H279.089V233.439Z",
    fill: "#C7C7C7"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 229.531H283.196V227.231H281.395V229.531Z",
    fill: "#C7C7C7"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 229.531H280.891V227.231H279.089V229.531Z",
    fill: "#C7C7C7"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 225.626H283.196V223.326H281.395V225.626Z",
    fill: "#C7C7C7"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 225.626H280.891V223.326H279.089V225.626Z",
    fill: "#C7C7C7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 221.719H283.196V219.418H281.395V221.719Z",
    fill: "#C7C7C7"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 221.719H280.891V219.418H279.089V221.719Z",
    fill: "#C7C7C7"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 217.809H283.196V215.508H281.395V217.809Z",
    fill: "#C7C7C7"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 217.809H280.891V215.508H279.089V217.809Z",
    fill: "#C7C7C7"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 213.904H283.196V211.604H281.395V213.904Z",
    fill: "#C7C7C7"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 213.904H280.891V211.604H279.089V213.904Z",
    fill: "#C7C7C7"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 209.996H283.196V207.696H281.395V209.996Z",
    fill: "#C7C7C7"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 209.996H280.891V207.696H279.089V209.996Z",
    fill: "#C7C7C7"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 206.092H283.196V203.791H281.395V206.092Z",
    fill: "#C7C7C7"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 206.092H280.891V203.791H279.089V206.092Z",
    fill: "#C7C7C7"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 202.18H283.196V199.879H281.395V202.18Z",
    fill: "#C7C7C7"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 202.18H280.891V199.879H279.089V202.18Z",
    fill: "#C7C7C7"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 198.274H283.196V195.974H281.395V198.274Z",
    fill: "#C7C7C7"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 198.274H280.891V195.974H279.089V198.274Z",
    fill: "#C7C7C7"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M281.395 194.369H283.196V192.069H281.395V194.369Z",
    fill: "#C7C7C7"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 192.067H276.806V194.368H278.607V192.067Z",
    fill: "#C7C7C7"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 195.976H276.806V198.276H278.607V195.976Z",
    fill: "#C7C7C7"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 199.883H276.806V202.183H278.607V199.883Z",
    fill: "#C7C7C7"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 203.787H276.806V206.087H278.607V203.787Z",
    fill: "#C7C7C7"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 207.696H276.806V209.997H278.607V207.696Z",
    fill: "#C7C7C7"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 211.604H276.806V213.905H278.607V211.604Z",
    fill: "#C7C7C7"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 215.512H276.806V217.812H278.607V215.512Z",
    fill: "#C7C7C7"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 219.415H276.806V221.715H278.607V219.415Z",
    fill: "#C7C7C7"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 223.323H276.806V225.624H278.607V223.323Z",
    fill: "#C7C7C7"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 227.231H276.806V229.532H278.607V227.231Z",
    fill: "#C7C7C7"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 231.139H276.806V233.439H278.607V231.139Z",
    fill: "#C7C7C7"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 235.044H276.806V237.344H278.607V235.044Z",
    fill: "#C7C7C7"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 238.951H276.806V241.252H278.607V238.951Z",
    fill: "#C7C7C7"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M278.607 242.859H276.806V245.16H278.607V242.859Z",
    fill: "#C7C7C7"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M279.089 194.369H280.891V192.069H279.089V194.369Z",
    fill: "#C7C7C7"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M192.38 188.794H180.675V250.377H192.38V188.794Z",
    fill: "#EBEBEB"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M192.379 187.568H180.393V188.794H192.379V187.568Z",
    fill: "#C7C7C7"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 190.604H181.731V250.382H182.916V190.604Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 190.604H183.833V250.382H185.018V190.604Z",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 190.604H185.934V250.382H187.119V190.604Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 190.604H188.033V250.382H189.218V190.604Z",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 190.604H190.138V250.382H191.323V190.604Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 192.151H181.731V194.571H182.916V192.151Z",
    fill: "#EBEBEB"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 192.151H183.833V194.571H185.018V192.151Z",
    fill: "#EBEBEB"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 192.151H185.934V194.571H187.119V192.151Z",
    fill: "#EBEBEB"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 192.151H188.033V194.571H189.218V192.151Z",
    fill: "#EBEBEB"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 192.151H190.138V194.571H191.323V192.151Z",
    fill: "#EBEBEB"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 196.086H181.731V198.506H182.916V196.086Z",
    fill: "#EBEBEB"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 196.086H183.833V198.506H185.018V196.086Z",
    fill: "#EBEBEB"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 196.086H185.934V198.506H187.119V196.086Z",
    fill: "#EBEBEB"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 196.086H188.033V198.506H189.218V196.086Z",
    fill: "#EBEBEB"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 196.086H190.138V198.506H191.323V196.086Z",
    fill: "#EBEBEB"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 200.02H181.731V202.439H182.916V200.02Z",
    fill: "#EBEBEB"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 200.02H183.833V202.439H185.018V200.02Z",
    fill: "#EBEBEB"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 200.02H185.934V202.439H187.119V200.02Z",
    fill: "#EBEBEB"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 200.02H188.033V202.439H189.218V200.02Z",
    fill: "#EBEBEB"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 200.02H190.138V202.439H191.323V200.02Z",
    fill: "#EBEBEB"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 203.954H181.731V206.374H182.916V203.954Z",
    fill: "#EBEBEB"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 203.954H183.833V206.374H185.018V203.954Z",
    fill: "#EBEBEB"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 203.954H185.934V206.374H187.119V203.954Z",
    fill: "#EBEBEB"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 203.954H188.033V206.374H189.218V203.954Z",
    fill: "#EBEBEB"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 203.954H190.138V206.374H191.323V203.954Z",
    fill: "#EBEBEB"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 207.891H181.731V210.31H182.916V207.891Z",
    fill: "#EBEBEB"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 207.891H183.833V210.31H185.018V207.891Z",
    fill: "#EBEBEB"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 207.891H185.934V210.31H187.119V207.891Z",
    fill: "#EBEBEB"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 207.891H188.033V210.31H189.218V207.891Z",
    fill: "#EBEBEB"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 207.891H190.138V210.31H191.323V207.891Z",
    fill: "#EBEBEB"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 211.824H181.731V214.244H182.916V211.824Z",
    fill: "#EBEBEB"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 211.824H183.833V214.244H185.018V211.824Z",
    fill: "#EBEBEB"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 211.824H185.934V214.244H187.119V211.824Z",
    fill: "#EBEBEB"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 211.824H188.033V214.244H189.218V211.824Z",
    fill: "#EBEBEB"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 211.824H190.138V214.244H191.323V211.824Z",
    fill: "#EBEBEB"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 215.759H181.731V218.179H182.916V215.759Z",
    fill: "#EBEBEB"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 215.759H183.833V218.179H185.018V215.759Z",
    fill: "#EBEBEB"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 215.759H185.934V218.179H187.119V215.759Z",
    fill: "#EBEBEB"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 215.759H188.033V218.179H189.218V215.759Z",
    fill: "#EBEBEB"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 215.759H190.138V218.179H191.323V215.759Z",
    fill: "#EBEBEB"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 219.692H181.731V222.112H182.916V219.692Z",
    fill: "#EBEBEB"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 219.692H183.833V222.112H185.018V219.692Z",
    fill: "#EBEBEB"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 219.692H185.934V222.112H187.119V219.692Z",
    fill: "#EBEBEB"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 219.692H188.033V222.112H189.218V219.692Z",
    fill: "#EBEBEB"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 219.692H190.138V222.112H191.323V219.692Z",
    fill: "#EBEBEB"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 223.626H181.731V226.046H182.916V223.626Z",
    fill: "#EBEBEB"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 223.626H183.833V226.046H185.018V223.626Z",
    fill: "#EBEBEB"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 223.626H185.934V226.046H187.119V223.626Z",
    fill: "#EBEBEB"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 223.626H188.033V226.046H189.218V223.626Z",
    fill: "#EBEBEB"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 223.626H190.138V226.046H191.323V223.626Z",
    fill: "#EBEBEB"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 227.561H181.731V229.98H182.916V227.561Z",
    fill: "#EBEBEB"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 227.561H183.833V229.98H185.018V227.561Z",
    fill: "#EBEBEB"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 227.561H185.934V229.98H187.119V227.561Z",
    fill: "#EBEBEB"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 227.561H188.033V229.98H189.218V227.561Z",
    fill: "#EBEBEB"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 227.561H190.138V229.98H191.323V227.561Z",
    fill: "#EBEBEB"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 231.494H181.731V233.914H182.916V231.494Z",
    fill: "#EBEBEB"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 231.494H183.833V233.914H185.018V231.494Z",
    fill: "#EBEBEB"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 231.494H185.934V233.914H187.119V231.494Z",
    fill: "#EBEBEB"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 231.494H188.033V233.914H189.218V231.494Z",
    fill: "#EBEBEB"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 231.494H190.138V233.914H191.323V231.494Z",
    fill: "#EBEBEB"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 235.432H181.731V237.851H182.916V235.432Z",
    fill: "#EBEBEB"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 235.432H183.833V237.851H185.018V235.432Z",
    fill: "#EBEBEB"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 235.432H185.934V237.851H187.119V235.432Z",
    fill: "#EBEBEB"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 235.432H188.033V237.851H189.218V235.432Z",
    fill: "#EBEBEB"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 235.432H190.138V237.851H191.323V235.432Z",
    fill: "#EBEBEB"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 239.364H181.731V241.784H182.916V239.364Z",
    fill: "#EBEBEB"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 239.364H183.833V241.784H185.018V239.364Z",
    fill: "#EBEBEB"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 239.364H185.934V241.784H187.119V239.364Z",
    fill: "#EBEBEB"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 239.364H188.033V241.784H189.218V239.364Z",
    fill: "#EBEBEB"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 239.364H190.138V241.784H191.323V239.364Z",
    fill: "#EBEBEB"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M182.916 243.299H181.731V250.38H182.916V243.299Z",
    fill: "#EBEBEB"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M185.018 243.299H183.833V250.38H185.018V243.299Z",
    fill: "#EBEBEB"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M187.119 243.299H185.934V250.38H187.119V243.299Z",
    fill: "#EBEBEB"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M189.218 243.299H188.033V250.38H189.218V243.299Z",
    fill: "#EBEBEB"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M191.323 243.299H190.138V250.38H191.323V243.299Z",
    fill: "#EBEBEB"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M199.892 188.794H192.379V250.377H199.892V188.794Z",
    fill: "#DBDBDB"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M200.219 187.568H192.379V188.794H200.219V187.568Z",
    fill: "#C7C7C7"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 190.604H193.439V250.382H194.624V190.604Z",
    fill: "#C7C7C7"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 190.604H195.539V250.382H196.724V190.604Z",
    fill: "#C7C7C7"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 190.604H197.641V250.382H198.826V190.604Z",
    fill: "#C7C7C7"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 192.151H193.439V194.571H194.624V192.151Z",
    fill: "#DBDBDB"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 192.151H195.539V194.571H196.724V192.151Z",
    fill: "#DBDBDB"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 192.151H197.641V194.571H198.826V192.151Z",
    fill: "#DBDBDB"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 196.086H193.439V198.506H194.624V196.086Z",
    fill: "#DBDBDB"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 196.086H195.539V198.506H196.724V196.086Z",
    fill: "#DBDBDB"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 196.086H197.641V198.506H198.826V196.086Z",
    fill: "#DBDBDB"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 200.02H193.439V202.439H194.624V200.02Z",
    fill: "#DBDBDB"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 200.02H195.539V202.439H196.724V200.02Z",
    fill: "#DBDBDB"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 200.02H197.641V202.439H198.826V200.02Z",
    fill: "#DBDBDB"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 203.954H193.439V206.374H194.624V203.954Z",
    fill: "#DBDBDB"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 203.954H195.539V206.374H196.724V203.954Z",
    fill: "#DBDBDB"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 203.954H197.641V206.374H198.826V203.954Z",
    fill: "#DBDBDB"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 207.891H193.439V210.31H194.624V207.891Z",
    fill: "#DBDBDB"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 207.891H195.539V210.31H196.724V207.891Z",
    fill: "#DBDBDB"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 207.891H197.641V210.31H198.826V207.891Z",
    fill: "#DBDBDB"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 211.824H193.439V214.244H194.624V211.824Z",
    fill: "#DBDBDB"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 211.824H195.539V214.244H196.724V211.824Z",
    fill: "#DBDBDB"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 211.824H197.641V214.244H198.826V211.824Z",
    fill: "#DBDBDB"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 215.759H193.439V218.179H194.624V215.759Z",
    fill: "#DBDBDB"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 215.759H195.539V218.179H196.724V215.759Z",
    fill: "#DBDBDB"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 215.759H197.641V218.179H198.826V215.759Z",
    fill: "#DBDBDB"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 219.692H193.439V222.112H194.624V219.692Z",
    fill: "#DBDBDB"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 219.692H195.539V222.112H196.724V219.692Z",
    fill: "#DBDBDB"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 219.692H197.641V222.112H198.826V219.692Z",
    fill: "#DBDBDB"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 223.626H193.439V226.046H194.624V223.626Z",
    fill: "#DBDBDB"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 223.626H195.539V226.046H196.724V223.626Z",
    fill: "#DBDBDB"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 223.626H197.641V226.046H198.826V223.626Z",
    fill: "#DBDBDB"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 227.561H193.439V229.98H194.624V227.561Z",
    fill: "#DBDBDB"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 227.561H195.539V229.98H196.724V227.561Z",
    fill: "#DBDBDB"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 227.561H197.641V229.98H198.826V227.561Z",
    fill: "#DBDBDB"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 231.494H193.439V233.914H194.624V231.494Z",
    fill: "#DBDBDB"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 231.494H195.539V233.914H196.724V231.494Z",
    fill: "#DBDBDB"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 231.494H197.641V233.914H198.826V231.494Z",
    fill: "#DBDBDB"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 235.432H193.439V237.851H194.624V235.432Z",
    fill: "#DBDBDB"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 235.432H195.539V237.851H196.724V235.432Z",
    fill: "#DBDBDB"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 235.432H197.641V237.851H198.826V235.432Z",
    fill: "#DBDBDB"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 239.364H193.439V241.784H194.624V239.364Z",
    fill: "#DBDBDB"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 239.364H195.539V241.784H196.724V239.364Z",
    fill: "#DBDBDB"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 239.364H197.641V241.784H198.826V239.364Z",
    fill: "#DBDBDB"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M194.624 243.299H193.439V250.38H194.624V243.299Z",
    fill: "#DBDBDB"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M196.724 243.299H195.539V250.38H196.724V243.299Z",
    fill: "#DBDBDB"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 243.299H197.641V250.38H198.826V243.299Z",
    fill: "#DBDBDB"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M243.298 213.977H229.229V250.381H243.298V213.977Z",
    fill: "#EBEBEB"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M243.294 212.75H228.89V213.976H243.294V212.75Z",
    fill: "#C7C7C7"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M231.925 215.784H230.501V250.377H231.925V215.784Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 215.784H233.023V250.377H234.45V215.784Z",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M236.972 215.784H235.548V250.377H236.972V215.784Z",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 215.784H238.074V250.377H239.501V215.784Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M242.024 215.784H240.601V250.377H242.024V215.784Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 217.334H230.501V219.754H231.928V217.334Z",
    fill: "#EBEBEB"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 217.334H233.023V219.754H234.45V217.334Z",
    fill: "#EBEBEB"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 217.334H235.548V219.754H236.974V217.334Z",
    fill: "#EBEBEB"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 217.334H238.074V219.754H239.501V217.334Z",
    fill: "#EBEBEB"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 217.334H240.597V219.754H242.023V217.334Z",
    fill: "#EBEBEB"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 221.269H230.501V223.688H231.928V221.269Z",
    fill: "#EBEBEB"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 221.269H233.023V223.688H234.45V221.269Z",
    fill: "#EBEBEB"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 221.269H235.548V223.688H236.974V221.269Z",
    fill: "#EBEBEB"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 221.269H238.074V223.688H239.501V221.269Z",
    fill: "#EBEBEB"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 221.269H240.597V223.688H242.023V221.269Z",
    fill: "#EBEBEB"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 225.202H230.501V227.622H231.928V225.202Z",
    fill: "#EBEBEB"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 225.202H233.023V227.622H234.45V225.202Z",
    fill: "#EBEBEB"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 225.202H235.548V227.622H236.974V225.202Z",
    fill: "#EBEBEB"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 225.202H238.074V227.622H239.501V225.202Z",
    fill: "#EBEBEB"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 225.202H240.597V227.622H242.023V225.202Z",
    fill: "#EBEBEB"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 229.137H230.501V231.556H231.928V229.137Z",
    fill: "#EBEBEB"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 229.137H233.023V231.556H234.45V229.137Z",
    fill: "#EBEBEB"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 229.137H235.548V231.556H236.974V229.137Z",
    fill: "#EBEBEB"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 229.137H238.074V231.556H239.501V229.137Z",
    fill: "#EBEBEB"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 229.137H240.597V231.556H242.023V229.137Z",
    fill: "#EBEBEB"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 233.07H230.501V235.49H231.928V233.07Z",
    fill: "#EBEBEB"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 233.07H233.023V235.49H234.45V233.07Z",
    fill: "#EBEBEB"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 233.07H235.548V235.49H236.974V233.07Z",
    fill: "#EBEBEB"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 233.07H238.074V235.49H239.501V233.07Z",
    fill: "#EBEBEB"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 233.07H240.597V235.49H242.023V233.07Z",
    fill: "#EBEBEB"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 237.004H230.501V239.424H231.928V237.004Z",
    fill: "#EBEBEB"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 237.004H233.023V239.424H234.45V237.004Z",
    fill: "#EBEBEB"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 237.004H235.548V239.424H236.974V237.004Z",
    fill: "#EBEBEB"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 237.004H238.074V239.424H239.501V237.004Z",
    fill: "#EBEBEB"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 237.004H240.597V239.424H242.023V237.004Z",
    fill: "#EBEBEB"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 240.94H230.501V243.36H231.928V240.94Z",
    fill: "#EBEBEB"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 240.94H233.023V243.36H234.45V240.94Z",
    fill: "#EBEBEB"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 240.94H235.548V243.36H236.974V240.94Z",
    fill: "#EBEBEB"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 240.94H238.074V243.36H239.501V240.94Z",
    fill: "#EBEBEB"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 240.94H240.597V243.36H242.023V240.94Z",
    fill: "#EBEBEB"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 244.875H230.501V247.295H231.928V244.875Z",
    fill: "#EBEBEB"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 244.875H233.023V247.295H234.45V244.875Z",
    fill: "#EBEBEB"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M236.974 244.875H235.548V247.295H236.974V244.875Z",
    fill: "#EBEBEB"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 244.875H238.074V247.295H239.501V244.875Z",
    fill: "#EBEBEB"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M242.023 244.875H240.597V247.295H242.023V244.875Z",
    fill: "#EBEBEB"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M231.925 248.809H230.501V250.378H231.925V248.809Z",
    fill: "#EBEBEB"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M234.45 248.809H233.023V250.378H234.45V248.809Z",
    fill: "#EBEBEB"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M236.972 248.809H235.548V250.378H236.972V248.809Z",
    fill: "#EBEBEB"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M239.501 248.809H238.074V250.378H239.501V248.809Z",
    fill: "#EBEBEB"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M242.024 248.809H240.601V250.378H242.024V248.809Z",
    fill: "#EBEBEB"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M252.327 213.977H243.296V250.381H252.327V213.977Z",
    fill: "#DBDBDB"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M252.718 212.75H243.295V213.976H252.718V212.75Z",
    fill: "#C7C7C7"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 215.784H244.566V250.377H245.993V215.784Z",
    fill: "#C7C7C7"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M248.516 215.784H247.092V250.377H248.516V215.784Z",
    fill: "#C7C7C7"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 215.784H249.616V250.377H251.043V215.784Z",
    fill: "#C7C7C7"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 217.334H244.566V219.754H245.993V217.334Z",
    fill: "#DBDBDB"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 217.334H247.092V219.754H248.518V217.334Z",
    fill: "#DBDBDB"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 217.334H249.616V219.754H251.043V217.334Z",
    fill: "#DBDBDB"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 221.269H244.566V223.688H245.993V221.269Z",
    fill: "#DBDBDB"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 221.269H247.092V223.688H248.518V221.269Z",
    fill: "#DBDBDB"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 221.269H249.616V223.688H251.043V221.269Z",
    fill: "#DBDBDB"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 225.202H244.566V227.622H245.993V225.202Z",
    fill: "#DBDBDB"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 225.202H247.092V227.622H248.518V225.202Z",
    fill: "#DBDBDB"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 225.202H249.616V227.622H251.043V225.202Z",
    fill: "#DBDBDB"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 229.137H244.566V231.556H245.993V229.137Z",
    fill: "#DBDBDB"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 229.137H247.092V231.556H248.518V229.137Z",
    fill: "#DBDBDB"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 229.137H249.616V231.556H251.043V229.137Z",
    fill: "#DBDBDB"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 233.07H244.566V235.49H245.993V233.07Z",
    fill: "#DBDBDB"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 233.07H247.092V235.49H248.518V233.07Z",
    fill: "#DBDBDB"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 233.07H249.616V235.49H251.043V233.07Z",
    fill: "#DBDBDB"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 237.004H244.566V239.424H245.993V237.004Z",
    fill: "#DBDBDB"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 237.004H247.092V239.424H248.518V237.004Z",
    fill: "#DBDBDB"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 237.004H249.616V239.424H251.043V237.004Z",
    fill: "#DBDBDB"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 240.94H244.566V243.36H245.993V240.94Z",
    fill: "#DBDBDB"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 240.94H247.092V243.36H248.518V240.94Z",
    fill: "#DBDBDB"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 240.94H249.616V243.36H251.043V240.94Z",
    fill: "#DBDBDB"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 244.875H244.566V247.295H245.993V244.875Z",
    fill: "#DBDBDB"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M248.518 244.875H247.092V247.295H248.518V244.875Z",
    fill: "#DBDBDB"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 244.875H249.616V247.295H251.043V244.875Z",
    fill: "#DBDBDB"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M245.993 248.809H244.566V250.378H245.993V248.809Z",
    fill: "#DBDBDB"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M248.516 248.809H247.092V250.378H248.516V248.809Z",
    fill: "#DBDBDB"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M251.043 248.809H249.616V250.378H251.043V248.809Z",
    fill: "#DBDBDB"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M290.683 207.968H284.755V215.146H290.683V207.968Z",
    fill: "#DBDBDB"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M294.442 207.968H290.683V215.408H294.442V207.968Z",
    fill: "#C7C7C7"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M294.692 211.135H290.961V215.406H294.692V211.135Z",
    fill: "#DBDBDB"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M297.021 211.135H294.693V215.406H297.021V211.135Z",
    fill: "#C7C7C7"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M292.066 214.677H282.478V250.379H292.066V214.677Z",
    fill: "#EBEBEB"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 216.213H283.573V217.474H286.588V216.213Z",
    fill: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 216.213H287.432V217.474H290.447V216.213Z",
    fill: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 218.355H283.573V219.616H286.588V218.355Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 218.355H287.432V219.616H290.447V218.355Z",
    fill: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 220.496H283.573V221.757H286.588V220.496Z",
    fill: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 220.496H287.432V221.757H290.447V220.496Z",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 222.64H283.573V223.9H286.588V222.64Z",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 222.64H287.432V223.9H290.447V222.64Z",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 224.782H283.573V226.043H286.588V224.782Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 224.782H287.432V226.043H290.447V224.782Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 226.926H283.573V228.187H286.588V226.926Z",
    fill: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 226.926H287.432V228.187H290.447V226.926Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 229.069H283.573V230.33H286.588V229.069Z",
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 229.069H287.432V230.33H290.447V229.069Z",
    fill: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 231.211H283.573V232.472H286.588V231.211Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 231.211H287.432V232.472H290.447V231.211Z",
    fill: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 233.354H283.573V234.615H286.588V233.354Z",
    fill: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 233.354H287.432V234.615H290.447V233.354Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 235.499H283.573V236.76H286.588V235.499Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 235.499H287.432V236.76H290.447V235.499Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 237.642H283.573V238.902H286.588V237.642Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 237.642H287.432V238.902H290.447V237.642Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 239.785H283.573V241.046H286.588V239.785Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 239.785H287.432V241.046H290.447V239.785Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 241.928H283.573V243.189H286.588V241.928Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 241.928H287.432V243.189H290.447V241.928Z",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M286.588 244.071H283.573V245.332H286.588V244.071Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M290.447 244.071H287.432V245.332H290.447V244.071Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M299.836 214.677H292.066V250.379H299.836V214.677Z",
    fill: "#C7C7C7"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 245.333H299.055V244.072H296.58V245.333Z",
    fill: "#EBEBEB"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 245.333H295.891V244.072H293.415V245.333Z",
    fill: "#EBEBEB"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 243.188H299.055V241.928H296.58V243.188Z",
    fill: "#EBEBEB"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 243.188H295.891V241.928H293.415V243.188Z",
    fill: "#EBEBEB"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 241.044H299.055V239.783H296.58V241.044Z",
    fill: "#EBEBEB"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 241.044H295.891V239.783H293.415V241.044Z",
    fill: "#EBEBEB"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 238.901H299.055V237.641H296.58V238.901Z",
    fill: "#EBEBEB"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 238.901H295.891V237.641H293.415V238.901Z",
    fill: "#EBEBEB"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 236.762H299.055V235.501H296.58V236.762Z",
    fill: "#EBEBEB"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 236.762H295.891V235.501H293.415V236.762Z",
    fill: "#EBEBEB"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 234.619H299.055V233.358H296.58V234.619Z",
    fill: "#EBEBEB"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 234.619H295.891V233.358H293.415V234.619Z",
    fill: "#EBEBEB"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 232.476H299.055V231.215H296.58V232.476Z",
    fill: "#EBEBEB"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 232.476H295.891V231.215H293.415V232.476Z",
    fill: "#EBEBEB"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 230.331H299.055V229.07H296.58V230.331Z",
    fill: "#EBEBEB"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 230.331H295.891V229.07H293.415V230.331Z",
    fill: "#EBEBEB"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 228.189H299.055V226.929H296.58V228.189Z",
    fill: "#EBEBEB"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 228.189H295.891V226.929H293.415V228.189Z",
    fill: "#EBEBEB"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 226.046H299.055V224.785H296.58V226.046Z",
    fill: "#EBEBEB"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 226.046H295.891V224.785H293.415V226.046Z",
    fill: "#EBEBEB"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 223.903H299.055V222.642H296.58V223.903Z",
    fill: "#EBEBEB"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 223.903H295.891V222.642H293.415V223.903Z",
    fill: "#EBEBEB"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 221.761H299.055V220.5H296.58V221.761Z",
    fill: "#EBEBEB"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 221.761H295.891V220.5H293.415V221.761Z",
    fill: "#EBEBEB"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 219.613H299.055V218.352H296.58V219.613Z",
    fill: "#EBEBEB"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 219.613H295.891V218.352H293.415V219.613Z",
    fill: "#EBEBEB"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M296.58 217.474H299.055V216.213H296.58V217.474Z",
    fill: "#EBEBEB"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M293.415 217.474H295.891V216.213H293.415V217.474Z",
    fill: "#EBEBEB"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M203.908 207.968H197.98V215.146H203.908V207.968Z",
    fill: "#DBDBDB"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M207.671 207.968H203.911V215.408H207.671V207.968Z",
    fill: "#C7C7C7"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M207.921 211.135H204.189V215.406H207.921V211.135Z",
    fill: "#DBDBDB"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M210.248 211.135H207.921V215.406H210.248V211.135Z",
    fill: "#C7C7C7"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M205.296 214.677H195.708V250.379H205.296V214.677Z",
    fill: "#EBEBEB"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 216.213H196.803V217.474H199.818V216.213Z",
    fill: "white"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 216.213H200.661V217.474H203.676V216.213Z",
    fill: "white"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 218.355H196.803V219.616H199.818V218.355Z",
    fill: "white"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 218.355H200.661V219.616H203.676V218.355Z",
    fill: "white"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 220.496H196.803V221.757H199.818V220.496Z",
    fill: "white"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 220.496H200.661V221.757H203.676V220.496Z",
    fill: "white"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 222.64H196.803V223.9H199.818V222.64Z",
    fill: "white"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 222.64H200.661V223.9H203.676V222.64Z",
    fill: "white"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 224.782H196.803V226.043H199.818V224.782Z",
    fill: "white"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 224.782H200.661V226.043H203.676V224.782Z",
    fill: "white"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 226.926H196.803V228.187H199.818V226.926Z",
    fill: "white"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 226.926H200.661V228.187H203.676V226.926Z",
    fill: "white"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 229.069H196.803V230.33H199.818V229.069Z",
    fill: "white"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 229.069H200.661V230.33H203.676V229.069Z",
    fill: "white"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 231.211H196.803V232.472H199.818V231.211Z",
    fill: "white"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 231.211H200.661V232.472H203.676V231.211Z",
    fill: "white"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 233.354H196.803V234.615H199.818V233.354Z",
    fill: "white"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 233.354H200.661V234.615H203.676V233.354Z",
    fill: "white"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 235.499H196.803V236.76H199.818V235.499Z",
    fill: "white"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 235.499H200.661V236.76H203.676V235.499Z",
    fill: "white"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 237.642H196.803V238.902H199.818V237.642Z",
    fill: "white"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 237.642H200.661V238.902H203.676V237.642Z",
    fill: "white"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 239.785H196.803V241.046H199.818V239.785Z",
    fill: "white"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 239.785H200.661V241.046H203.676V239.785Z",
    fill: "white"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 241.928H196.803V243.189H199.818V241.928Z",
    fill: "white"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 241.928H200.661V243.189H203.676V241.928Z",
    fill: "white"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 244.071H196.803V245.332H199.818V244.071Z",
    fill: "white"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M203.676 244.071H200.661V245.332H203.676V244.071Z",
    fill: "white"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M213.064 214.677H205.295V250.379H213.064V214.677Z",
    fill: "#C7C7C7"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 245.333H212.284V244.072H209.809V245.333Z",
    fill: "#EBEBEB"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 245.333H209.121V244.072H206.646V245.333Z",
    fill: "#EBEBEB"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 243.188H212.284V241.928H209.809V243.188Z",
    fill: "#EBEBEB"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 243.188H209.121V241.928H206.646V243.188Z",
    fill: "#EBEBEB"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 241.044H212.284V239.783H209.809V241.044Z",
    fill: "#EBEBEB"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 241.044H209.121V239.783H206.646V241.044Z",
    fill: "#EBEBEB"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 238.901H212.284V237.641H209.809V238.901Z",
    fill: "#EBEBEB"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 238.901H209.121V237.641H206.646V238.901Z",
    fill: "#EBEBEB"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 236.762H212.284V235.501H209.809V236.762Z",
    fill: "#EBEBEB"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 236.762H209.121V235.501H206.646V236.762Z",
    fill: "#EBEBEB"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 234.619H212.284V233.358H209.809V234.619Z",
    fill: "#EBEBEB"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 234.619H209.121V233.358H206.646V234.619Z",
    fill: "#EBEBEB"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 232.476H212.284V231.215H209.809V232.476Z",
    fill: "#EBEBEB"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 232.476H209.121V231.215H206.646V232.476Z",
    fill: "#EBEBEB"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 230.331H212.284V229.07H209.809V230.331Z",
    fill: "#EBEBEB"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 230.331H209.121V229.07H206.646V230.331Z",
    fill: "#EBEBEB"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 228.189H212.284V226.929H209.809V228.189Z",
    fill: "#EBEBEB"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 228.189H209.121V226.929H206.646V228.189Z",
    fill: "#EBEBEB"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 226.046H212.284V224.785H209.809V226.046Z",
    fill: "#EBEBEB"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 226.046H209.121V224.785H206.646V226.046Z",
    fill: "#EBEBEB"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 223.903H212.284V222.642H209.809V223.903Z",
    fill: "#EBEBEB"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 223.903H209.121V222.642H206.646V223.903Z",
    fill: "#EBEBEB"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 221.761H212.284V220.5H209.809V221.761Z",
    fill: "#EBEBEB"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 221.761H209.121V220.5H206.646V221.761Z",
    fill: "#EBEBEB"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 219.613H212.284V218.352H209.809V219.613Z",
    fill: "#EBEBEB"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 219.613H209.121V218.352H206.646V219.613Z",
    fill: "#EBEBEB"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M209.809 217.474H212.284V216.213H209.809V217.474Z",
    fill: "#EBEBEB"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M206.646 217.474H209.121V216.213H206.646V217.474Z",
    fill: "#EBEBEB"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M261.276 227.115H249.969V250.378H261.276V227.115Z",
    fill: "#C7C7C7"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 229.131H251.75V230.555H253.751V229.131Z",
    fill: "#DBDBDB"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 232.173H251.75V233.597H253.751V232.173Z",
    fill: "#DBDBDB"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 235.218H251.75V236.645H253.751V235.218Z",
    fill: "#DBDBDB"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 238.262H251.75V239.686H253.751V238.262Z",
    fill: "#DBDBDB"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 241.307H251.75V242.731H253.751V241.307Z",
    fill: "#DBDBDB"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 244.35H251.75V245.776H253.751V244.35Z",
    fill: "#DBDBDB"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 247.396H251.75V248.819H253.751V247.396Z",
    fill: "#DBDBDB"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 229.131H254.627V230.555H256.628V229.131Z",
    fill: "#DBDBDB"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 232.173H254.627V233.597H256.628V232.173Z",
    fill: "#DBDBDB"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 235.218H254.627V236.645H256.628V235.218Z",
    fill: "#DBDBDB"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 238.262H254.627V239.686H256.628V238.262Z",
    fill: "#DBDBDB"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 241.307H254.627V242.731H256.628V241.307Z",
    fill: "#DBDBDB"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 244.35H254.627V245.776H256.628V244.35Z",
    fill: "#DBDBDB"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M256.628 247.396H254.627V248.819H256.628V247.396Z",
    fill: "#DBDBDB"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 229.131H257.497V230.555H259.498V229.131Z",
    fill: "#DBDBDB"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 232.173H257.497V233.597H259.498V232.173Z",
    fill: "#DBDBDB"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 235.218H257.497V236.645H259.498V235.218Z",
    fill: "#DBDBDB"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 238.262H257.497V239.686H259.498V238.262Z",
    fill: "#DBDBDB"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 241.307H257.497V242.731H259.498V241.307Z",
    fill: "#DBDBDB"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 244.35H257.497V245.776H259.498V244.35Z",
    fill: "#DBDBDB"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 247.396H257.497V248.819H259.498V247.396Z",
    fill: "#DBDBDB"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M261.277 224.691H253.749V227.114H261.277V224.691Z",
    fill: "#DBDBDB"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M261.28 223.189H256.506V224.689H261.28V223.189Z",
    fill: "#EBEBEB"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M269.209 227.115H261.274V250.378H269.209V227.115Z",
    fill: "#A6A6A6"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 248.594H268.396V247.167H266.768V248.594Z",
    fill: "#C7C7C7"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 245.551H268.396V244.127H266.768V245.551Z",
    fill: "#C7C7C7"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 242.504H268.396V241.08H266.768V242.504Z",
    fill: "#C7C7C7"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 239.462H268.396V238.035H266.768V239.462Z",
    fill: "#C7C7C7"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 236.416H268.396V234.992H266.768V236.416Z",
    fill: "#C7C7C7"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 233.372H268.396V231.948H266.768V233.372Z",
    fill: "#C7C7C7"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M266.768 230.326H268.396V228.902H266.768V230.326Z",
    fill: "#C7C7C7"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 248.594H266.054V247.167H264.425V248.594Z",
    fill: "#C7C7C7"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 245.551H266.054V244.127H264.425V245.551Z",
    fill: "#C7C7C7"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 242.504H266.054V241.08H264.425V242.504Z",
    fill: "#C7C7C7"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 239.462H266.054V238.035H264.425V239.462Z",
    fill: "#C7C7C7"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 236.416H266.054V234.992H264.425V236.416Z",
    fill: "#C7C7C7"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 233.372H266.054V231.948H264.425V233.372Z",
    fill: "#C7C7C7"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M264.425 230.326H266.054V228.902H264.425V230.326Z",
    fill: "#C7C7C7"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 248.594H263.717V247.167H262.088V248.594Z",
    fill: "#C7C7C7"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 245.551H263.717V244.127H262.088V245.551Z",
    fill: "#C7C7C7"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 242.504H263.717V241.08H262.088V242.504Z",
    fill: "#C7C7C7"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 239.462H263.717V238.035H262.088V239.462Z",
    fill: "#C7C7C7"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 236.416H263.717V234.992H262.088V236.416Z",
    fill: "#C7C7C7"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 233.372H263.717V231.948H262.088V233.372Z",
    fill: "#C7C7C7"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M262.088 230.326H263.717V228.902H262.088V230.326Z",
    fill: "#C7C7C7"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M268.006 224.691H261.274V227.114H268.006V224.691Z",
    fill: "#C7C7C7"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M264.923 223.189H261.274V224.689H264.923V223.189Z",
    fill: "#DBDBDB"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M243.264 245.473C242.912 245.832 238.837 245.992 237.353 245.992C235.87 245.992 231.795 245.832 231.445 245.473C231.096 245.115 236.032 217.351 237.353 217.351C238.675 217.351 243.614 245.101 243.264 245.473Z",
    fill: "#455A64"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M243.343 238.381C242.337 238.774 238.606 240.332 237.799 240.786V240.265C238.697 239.72 239.601 239.184 240.505 238.646C241.474 238.063 242.514 237.554 243.417 236.872C243.46 236.837 243.437 236.747 243.375 236.77C242.394 237.243 241.444 237.782 240.533 238.384C239.615 238.937 238.709 239.505 237.802 240.075C237.802 238.744 237.802 237.413 237.802 236.083C239.276 235.459 240.701 234.719 242.065 233.87C242.11 233.841 242.079 233.754 242.025 233.777C240.57 234.377 239.161 235.088 237.811 235.906C237.811 235.213 237.811 234.523 237.811 233.829C237.774 230.268 237.768 226.701 237.677 223.137C238.564 222.68 239.473 222.264 240.36 221.818C240.416 221.789 240.377 221.684 240.314 221.707C239.416 222.068 238.552 222.494 237.671 222.89C237.623 221.052 237.555 219.215 237.447 217.377C237.444 217.367 237.438 217.357 237.43 217.35C237.421 217.344 237.411 217.34 237.4 217.34C237.389 217.34 237.379 217.344 237.37 217.35C237.362 217.357 237.356 217.367 237.353 217.377C237.228 220.79 237.239 224.209 237.282 227.624C236.364 226.873 235.387 226.209 234.455 225.484C234.418 225.455 234.384 225.519 234.42 225.545C235.395 226.305 236.307 227.15 237.285 227.907V228.489C236.29 228.023 235.296 227.589 234.278 227.15C234.199 227.115 234.128 227.228 234.207 227.269C235.23 227.773 236.251 228.285 237.288 228.76C237.31 230.452 237.339 232.144 237.362 233.832C237.399 236.788 237.461 239.741 237.524 242.693C235.648 241.723 233.758 240.777 231.854 239.857C231.78 239.822 231.718 239.927 231.789 239.968C233.648 241.058 235.563 242.045 237.526 242.923C237.578 245.375 237.629 247.83 237.657 250.284C237.657 250.315 237.669 250.345 237.69 250.367C237.712 250.389 237.741 250.401 237.771 250.401C237.801 250.401 237.83 250.389 237.851 250.367C237.873 250.345 237.885 250.315 237.885 250.284C237.85 247.154 237.848 244.024 237.839 240.894C238.828 240.643 242.565 239.004 243.451 238.564C243.505 238.506 243.443 238.343 243.343 238.381Z",
    fill: "#37474F"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M192.86 245.571C192.519 245.924 188.538 246.078 187.089 246.078C185.64 246.078 181.661 245.924 181.317 245.571C180.973 245.219 185.799 218.101 187.089 218.101C188.379 218.101 193.204 245.222 192.86 245.571Z",
    fill: "#455A64"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M192.941 238.66C191.958 239.044 188.315 240.564 187.542 241.009C187.542 240.838 187.542 240.669 187.542 240.5C188.423 239.967 189.304 239.443 190.184 238.919C191.161 238.393 192.109 237.814 193.026 237.186C193.069 237.154 193.046 237.064 192.986 237.087C192.026 237.548 191.097 238.075 190.204 238.662C189.306 239.201 188.423 239.757 187.539 240.316C187.539 239.014 187.533 237.714 187.522 236.417C188.959 235.806 190.348 235.083 191.676 234.254C191.722 234.225 191.676 234.14 191.639 234.164C190.217 234.748 188.841 235.443 187.522 236.243C187.522 235.567 187.522 234.892 187.522 234.204C187.485 230.71 187.479 227.239 187.391 223.759C188.244 223.314 189.147 222.921 190.008 222.47C190.065 222.44 190.025 222.338 189.966 222.365C189.09 222.714 188.246 223.131 187.385 223.529C187.34 221.733 187.272 219.939 187.164 218.145C187.161 218.135 187.156 218.126 187.148 218.12C187.14 218.114 187.13 218.11 187.12 218.11C187.11 218.11 187.1 218.114 187.092 218.12C187.084 218.126 187.078 218.135 187.076 218.145C186.953 221.479 186.965 224.816 187.005 228.153C186.109 227.42 185.155 226.773 184.242 226.063C184.208 226.034 184.174 226.095 184.208 226.124C185.16 226.866 186.053 227.688 187.007 228.43V228.995C186.036 228.541 185.049 228.121 184.069 227.688C183.992 227.653 183.924 227.766 184.004 227.804C185.001 228.296 185.993 228.794 187.01 229.26C187.033 230.911 187.061 232.562 187.081 234.21C187.118 237.096 187.181 239.979 187.24 242.864C185.408 241.915 183.562 240.991 181.702 240.092C181.631 240.06 181.571 240.162 181.639 240.203C183.456 241.266 185.326 242.228 187.243 243.086C187.294 245.482 187.343 247.881 187.371 250.278C187.371 250.308 187.383 250.337 187.404 250.358C187.424 250.379 187.453 250.391 187.482 250.391C187.511 250.391 187.54 250.379 187.56 250.358C187.581 250.337 187.593 250.308 187.593 250.278C187.542 247.218 187.542 244.169 187.542 241.103C188.508 240.858 192.157 239.256 193.026 238.817C193.1 238.773 193.038 238.622 192.941 238.66Z",
    fill: "#37474F"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M289.634 244.506C289.216 244.934 284.354 245.123 282.583 245.123C280.813 245.123 275.954 244.934 275.536 244.506C275.118 244.078 281.006 210.958 282.583 210.958C284.16 210.958 290.051 244.078 289.634 244.506Z",
    fill: "#37474F"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M289.732 236.063C288.53 236.535 284.08 238.392 283.12 238.931C283.12 238.724 283.12 238.518 283.12 238.311C284.194 237.662 285.271 237.021 286.348 236.38C287.502 235.69 288.743 235.076 289.82 234.263C289.874 234.226 289.843 234.115 289.772 234.144C288.584 234.651 287.482 235.402 286.362 236.069C285.242 236.736 284.185 237.402 283.108 238.087C283.108 236.501 283.102 234.914 283.088 233.326C284.843 232.579 286.539 231.695 288.161 230.682C288.215 230.65 288.178 230.545 288.113 230.571C286.377 231.288 284.697 232.137 283.086 233.11C283.086 232.286 283.086 231.462 283.069 230.635C283.026 226.387 283.017 222.133 282.909 217.881C283.967 217.337 285.052 216.856 286.106 216.306C286.177 216.271 286.129 216.146 286.055 216.175C284.984 216.603 283.952 217.112 282.904 217.584C282.844 215.392 282.764 213.216 282.634 211.012C282.631 210.999 282.624 210.988 282.614 210.98C282.604 210.971 282.591 210.967 282.578 210.967C282.565 210.967 282.553 210.971 282.543 210.98C282.533 210.988 282.526 210.999 282.523 211.012C282.375 215.089 282.387 219.165 282.438 223.242C281.344 222.348 280.164 221.559 279.065 220.691C279.022 220.656 278.982 220.732 279.022 220.764C280.187 221.672 281.275 222.677 282.432 223.58V224.273C281.247 223.717 280.045 223.198 278.846 222.674C278.752 222.633 278.67 222.77 278.766 222.817C279.985 223.417 281.202 224.028 282.438 224.593C282.466 226.611 282.5 228.629 282.526 230.647C282.568 234.17 282.645 237.694 282.719 241.217C280.48 240.052 278.225 238.924 275.956 237.833C275.87 237.793 275.794 237.918 275.879 237.967C278.102 239.263 280.392 240.435 282.739 241.476C282.799 244.405 282.858 247.332 282.895 250.261C282.895 250.3 282.91 250.337 282.937 250.364C282.963 250.391 283 250.407 283.037 250.407C283.075 250.407 283.111 250.391 283.138 250.364C283.164 250.337 283.179 250.3 283.179 250.261C283.14 246.525 283.134 242.792 283.123 239.059C284.302 238.768 288.76 236.803 289.82 236.267C289.926 236.211 289.843 236.019 289.732 236.063Z",
    fill: "#455A64"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M205.092 244.506C204.674 244.934 199.812 245.123 198.044 245.123C196.277 245.123 191.412 244.934 190.994 244.506C190.576 244.078 196.467 210.958 198.055 210.958C199.644 210.958 205.509 244.078 205.092 244.506Z",
    fill: "#37474F"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M205.192 236.064C203.99 236.536 199.54 238.394 198.576 238.932V238.312C199.648 237.663 200.725 237.022 201.802 236.382C202.958 235.691 204.2 235.077 205.277 234.265C205.328 234.227 205.3 234.116 205.226 234.145C204.038 234.652 202.935 235.403 201.816 236.07C200.696 236.737 199.639 237.404 198.559 238.088C198.559 236.502 198.553 234.915 198.539 233.327C200.294 232.582 201.99 231.698 203.612 230.683C203.669 230.651 203.632 230.546 203.566 230.572C201.831 231.288 200.15 232.137 198.539 233.112C198.539 232.287 198.539 231.463 198.522 230.636C198.477 226.388 198.468 222.134 198.363 217.882C199.417 217.338 200.506 216.857 201.56 216.307C201.628 216.272 201.58 216.147 201.506 216.176C200.438 216.604 199.406 217.114 198.355 217.585C198.298 215.393 198.215 213.218 198.085 211.013C198.085 210.999 198.079 210.985 198.069 210.974C198.059 210.964 198.045 210.958 198.031 210.958C198.016 210.958 198.003 210.964 197.992 210.974C197.982 210.985 197.977 210.999 197.977 211.013C197.826 215.09 197.84 219.167 197.889 223.243C196.797 222.349 195.632 221.56 194.518 220.692C194.476 220.657 194.433 220.733 194.476 220.765C195.638 221.674 196.726 222.678 197.886 223.581V224.274C196.701 223.718 195.496 223.2 194.299 222.675C194.206 222.635 194.12 222.771 194.217 222.818C195.439 223.418 196.655 224.029 197.889 224.594C197.917 226.612 197.951 228.63 197.977 230.648C198.022 234.171 198.096 237.695 198.17 241.218C195.932 240.053 193.679 238.926 191.409 237.835C191.321 237.794 191.247 237.919 191.333 237.969C193.55 239.267 195.834 240.443 198.176 241.489C198.238 244.418 198.29 247.347 198.332 250.274C198.332 250.313 198.347 250.35 198.373 250.377C198.4 250.404 198.436 250.42 198.474 250.42C198.512 250.42 198.548 250.404 198.574 250.377C198.601 250.35 198.616 250.313 198.616 250.274C198.576 246.538 198.571 242.805 198.562 239.072C199.741 238.781 204.197 236.815 205.257 236.28C205.382 236.213 205.305 236.02 205.192 236.064Z",
    fill: "#455A64"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M217.137 246.517C217.421 246.808 220.612 246.925 221.777 246.925C222.942 246.925 226.139 246.8 226.415 246.517C226.691 246.235 222.815 224.442 221.777 224.442C220.74 224.442 216.864 246.238 217.137 246.517Z",
    fill: "#455A64"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M217.072 240.964C217.862 241.273 220.792 242.496 221.423 242.851C221.423 242.714 221.423 242.58 221.423 242.443C220.715 242.015 220.002 241.596 219.297 241.174C218.516 240.75 217.757 240.285 217.024 239.779C216.99 239.756 217.024 239.68 217.055 239.7C217.827 240.071 218.574 240.494 219.292 240.967C220.014 241.401 220.713 241.84 221.434 242.295C221.434 241.252 221.434 240.207 221.449 239.161C220.293 238.669 219.177 238.085 218.11 237.414C218.073 237.394 218.11 237.324 218.141 237.342C219.282 237.814 220.388 238.373 221.449 239.013C221.449 238.471 221.449 237.927 221.449 237.385C221.477 234.587 221.483 231.789 221.551 228.99C220.858 228.632 220.13 228.315 219.448 227.954C219.403 227.93 219.434 227.849 219.485 227.869C220.187 228.16 220.866 228.484 221.557 228.795C221.596 227.354 221.65 225.91 221.736 224.471C221.734 224.465 221.734 224.46 221.735 224.454C221.736 224.448 221.738 224.443 221.742 224.438C221.745 224.433 221.75 224.429 221.755 224.427C221.76 224.424 221.765 224.423 221.771 224.423C221.777 224.423 221.782 224.424 221.788 224.427C221.793 224.429 221.797 224.433 221.801 224.438C221.804 224.443 221.806 224.448 221.807 224.454C221.808 224.46 221.808 224.465 221.807 224.471C221.906 227.15 221.898 229.829 221.863 232.511C222.582 231.928 223.35 231.401 224.083 230.831C224.111 230.81 224.14 230.86 224.111 230.88C223.344 231.477 222.628 232.138 221.861 232.735C221.861 232.886 221.861 233.026 221.861 233.189C222.642 232.822 223.432 232.482 224.222 232.138C224.282 232.109 224.339 232.199 224.276 232.231C223.472 232.627 222.671 233.029 221.858 233.396C221.841 234.724 221.818 236.052 221.801 237.379C221.773 239.709 221.721 242.015 221.673 244.333C223.145 243.57 224.628 242.828 226.123 242.105C226.135 242.1 226.148 242.099 226.16 242.103C226.172 242.107 226.183 242.115 226.189 242.127C226.195 242.138 226.197 242.151 226.195 242.164C226.192 242.177 226.185 242.188 226.174 242.196C224.714 243.053 223.211 243.831 221.67 244.525C221.63 246.45 221.591 248.378 221.568 250.302C221.564 250.324 221.553 250.343 221.537 250.357C221.52 250.371 221.5 250.379 221.478 250.379C221.457 250.379 221.436 250.371 221.42 250.357C221.404 250.343 221.393 250.324 221.389 250.302C221.414 247.845 221.42 245.39 221.426 242.932C220.65 242.734 217.717 241.447 217.018 241.095C216.944 241.063 216.996 240.935 217.072 240.964Z",
    fill: "#37474F"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M289.633 246.517C289.917 246.808 293.108 246.925 294.273 246.925C295.438 246.925 298.635 246.8 298.911 246.517C299.187 246.235 295.311 224.442 294.273 224.442C293.236 224.442 289.36 246.238 289.633 246.517Z",
    fill: "#455A64"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M289.56 240.964C290.35 241.273 293.28 242.496 293.911 242.851C293.911 242.714 293.911 242.58 293.911 242.443C293.203 242.015 292.49 241.596 291.785 241.174C291.004 240.75 290.245 240.285 289.512 239.779C289.477 239.756 289.512 239.68 289.543 239.7C290.315 240.071 291.062 240.494 291.779 240.967C292.501 241.401 293.2 241.84 293.922 242.295C293.922 241.252 293.922 240.207 293.936 239.161C292.781 238.669 291.664 238.085 290.597 237.414C290.56 237.394 290.597 237.324 290.628 237.342C291.77 237.814 292.876 238.373 293.936 239.013C293.936 238.471 293.936 237.927 293.936 237.385C293.965 234.587 293.97 231.789 294.038 228.99C293.345 228.632 292.618 228.315 291.936 227.954C291.89 227.93 291.921 227.849 291.973 227.869C292.674 228.16 293.354 228.484 294.044 228.795C294.084 227.354 294.138 225.91 294.223 224.471C294.222 224.465 294.221 224.46 294.222 224.454C294.223 224.448 294.226 224.443 294.229 224.438C294.233 224.433 294.237 224.429 294.242 224.427C294.247 224.424 294.253 224.423 294.259 224.423C294.264 224.423 294.27 224.424 294.275 224.427C294.28 224.429 294.285 224.433 294.288 224.438C294.292 224.443 294.294 224.448 294.295 224.454C294.296 224.46 294.296 224.465 294.294 224.471C294.394 227.15 294.385 229.829 294.351 232.511C295.07 231.928 295.837 231.401 296.57 230.831C296.599 230.81 296.627 230.86 296.599 230.88C295.832 231.477 295.115 232.138 294.348 232.735C294.348 232.886 294.348 233.026 294.348 233.189C295.13 232.822 295.92 232.482 296.71 232.138C296.769 232.109 296.826 232.199 296.764 232.231C295.959 232.627 295.158 233.029 294.345 233.396C294.328 234.724 294.306 236.052 294.289 237.379C294.26 239.709 294.209 242.015 294.161 244.333C295.633 243.57 297.116 242.828 298.611 242.105C298.622 242.1 298.636 242.099 298.648 242.103C298.66 242.107 298.67 242.115 298.677 242.127C298.683 242.138 298.685 242.151 298.682 242.164C298.68 242.177 298.672 242.188 298.662 242.196C297.202 243.053 295.698 243.831 294.158 244.525C294.118 246.45 294.078 248.378 294.055 250.302C294.052 250.324 294.041 250.343 294.024 250.357C294.008 250.371 293.987 250.379 293.966 250.379C293.945 250.379 293.924 250.371 293.908 250.357C293.891 250.343 293.88 250.324 293.876 250.302C293.902 247.845 293.908 245.39 293.913 242.932C293.138 242.734 290.205 241.447 289.506 241.095C289.443 241.063 289.495 240.935 289.56 240.964Z",
    fill: "#37474F"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M209.119 250.405H192.921C192.921 250.405 192.958 247.936 194.549 247.281C194.981 247.088 195.463 247.045 195.921 247.158C196.379 247.27 196.789 247.532 197.09 247.904C197.09 247.904 197.738 243.361 200.704 243.361C203.671 243.361 205.092 247.281 205.092 247.281C205.092 247.281 205.757 246.096 207.402 246.317C209.048 246.538 209.119 250.405 209.119 250.405Z",
    fill: "#455A64"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M299.335 250.404C299.335 250.404 298.838 248.031 297.846 247.664C296.854 247.298 296.252 248.363 296.252 248.363C296.252 248.363 296.019 246.098 294.612 245.416C293.205 244.735 292.151 246.13 292.151 246.13C292.151 246.13 291.071 243.25 289.145 243.25C287.218 243.25 286.246 247.461 286.246 247.461C286.246 247.461 285.109 246.206 283.941 246.916C282.774 247.627 282.776 250.41 282.776 250.41L299.335 250.404Z",
    fill: "#37474F"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M195.825 250.403H180.892C180.892 250.403 181.383 248.246 182.375 248.094C183.367 247.943 183.824 248.942 183.824 248.942C183.824 248.942 183.779 245.931 185.629 245.418C187.479 244.906 189.039 247.564 189.039 247.564C189.039 247.564 190.198 246.05 191.778 246.146C193.358 246.242 193.767 248.749 193.767 248.749C193.767 248.749 195.191 247.879 195.825 250.403Z",
    fill: "#37474F"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M283.846 250.404H274.67C274.67 250.404 274.69 249.004 275.593 248.634C275.838 248.525 276.111 248.5 276.37 248.563C276.629 248.627 276.862 248.775 277.031 248.986C277.031 248.986 277.398 246.415 279.08 246.415C280.763 246.415 281.564 248.634 281.564 248.634C281.707 248.422 281.906 248.257 282.139 248.16C282.372 248.063 282.627 248.037 282.874 248.086C283.809 248.212 283.846 250.404 283.846 250.404Z",
    fill: "#455A64"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M179.809 250.394L194.884 250.324L209.962 250.298L240.113 250.251L270.263 250.298L285.339 250.324L300.417 250.394L285.339 250.466L270.263 250.493L240.113 250.539L209.962 250.493L194.884 250.466L179.809 250.394Z",
    fill: "#263238"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M558.06 220.903H545.739V249.475H558.06V220.903Z",
    fill: "#FFC727"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M558.06 220.903H545.739V249.475H558.06V220.903Z",
    fill: "black"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M552.729 220.903H534.095V249.475H552.729V220.903Z",
    fill: "#FFC727"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M549.729 233.13H551.002V232.579H549.729V233.13Z",
    fill: "black"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M550.44 232.437H551.713V231.885H550.44V232.437Z",
    fill: "black"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M549.024 232.437H550.297V231.885H549.024V232.437Z",
    fill: "black"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M547.674 225.216H546.401V225.767H547.674V225.216Z",
    fill: "black"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M548.383 225.91H547.11V226.461H548.383V225.91Z",
    fill: "black"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M555.259 240.717H553.986V241.268H555.259V240.717Z",
    fill: "black"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M555.967 241.412H554.694V241.963H555.967V241.412Z",
    fill: "black"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M535.13 232.437H536.403V231.885H535.13V232.437Z",
    fill: "black"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M554.727 248.308H556V247.757H554.727V248.308Z",
    fill: "black"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M556.456 227.619H557.729V227.068H556.456V227.619Z",
    fill: "black"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M535.13 246.234H536.403V245.683H535.13V246.234Z",
    fill: "black"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M534.42 245.54H535.693V244.989H534.42V245.54Z",
    fill: "black"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M550.44 246.234H551.713V245.683H550.44V246.234Z",
    fill: "black"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M547.674 237.539H546.401V238.09H547.674V237.539Z",
    fill: "black"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M546.965 238.233H545.692V238.784H546.965V238.233Z",
    fill: "black"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M537.115 222.053H535.842V222.604H537.115V222.053Z",
    fill: "black"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M536.403 222.748H535.13V223.299H536.403V222.748Z",
    fill: "black"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M541.841 222.748H540.568V223.299H541.841V222.748Z",
    fill: "black"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M553.07 236.412H533.752V236.969H553.07V236.412Z",
    fill: "white"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M553.07 233.485H533.752V234.043H553.07V233.485Z",
    fill: "white"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M534.095 236.411V234.039H552.726V236.411",
    fill: "#EBEBEB"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M543.411 231.808C542.75 231.808 542.103 232.008 541.554 232.385C541.004 232.761 540.576 233.296 540.323 233.922C540.07 234.548 540.004 235.236 540.133 235.9C540.262 236.565 540.58 237.175 541.047 237.654C541.515 238.133 542.11 238.459 542.759 238.591C543.407 238.723 544.079 238.656 544.69 238.396C545.3 238.137 545.822 237.698 546.189 237.135C546.557 236.572 546.753 235.91 546.753 235.232C546.753 234.324 546.401 233.453 545.774 232.811C545.147 232.168 544.297 231.808 543.411 231.808ZM543.411 236.412C543.182 236.412 542.958 236.343 542.767 236.212C542.577 236.082 542.429 235.897 542.341 235.68C542.253 235.463 542.231 235.225 542.275 234.995C542.32 234.765 542.43 234.553 542.592 234.387C542.754 234.221 542.96 234.108 543.185 234.063C543.409 234.017 543.642 234.04 543.854 234.13C544.065 234.22 544.246 234.372 544.373 234.567C544.5 234.762 544.568 234.991 544.568 235.226C544.569 235.382 544.539 235.536 544.481 235.681C544.423 235.825 544.338 235.956 544.23 236.066C544.122 236.176 543.995 236.263 543.854 236.323C543.713 236.382 543.563 236.413 543.411 236.412V236.412Z",
    fill: "#FFC727"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M543.411 231.808C542.75 231.808 542.103 232.008 541.554 232.385C541.004 232.761 540.576 233.296 540.323 233.922C540.07 234.548 540.004 235.236 540.133 235.9C540.262 236.565 540.58 237.175 541.047 237.654C541.515 238.133 542.11 238.459 542.759 238.591C543.407 238.723 544.079 238.656 544.69 238.396C545.3 238.137 545.822 237.698 546.189 237.135C546.557 236.572 546.753 235.91 546.753 235.232C546.753 234.324 546.401 233.453 545.774 232.811C545.147 232.168 544.297 231.808 543.411 231.808ZM543.411 236.412C543.182 236.412 542.958 236.343 542.767 236.212C542.577 236.082 542.429 235.897 542.341 235.68C542.253 235.463 542.231 235.225 542.275 234.995C542.32 234.765 542.43 234.553 542.592 234.387C542.754 234.221 542.96 234.108 543.185 234.063C543.409 234.017 543.642 234.04 543.854 234.13C544.065 234.22 544.246 234.372 544.373 234.567C544.5 234.762 544.568 234.991 544.568 235.226C544.569 235.382 544.539 235.536 544.481 235.681C544.423 235.825 544.338 235.956 544.23 236.066C544.122 236.176 543.995 236.263 543.854 236.323C543.713 236.382 543.563 236.413 543.411 236.412V236.412Z",
    fill: "black"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M541.33 236.885H541.048C541.021 236.885 540.995 236.874 540.977 236.855C540.958 236.836 540.947 236.81 540.947 236.782C540.947 236.769 540.95 236.756 540.955 236.743C540.96 236.731 540.967 236.72 540.977 236.711C540.986 236.701 540.997 236.694 541.009 236.689C541.022 236.685 541.035 236.682 541.048 236.683H541.33C541.343 236.682 541.356 236.685 541.368 236.689C541.38 236.694 541.391 236.701 541.401 236.711C541.41 236.72 541.418 236.731 541.423 236.743C541.428 236.756 541.43 236.769 541.43 236.782V236.782C541.43 236.81 541.42 236.836 541.401 236.855C541.382 236.874 541.357 236.885 541.33 236.885V236.885Z",
    fill: "#FFC727"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M545.392 234.741H545.109C545.082 234.741 545.057 234.731 545.038 234.711C545.019 234.692 545.009 234.666 545.009 234.639C545.009 234.625 545.011 234.612 545.016 234.6C545.022 234.588 545.029 234.576 545.038 234.567C545.048 234.558 545.059 234.551 545.071 234.546C545.083 234.541 545.096 234.539 545.109 234.539H545.392C545.405 234.539 545.418 234.541 545.43 234.546C545.442 234.551 545.453 234.558 545.462 234.567C545.472 234.576 545.479 234.588 545.484 234.6C545.489 234.612 545.492 234.625 545.492 234.639V234.639C545.492 234.666 545.481 234.692 545.463 234.711C545.444 234.731 545.418 234.741 545.392 234.741V234.741Z",
    fill: "#FFC727"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M544.45 237.276H544.168C544.141 237.276 544.116 237.265 544.097 237.246C544.078 237.226 544.067 237.2 544.067 237.173C544.067 237.16 544.07 237.146 544.075 237.134C544.08 237.122 544.088 237.111 544.097 237.101C544.106 237.092 544.117 237.085 544.13 237.08C544.142 237.075 544.155 237.073 544.168 237.073H544.45C544.463 237.073 544.476 237.075 544.488 237.08C544.501 237.085 544.512 237.092 544.521 237.101C544.53 237.111 544.538 237.122 544.543 237.134C544.548 237.146 544.55 237.16 544.55 237.173V237.173C544.55 237.2 544.54 237.226 544.521 237.246C544.502 237.265 544.477 237.276 544.45 237.276V237.276Z",
    fill: "white"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M541.311 233.624H541.007C540.981 233.624 540.955 233.613 540.937 233.594C540.918 233.575 540.907 233.549 540.907 233.522V233.522C540.907 233.508 540.91 233.495 540.915 233.483C540.92 233.47 540.927 233.459 540.937 233.45C540.946 233.441 540.957 233.433 540.969 233.429C540.982 233.424 540.994 233.422 541.007 233.422H541.311C541.324 233.422 541.337 233.424 541.349 233.429C541.362 233.433 541.373 233.441 541.382 233.45C541.391 233.459 541.399 233.47 541.404 233.483C541.409 233.495 541.412 233.508 541.412 233.522V233.522C541.412 233.549 541.401 233.575 541.382 233.594C541.363 233.613 541.338 233.624 541.311 233.624V233.624Z",
    fill: "white"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M541.771 234.742V234.452C541.771 234.425 541.782 234.399 541.801 234.38C541.82 234.36 541.845 234.35 541.872 234.35V234.35C541.885 234.35 541.898 234.352 541.91 234.357C541.922 234.363 541.933 234.37 541.942 234.38C541.951 234.389 541.958 234.401 541.962 234.413C541.967 234.426 541.969 234.439 541.969 234.452V234.742C541.969 234.755 541.967 234.769 541.962 234.781C541.958 234.793 541.951 234.805 541.942 234.814C541.933 234.824 541.922 234.832 541.91 234.837C541.898 234.842 541.885 234.845 541.872 234.845V234.845C541.845 234.845 541.82 234.834 541.801 234.815C541.782 234.795 541.771 234.769 541.771 234.742V234.742Z",
    fill: "#FFC727"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M546.113 235.964V235.678C546.113 235.664 546.116 235.651 546.121 235.639C546.126 235.627 546.134 235.616 546.143 235.606C546.152 235.597 546.163 235.59 546.176 235.585C546.188 235.58 546.201 235.578 546.214 235.578V235.578C546.227 235.578 546.24 235.58 546.252 235.585C546.264 235.59 546.275 235.597 546.284 235.606C546.294 235.616 546.301 235.627 546.306 235.639C546.311 235.651 546.314 235.664 546.314 235.678V235.97C546.314 235.984 546.311 235.997 546.306 236.009C546.301 236.022 546.294 236.033 546.284 236.042C546.275 236.051 546.264 236.059 546.252 236.063C546.24 236.068 546.227 236.071 546.214 236.07V236.07C546.2 236.071 546.187 236.068 546.174 236.063C546.162 236.058 546.15 236.05 546.141 236.04C546.131 236.03 546.124 236.018 546.119 236.005C546.115 235.992 546.113 235.978 546.113 235.964V235.964Z",
    fill: "white"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M543.279 233.522V233.233C543.279 233.205 543.29 233.179 543.309 233.16C543.327 233.141 543.353 233.13 543.38 233.13V233.13C543.406 233.13 543.432 233.141 543.45 233.16C543.469 233.179 543.48 233.205 543.48 233.233V233.522C543.48 233.549 543.469 233.576 543.45 233.595C543.432 233.614 543.406 233.625 543.38 233.625C543.353 233.625 543.327 233.614 543.309 233.595C543.29 233.576 543.279 233.549 543.279 233.522Z",
    fill: "white"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M542.48 236.991L542.28 236.788C542.27 236.779 542.263 236.767 542.258 236.755C542.253 236.742 542.25 236.729 542.25 236.715C542.25 236.701 542.253 236.688 542.258 236.675C542.263 236.663 542.27 236.651 542.28 236.642V236.642C542.289 236.632 542.3 236.625 542.313 236.619C542.325 236.614 542.338 236.611 542.351 236.611C542.365 236.611 542.378 236.614 542.39 236.619C542.402 236.625 542.413 236.632 542.423 236.642L542.623 236.847C542.641 236.867 542.65 236.893 542.65 236.919C542.65 236.946 542.641 236.971 542.623 236.991C542.614 237 542.603 237.008 542.591 237.013C542.578 237.019 542.565 237.021 542.552 237.021C542.539 237.021 542.525 237.019 542.513 237.013C542.501 237.008 542.49 237 542.48 236.991V236.991Z",
    fill: "white"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M545.673 233.776L545.472 233.57C545.463 233.561 545.455 233.55 545.45 233.537C545.445 233.525 545.442 233.512 545.442 233.498C545.442 233.485 545.445 233.472 545.45 233.46C545.455 233.447 545.463 233.436 545.472 233.427C545.481 233.417 545.492 233.41 545.504 233.404C545.516 233.399 545.529 233.396 545.542 233.396C545.555 233.396 545.568 233.399 545.58 233.404C545.592 233.41 545.603 233.417 545.612 233.427L545.812 233.632C545.822 233.642 545.829 233.653 545.834 233.665C545.839 233.677 545.842 233.691 545.842 233.704C545.842 233.717 545.839 233.731 545.834 233.743C545.829 233.755 545.822 233.766 545.812 233.776V233.776C545.803 233.785 545.792 233.793 545.78 233.798C545.768 233.803 545.755 233.806 545.742 233.806C545.729 233.806 545.716 233.803 545.704 233.798C545.692 233.793 545.682 233.785 545.673 233.776V233.776Z",
    fill: "white"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M545.279 236.502L545.078 236.297C545.069 236.288 545.062 236.276 545.057 236.264C545.051 236.252 545.049 236.239 545.049 236.225C545.049 236.212 545.051 236.199 545.057 236.186C545.062 236.174 545.069 236.163 545.078 236.154V236.154C545.088 236.144 545.099 236.136 545.111 236.131C545.123 236.126 545.137 236.123 545.15 236.123C545.163 236.123 545.176 236.126 545.189 236.131C545.201 236.136 545.212 236.144 545.221 236.154L545.422 236.359C545.439 236.379 545.449 236.404 545.449 236.431C545.449 236.457 545.439 236.483 545.422 236.502C545.412 236.512 545.401 236.52 545.389 236.525C545.377 236.53 545.364 236.533 545.35 236.533C545.337 236.533 545.324 236.53 545.312 236.525C545.299 236.52 545.288 236.512 545.279 236.502Z",
    fill: "#FFC727"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M542.349 233.031L542.149 232.828C542.131 232.808 542.121 232.782 542.121 232.755C542.121 232.728 542.131 232.702 542.149 232.682V232.682C542.158 232.672 542.169 232.665 542.181 232.659C542.194 232.654 542.207 232.651 542.22 232.651C542.233 232.651 542.246 232.654 542.259 232.659C542.271 232.665 542.282 232.672 542.291 232.682L542.492 232.887C542.509 232.907 542.519 232.933 542.519 232.959C542.519 232.986 542.509 233.011 542.492 233.031C542.483 233.04 542.472 233.048 542.459 233.053C542.447 233.059 542.434 233.061 542.421 233.061C542.407 233.061 542.394 233.059 542.382 233.053C542.37 233.048 542.358 233.04 542.349 233.031V233.031Z",
    fill: "#FFC727"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M540.846 235.428L541.046 235.222C541.055 235.212 541.067 235.205 541.079 235.199C541.091 235.194 541.104 235.191 541.118 235.191C541.131 235.191 541.144 235.194 541.156 235.199C541.168 235.205 541.18 235.212 541.189 235.222C541.198 235.231 541.206 235.242 541.211 235.255C541.216 235.267 541.219 235.28 541.219 235.294C541.219 235.307 541.216 235.32 541.211 235.333C541.206 235.345 541.198 235.356 541.189 235.365L540.988 235.571C540.979 235.58 540.968 235.588 540.956 235.593C540.943 235.599 540.93 235.601 540.917 235.601C540.904 235.601 540.891 235.599 540.878 235.593C540.866 235.588 540.855 235.58 540.846 235.571V235.571C540.828 235.551 540.818 235.526 540.818 235.499C540.818 235.473 540.828 235.447 540.846 235.428V235.428Z",
    fill: "white"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M543.109 237.911L543.31 237.709C543.319 237.699 543.329 237.692 543.341 237.687C543.353 237.681 543.366 237.679 543.379 237.679C543.392 237.679 543.405 237.681 543.417 237.687C543.429 237.692 543.44 237.699 543.449 237.709C543.459 237.718 543.466 237.729 543.471 237.742C543.476 237.754 543.479 237.767 543.479 237.781C543.479 237.794 543.476 237.807 543.471 237.82C543.466 237.832 543.459 237.843 543.449 237.852L543.252 238.058C543.242 238.067 543.231 238.075 543.219 238.08C543.207 238.086 543.194 238.088 543.18 238.088C543.167 238.088 543.154 238.086 543.142 238.08C543.129 238.075 543.118 238.067 543.109 238.058V238.058C543.1 238.048 543.092 238.037 543.087 238.024C543.082 238.012 543.079 237.998 543.079 237.985C543.079 237.971 543.082 237.958 543.087 237.945C543.092 237.932 543.1 237.921 543.109 237.911Z",
    fill: "#FFC727"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M544.397 232.788L544.598 232.582C544.607 232.573 544.618 232.565 544.63 232.56C544.642 232.554 544.654 232.552 544.667 232.552C544.681 232.552 544.693 232.554 544.705 232.56C544.717 232.565 544.728 232.573 544.737 232.582C544.747 232.592 544.754 232.603 544.759 232.616C544.765 232.628 544.767 232.642 544.767 232.655C544.767 232.669 544.765 232.682 544.759 232.695C544.754 232.707 544.747 232.719 544.737 232.728L544.537 232.934C544.518 232.952 544.493 232.962 544.467 232.962C544.441 232.962 544.416 232.952 544.397 232.934V232.934C544.388 232.924 544.38 232.913 544.375 232.9C544.37 232.888 544.367 232.874 544.367 232.861C544.367 232.847 544.37 232.834 544.375 232.821C544.38 232.809 544.388 232.797 544.397 232.788V232.788Z",
    fill: "#FFC727"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M553.07 224.257H533.752V224.814H553.07V224.257Z",
    fill: "#FFC727"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M553.07 224.257H533.752V224.814H553.07V224.257Z",
    fill: "black"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M553.07 220.35H533.752V220.907H553.07V220.35Z",
    fill: "#FFC727"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M553.07 220.35H533.752V220.907H553.07V220.35Z",
    fill: "black"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M558.382 220.35H553.068V220.907H558.382V220.35Z",
    fill: "#FFC727"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M558.382 220.35H553.068V220.907H558.382V220.35Z",
    fill: "black"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M558.382 248.921H553.068V249.478H558.382V248.921Z",
    fill: "#FFC727"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M558.382 248.921H553.068V249.478H558.382V248.921Z",
    fill: "black"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M553.07 248.921H533.752V249.478H553.07V248.921Z",
    fill: "#FFC727"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M553.07 248.921H533.752V249.478H553.07V248.921Z",
    fill: "black"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M539.483 226.007H536.037V231.412H539.483V226.007Z",
    fill: "white"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M539.201 226.297H536.317V231.129H539.201V226.297Z",
    fill: "#263238"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.201 226.297V226.879L536.317 229.834V228.433L538.405 226.297H539.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.199 229.351V230.748L538.831 231.125H537.464L539.199 229.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.2 228.733V229.029L537.155 231.124H536.866L539.2 228.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.113 226.297L536.317 228.137V227.558L537.548 226.297H538.113Z",
    fill: "white"
  }))), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M539.201 227.679H536.317V227.965H539.201V227.679Z",
    fill: "white"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M545.133 226.007H541.688V231.412H545.133V226.007Z",
    fill: "white"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M544.85 226.297H541.967V231.129H544.85V226.297Z",
    fill: "#263238"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.852 226.297V226.879L541.966 229.834V228.433L544.053 226.297H544.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.853 229.351V230.748L544.482 231.125H543.118L544.853 229.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.852 228.733V229.029L542.807 231.124H542.519L544.852 228.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.761 226.297L541.966 228.137V227.558L543.196 226.297H543.761Z",
    fill: "white"
  }))), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M544.85 227.679H541.967V227.965H544.85V227.679Z",
    fill: "white"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M550.787 226.007H547.342V231.412H550.787V226.007Z",
    fill: "white"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M550.505 226.297H547.622V231.129H550.505V226.297Z",
    fill: "#263238"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.503 226.297V226.879L547.619 229.834V228.433L549.706 226.297H550.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.501 229.351V230.748L550.133 231.125H548.766L550.501 229.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.501 228.733V229.029L548.457 231.124H548.168L550.501 228.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.415 226.297L547.619 228.137V227.558L548.85 226.297H549.415Z",
    fill: "white"
  }))), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M550.505 227.679H547.622V227.965H550.505V227.679Z",
    fill: "white"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M539.483 221.626H536.037V223.584H539.483V221.626Z",
    fill: "white"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M539.201 221.913H536.317V223.299H539.201V221.913Z",
    fill: "#263238"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.201 221.913V222.498L538.42 223.299H537.053L538.405 221.913H539.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.113 221.913L536.761 223.299H536.317V223.174L537.548 221.913H538.113Z",
    fill: "white"
  }))), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M545.133 221.626H541.688V223.584H545.133V221.626Z",
    fill: "white"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M544.854 221.913H541.971V223.299H544.854V221.913Z",
    fill: "#263238"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.854 221.913V222.498L544.07 223.299H542.703L544.055 221.913H544.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.765 221.913L542.412 223.299H541.966V223.174L543.199 221.913H543.765Z",
    fill: "white"
  }))), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M550.787 221.626H547.342V223.584H550.787V221.626Z",
    fill: "white"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M550.505 221.913H547.622V223.299H550.505V221.913Z",
    fill: "#263238"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.504 221.913V222.498L549.723 223.299H548.355L549.708 221.913H550.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.415 221.913L548.063 223.299H547.619V223.174L548.85 221.913H549.415Z",
    fill: "white"
  }))), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M551.602 239.163H547.297V249.475H551.602V239.163Z",
    fill: "white"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M550.963 239.836H547.939V248.335H550.963V239.836Z",
    fill: "#263238"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.963 246.708V248.174L550.802 248.339H549.371L550.963 246.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.964 239.839V240.337L547.94 243.438V241.968L550.019 239.839H550.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.964 240.941V241.253L547.94 244.351V244.042L550.964 240.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.964 244.347V244.655L547.94 247.756V247.444L550.964 244.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.779 239.839L547.94 240.698V240.091L548.187 239.839H548.779Z",
    fill: "white"
  }))), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M551.417 245.145H551.152V246.016H551.417V245.145Z",
    fill: "#A6A6A6"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M550.963 244.86H547.939V245.144H550.963V244.86Z",
    fill: "white"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M545.911 239.163H535.222V247.485H545.911V239.163Z",
    fill: "white"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M545.645 239.446H535.487V247.202H545.645V239.446Z",
    fill: "#263238"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.644 244.186V245.655L544.131 247.206H542.7L545.644 244.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.431 239.45L535.488 245.537V244.07L540 239.45H541.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.322 239.45L535.488 246.449V246.141L542.021 239.45H542.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.645 241.825V242.137L540.698 247.205H540.397L545.645 241.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.646 246.212V246.819L545.272 247.205H544.68L545.646 246.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.758 239.45L535.488 242.797V242.19L538.165 239.45H538.758Z",
    fill: "white"
  }))), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M546.915 239.172L546.879 239.178L547.28 241.795L547.316 241.789L546.915 239.172Z",
    fill: "#263238"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M547.294 241.875C547.332 241.875 547.363 241.843 547.363 241.803C547.363 241.763 547.332 241.731 547.294 241.731C547.255 241.731 547.224 241.763 547.224 241.803C547.224 241.843 547.255 241.875 547.294 241.875Z",
    fill: "white"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M551.61 241.807L551.576 241.801L551.977 239.186L552.011 239.189L551.61 241.807Z",
    fill: "#263238"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M551.521 241.803C551.522 241.822 551.53 241.84 551.543 241.853C551.556 241.866 551.573 241.874 551.591 241.875C551.61 241.875 551.628 241.867 551.641 241.854C551.654 241.84 551.661 241.822 551.661 241.803C551.661 241.784 551.654 241.766 551.641 241.752C551.628 241.739 551.61 241.731 551.591 241.731C551.573 241.731 551.555 241.739 551.542 241.752C551.529 241.766 551.521 241.784 551.521 241.803Z",
    fill: "white"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M552.065 239.167H546.824C547.118 238.665 547.323 238.114 547.432 237.539H551.452C551.562 238.114 551.77 238.665 552.065 239.167V239.167Z",
    fill: "#455A64"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M552.064 239.167V239.36C552.066 239.382 552.062 239.405 552.055 239.426C552.048 239.447 552.036 239.466 552.022 239.483C552.007 239.499 551.989 239.513 551.969 239.522C551.95 239.531 551.928 239.537 551.906 239.537H551.569C551.547 239.537 551.526 239.531 551.506 239.522C551.486 239.513 551.468 239.499 551.453 239.483C551.438 239.466 551.426 239.447 551.418 239.426C551.411 239.405 551.407 239.383 551.408 239.36C551.409 239.382 551.406 239.404 551.399 239.425C551.392 239.446 551.381 239.465 551.367 239.482C551.352 239.498 551.335 239.512 551.315 239.521C551.296 239.531 551.275 239.536 551.253 239.537H550.913C550.891 239.537 550.87 239.531 550.85 239.522C550.83 239.513 550.812 239.499 550.797 239.483C550.783 239.466 550.771 239.447 550.764 239.426C550.757 239.405 550.754 239.382 550.755 239.36C550.756 239.405 550.741 239.449 550.711 239.482C550.682 239.515 550.641 239.535 550.597 239.537H550.257C550.263 239.513 550.264 239.488 550.26 239.463C550.255 239.439 550.245 239.416 550.231 239.396C550.216 239.376 550.197 239.359 550.175 239.348C550.153 239.337 550.129 239.331 550.105 239.331C550.08 239.331 550.056 239.337 550.034 239.348C550.012 239.359 549.993 239.376 549.978 239.396C549.964 239.416 549.954 239.439 549.949 239.463C549.945 239.488 549.946 239.513 549.953 239.537H549.615C549.594 239.537 549.572 239.531 549.552 239.522C549.533 239.513 549.515 239.499 549.5 239.483C549.485 239.466 549.474 239.447 549.467 239.426C549.459 239.405 549.456 239.382 549.457 239.36C549.458 239.383 549.455 239.405 549.447 239.426C549.439 239.447 549.428 239.466 549.413 239.483C549.398 239.499 549.38 239.513 549.36 239.522C549.34 239.531 549.318 239.537 549.296 239.537H548.959C548.966 239.513 548.967 239.488 548.963 239.463C548.958 239.439 548.948 239.416 548.933 239.396C548.919 239.376 548.9 239.359 548.878 239.348C548.856 239.337 548.832 239.331 548.807 239.331C548.783 239.331 548.759 239.337 548.737 239.348C548.715 239.359 548.696 239.376 548.681 239.396C548.666 239.416 548.656 239.439 548.652 239.463C548.647 239.488 548.649 239.513 548.655 239.537H548.3C548.256 239.535 548.215 239.515 548.185 239.482C548.156 239.449 548.14 239.405 548.142 239.36C548.143 239.382 548.14 239.405 548.133 239.426C548.125 239.447 548.114 239.466 548.099 239.483C548.085 239.499 548.067 239.513 548.047 239.522C548.027 239.531 548.006 239.537 547.984 239.537H547.647C547.625 239.537 547.603 239.531 547.583 239.522C547.564 239.513 547.546 239.499 547.531 239.483C547.516 239.466 547.505 239.447 547.498 239.426C547.49 239.405 547.487 239.382 547.489 239.36C547.489 239.383 547.486 239.405 547.478 239.426C547.471 239.447 547.459 239.466 547.444 239.483C547.429 239.499 547.411 239.513 547.391 239.522C547.371 239.531 547.349 239.537 547.328 239.537H546.99C546.968 239.537 546.947 239.531 546.927 239.522C546.907 239.513 546.89 239.499 546.875 239.483C546.86 239.466 546.849 239.447 546.842 239.426C546.834 239.405 546.831 239.382 546.832 239.36V239.167H552.064Z",
    fill: "#37474F"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M514.641 249.478H500.576V204.269L514.641 194.929V249.478Z",
    fill: "#FFC727"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M512.833 249.479H502.159V205.534L512.833 198.448V249.479Z",
    fill: "#FFC727"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M512.833 249.479H502.159V205.534L512.833 198.448V249.479Z",
    fill: "black"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 206.296H503.38V206.645H512.832V206.296Z",
    fill: "#FFC727"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 209.151H503.38V209.5H512.832V209.151Z",
    fill: "#FFC727"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 212.006H503.38V212.355H512.832V212.006Z",
    fill: "#FFC727"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 214.86H503.38V215.209H512.832V214.86Z",
    fill: "#FFC727"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 217.716H503.38V218.065H512.832V217.716Z",
    fill: "#FFC727"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 220.573H503.38V220.922H512.832V220.573Z",
    fill: "#FFC727"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 223.429H503.38V223.777H512.832V223.429Z",
    fill: "#FFC727"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 226.284H503.38V226.633H512.832V226.284Z",
    fill: "#FFC727"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 229.139H503.38V229.487H512.832V229.139Z",
    fill: "#FFC727"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 231.994H503.38V232.343H512.832V231.994Z",
    fill: "#FFC727"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 234.852H503.38V235.2H512.832V234.852Z",
    fill: "#FFC727"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 237.707H503.38V238.056H512.832V237.707Z",
    fill: "#FFC727"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 240.562H503.38V240.911H512.832V240.562Z",
    fill: "#FFC727"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 243.418H503.38V243.767H512.832V243.418Z",
    fill: "#FFC727"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 246.271H503.38V246.62H512.832V246.271Z",
    fill: "#FFC727"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M512.832 249.13H503.38V249.479H512.832V249.13Z",
    fill: "#FFC727"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M507.938 202.973V249.475H508.278V202.973H507.938Z",
    fill: "#FFC727"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M512.833 198.444V200.02L503.384 206.296V249.478H502.159V205.533L512.833 198.444Z",
    fill: "#FFC727"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M512.833 198.444V200.02L503.384 206.296V249.478H502.159V205.533L512.833 198.444Z",
    fill: "black"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M527.031 194.929H514.641V249.475H527.031V194.929Z",
    fill: "#FFC727"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M527.031 194.929H514.641V249.475H527.031V194.929Z",
    fill: "black"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.831 198.448H515.844V199.684H525.831V198.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 201.243H515.844V202.479H525.831V201.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 204.04H515.844V205.276H525.831V204.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 206.838H515.844V208.074H525.831V206.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 209.634H515.844V210.87H525.831V209.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 212.435H515.844V213.671H525.831V212.435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 215.229H515.844V216.465H525.831V215.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 218.026H515.844V219.262H525.831V218.026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 220.823H515.844V222.059H525.831V220.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 223.623H515.844V224.859H525.831V223.623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 226.418H515.844V227.654H525.831V226.418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 229.218H515.844V230.454H525.831V229.218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 232.013H515.844V233.249H525.831V232.013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 234.812H515.844V236.049H525.831V234.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 237.607H515.844V238.843H525.831V237.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 240.406H515.844V241.642H525.831V240.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 243.201H515.844V244.437H525.831V243.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.831 246.001H515.844V247.237H525.831V246.001Z",
    fill: "black"
  }))), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M573.404 196.259H556.489V249.475H573.404V196.259Z",
    fill: "#455A64"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M573.341 190.906H560.684V196.258H573.341V190.906Z",
    fill: "#37474F"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M562.818 191.732H561.736V195.434H562.818V191.732Z",
    fill: "#455A64"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M564.712 191.732H563.63V195.434H564.712V191.732Z",
    fill: "#455A64"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M566.606 191.732H565.524V195.434H566.606V191.732Z",
    fill: "#455A64"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M568.503 191.732H567.421V195.434H568.503V191.732Z",
    fill: "#455A64"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M570.394 191.732H569.312V195.434H570.394V191.732Z",
    fill: "#455A64"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M572.288 191.732H571.206V195.434H572.288V191.732Z",
    fill: "#455A64"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M579.096 190.906H573.342V196.258H579.096V190.906Z",
    fill: "#455A64"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M575.071 191.732H574.15V195.434H575.071V191.732Z",
    fill: "#37474F"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M576.684 191.732H575.764V195.434H576.684V191.732Z",
    fill: "#37474F"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M578.29 191.732H577.369V195.434H578.29V191.732Z",
    fill: "#37474F"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M581.949 196.259H573.342V249.475H581.949V196.259Z",
    fill: "#37474F"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M563.469 188.191H563.083V190.903H563.469V188.191Z",
    fill: "#263238"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M570.938 188.191H570.552V190.903H570.938V188.191Z",
    fill: "#263238"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M572.659 183.45H561.371V188.192H572.659V183.45Z",
    fill: "#FFC727"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 199.926H559.95V204.823H563.074V199.926Z",
    fill: "#263238"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 199.926H566.309V204.823H569.432V199.926Z",
    fill: "#263238"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 207.645H559.95V212.542H563.074V207.645Z",
    fill: "#263238"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 207.645H566.309V212.542H569.432V207.645Z",
    fill: "#263238"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 215.365H559.95V220.263H563.074V215.365Z",
    fill: "#263238"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 215.365H566.309V220.263H569.432V215.365Z",
    fill: "#263238"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 223.084H559.95V227.981H563.074V223.084Z",
    fill: "#263238"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 223.084H566.309V227.981H569.432V223.084Z",
    fill: "#263238"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 230.805H559.95V235.702H563.074V230.805Z",
    fill: "#263238"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 230.805H566.309V235.702H569.432V230.805Z",
    fill: "#263238"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M563.074 238.522H559.95V243.42H563.074V238.522Z",
    fill: "#263238"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M569.432 238.522H566.309V243.42H569.432V238.522Z",
    fill: "#263238"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 199.926H574.92V204.823H576.713V199.926Z",
    fill: "#263238"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 199.926H578.572V204.823H580.365V199.926Z",
    fill: "#263238"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 207.645H574.92V212.542H576.713V207.645Z",
    fill: "#263238"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 207.645H578.572V212.542H580.365V207.645Z",
    fill: "#263238"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 215.365H574.92V220.263H576.713V215.365Z",
    fill: "#263238"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 215.365H578.572V220.263H580.365V215.365Z",
    fill: "#263238"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 223.084H574.92V227.981H576.713V223.084Z",
    fill: "#263238"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 223.084H578.572V227.981H580.365V223.084Z",
    fill: "#263238"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 230.805H574.92V235.702H576.713V230.805Z",
    fill: "#263238"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 230.805H578.572V235.702H580.365V230.805Z",
    fill: "#263238"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M576.713 238.522H574.92V243.42H576.713V238.522Z",
    fill: "#263238"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M580.365 238.522H578.572V243.42H580.365V238.522Z",
    fill: "#263238"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M462.945 187.521H452.25V249.479H462.945V187.521Z",
    fill: "#37474F"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M462.945 190.991H452.25V191.642H462.945V190.991Z",
    fill: "#455A64"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 193.555H453.35V197.179H455.318V193.555Z",
    fill: "#263238"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 198.128H453.35V201.752H455.318V198.128Z",
    fill: "#263238"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 202.697H453.35V206.321H455.318V202.697Z",
    fill: "#263238"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 207.265H453.35V210.889H455.318V207.265Z",
    fill: "#263238"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 211.835H453.35V215.459H455.318V211.835Z",
    fill: "#263238"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 216.405H453.35V220.029H455.318V216.405Z",
    fill: "#263238"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 220.976H453.35V224.6H455.318V220.976Z",
    fill: "#263238"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 225.547H453.35V229.171H455.318V225.547Z",
    fill: "#263238"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 230.115H453.35V233.739H455.318V230.115Z",
    fill: "#263238"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 234.684H453.35V238.308H455.318V234.684Z",
    fill: "#263238"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 239.254H453.35V242.878H455.318V239.254Z",
    fill: "#263238"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 243.825H453.35V247.449H455.318V243.825Z",
    fill: "#263238"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 193.555H453.35V197.179H455.318V193.555Z",
    fill: "#263238"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 198.128H453.35V201.752H455.318V198.128Z",
    fill: "#263238"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 202.697H453.35V206.321H455.318V202.697Z",
    fill: "#263238"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 207.265H453.35V210.889H455.318V207.265Z",
    fill: "#263238"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 211.835H453.35V215.459H455.318V211.835Z",
    fill: "#263238"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 216.405H453.35V220.029H455.318V216.405Z",
    fill: "#263238"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 220.976H453.35V224.6H455.318V220.976Z",
    fill: "#263238"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 225.547H453.35V229.171H455.318V225.547Z",
    fill: "#263238"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 230.115H453.35V233.739H455.318V230.115Z",
    fill: "#263238"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 234.684H453.35V238.308H455.318V234.684Z",
    fill: "#263238"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 239.254H453.35V242.878H455.318V239.254Z",
    fill: "#263238"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M455.318 243.825H453.35V247.449H455.318V243.825Z",
    fill: "#263238"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 193.555H456.614V197.179H458.583V193.555Z",
    fill: "#263238"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 198.128H456.614V201.752H458.583V198.128Z",
    fill: "#263238"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 202.697H456.614V206.321H458.583V202.697Z",
    fill: "#263238"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 207.265H456.614V210.889H458.583V207.265Z",
    fill: "#263238"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 211.835H456.614V215.459H458.583V211.835Z",
    fill: "#263238"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 216.405H456.614V220.029H458.583V216.405Z",
    fill: "#263238"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 220.976H456.614V224.6H458.583V220.976Z",
    fill: "#263238"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 225.547H456.614V229.171H458.583V225.547Z",
    fill: "#263238"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 230.115H456.614V233.739H458.583V230.115Z",
    fill: "#263238"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 234.684H456.614V238.308H458.583V234.684Z",
    fill: "#263238"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 239.254H456.614V242.878H458.583V239.254Z",
    fill: "#263238"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 243.825H456.614V247.449H458.583V243.825Z",
    fill: "#263238"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 193.555H456.614V197.179H458.583V193.555Z",
    fill: "#263238"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 198.128H456.614V201.752H458.583V198.128Z",
    fill: "#263238"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 202.697H456.614V206.321H458.583V202.697Z",
    fill: "#263238"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 207.265H456.614V210.889H458.583V207.265Z",
    fill: "#263238"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 211.835H456.614V215.459H458.583V211.835Z",
    fill: "#263238"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 216.405H456.614V220.029H458.583V216.405Z",
    fill: "#263238"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 220.976H456.614V224.6H458.583V220.976Z",
    fill: "#263238"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 225.547H456.614V229.171H458.583V225.547Z",
    fill: "#263238"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 230.115H456.614V233.739H458.583V230.115Z",
    fill: "#263238"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 234.684H456.614V238.308H458.583V234.684Z",
    fill: "#263238"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 239.254H456.614V242.878H458.583V239.254Z",
    fill: "#263238"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M458.583 243.825H456.614V247.449H458.583V243.825Z",
    fill: "#263238"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 193.555H459.872V197.179H461.841V193.555Z",
    fill: "#263238"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 198.128H459.872V201.752H461.841V198.128Z",
    fill: "#263238"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 202.697H459.872V206.321H461.841V202.697Z",
    fill: "#263238"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 207.265H459.872V210.889H461.841V207.265Z",
    fill: "#263238"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 211.835H459.872V215.459H461.841V211.835Z",
    fill: "#263238"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 216.405H459.872V220.029H461.841V216.405Z",
    fill: "#263238"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 220.976H459.872V224.6H461.841V220.976Z",
    fill: "#263238"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 225.547H459.872V229.171H461.841V225.547Z",
    fill: "#263238"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 230.115H459.872V233.739H461.841V230.115Z",
    fill: "#263238"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 234.684H459.872V238.308H461.841V234.684Z",
    fill: "#263238"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 239.254H459.872V242.878H461.841V239.254Z",
    fill: "#263238"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 243.825H459.872V247.449H461.841V243.825Z",
    fill: "#263238"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 193.555H459.872V197.179H461.841V193.555Z",
    fill: "#263238"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 198.128H459.872V201.752H461.841V198.128Z",
    fill: "#263238"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 202.697H459.872V206.321H461.841V202.697Z",
    fill: "#263238"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 207.265H459.872V210.889H461.841V207.265Z",
    fill: "#263238"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 211.835H459.872V215.459H461.841V211.835Z",
    fill: "#263238"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 216.405H459.872V220.029H461.841V216.405Z",
    fill: "#263238"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 220.976H459.872V224.6H461.841V220.976Z",
    fill: "#263238"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 225.547H459.872V229.171H461.841V225.547Z",
    fill: "#263238"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 230.115H459.872V233.739H461.841V230.115Z",
    fill: "#263238"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 234.684H459.872V238.308H461.841V234.684Z",
    fill: "#263238"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 239.254H459.872V242.878H461.841V239.254Z",
    fill: "#263238"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M461.841 243.825H459.872V247.449H461.841V243.825Z",
    fill: "#263238"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M452.248 187.521H433.963V249.479H452.248V187.521Z",
    fill: "#455A64"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M452.248 190.991H433.963V191.642H452.248V190.991Z",
    fill: "#37474F"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M452.25 184.038H440.482V187.519H452.25V184.038Z",
    fill: "#37474F"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M452.248 187.521H457.777V184.04H452.248V187.521Z",
    fill: "#263238"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 193.555H435.922V197.179H439.118V193.555Z",
    fill: "#37474F"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 198.128H435.922V201.752H439.118V198.128Z",
    fill: "#37474F"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 202.697H435.922V206.321H439.118V202.697Z",
    fill: "#37474F"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 207.265H435.922V210.889H439.118V207.265Z",
    fill: "#37474F"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 211.835H435.922V215.459H439.118V211.835Z",
    fill: "#37474F"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 216.405H435.922V220.029H439.118V216.405Z",
    fill: "#37474F"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 220.976H435.922V224.6H439.118V220.976Z",
    fill: "#37474F"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 225.547H435.922V229.171H439.118V225.547Z",
    fill: "#37474F"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 230.115H435.922V233.739H439.118V230.115Z",
    fill: "#37474F"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 234.684H435.922V238.308H439.118V234.684Z",
    fill: "#37474F"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 239.254H435.922V242.878H439.118V239.254Z",
    fill: "#37474F"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 243.825H435.922V247.449H439.118V243.825Z",
    fill: "#37474F"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 193.555H435.922V197.179H439.118V193.555Z",
    fill: "#37474F"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 198.128H435.922V201.752H439.118V198.128Z",
    fill: "#37474F"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 202.697H435.922V206.321H439.118V202.697Z",
    fill: "#37474F"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 207.265H435.922V210.889H439.118V207.265Z",
    fill: "#37474F"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 211.835H435.922V215.459H439.118V211.835Z",
    fill: "#37474F"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 216.405H435.922V220.029H439.118V216.405Z",
    fill: "#37474F"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 220.976H435.922V224.6H439.118V220.976Z",
    fill: "#37474F"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 225.547H435.922V229.171H439.118V225.547Z",
    fill: "#37474F"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 230.115H435.922V233.739H439.118V230.115Z",
    fill: "#37474F"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 234.684H435.922V238.308H439.118V234.684Z",
    fill: "#37474F"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 239.254H435.922V242.878H439.118V239.254Z",
    fill: "#37474F"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M439.118 243.825H435.922V247.449H439.118V243.825Z",
    fill: "#37474F"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 193.555H441.219V197.179H444.415V193.555Z",
    fill: "#37474F"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 198.128H441.219V201.752H444.415V198.128Z",
    fill: "#37474F"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 202.697H441.219V206.321H444.415V202.697Z",
    fill: "#37474F"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 207.265H441.219V210.889H444.415V207.265Z",
    fill: "#37474F"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 211.835H441.219V215.459H444.415V211.835Z",
    fill: "#37474F"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 216.405H441.219V220.029H444.415V216.405Z",
    fill: "#37474F"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 220.976H441.219V224.6H444.415V220.976Z",
    fill: "#37474F"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 225.547H441.219V229.171H444.415V225.547Z",
    fill: "#37474F"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 230.115H441.219V233.739H444.415V230.115Z",
    fill: "#37474F"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 234.684H441.219V238.308H444.415V234.684Z",
    fill: "#37474F"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 239.254H441.219V242.878H444.415V239.254Z",
    fill: "#37474F"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 243.825H441.219V247.449H444.415V243.825Z",
    fill: "#37474F"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 193.555H441.219V197.179H444.415V193.555Z",
    fill: "#37474F"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 198.128H441.219V201.752H444.415V198.128Z",
    fill: "#37474F"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 202.697H441.219V206.321H444.415V202.697Z",
    fill: "#37474F"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 207.265H441.219V210.889H444.415V207.265Z",
    fill: "#37474F"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 211.835H441.219V215.459H444.415V211.835Z",
    fill: "#37474F"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 216.405H441.219V220.029H444.415V216.405Z",
    fill: "#37474F"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 220.976H441.219V224.6H444.415V220.976Z",
    fill: "#37474F"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 225.547H441.219V229.171H444.415V225.547Z",
    fill: "#37474F"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 230.115H441.219V233.739H444.415V230.115Z",
    fill: "#37474F"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 234.684H441.219V238.308H444.415V234.684Z",
    fill: "#37474F"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 239.254H441.219V242.878H444.415V239.254Z",
    fill: "#37474F"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M444.415 243.825H441.219V247.449H444.415V243.825Z",
    fill: "#37474F"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 193.555H446.517V197.179H449.713V193.555Z",
    fill: "#37474F"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 198.128H446.517V201.752H449.713V198.128Z",
    fill: "#37474F"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 202.697H446.517V206.321H449.713V202.697Z",
    fill: "#37474F"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 207.265H446.517V210.889H449.713V207.265Z",
    fill: "#37474F"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 211.835H446.517V215.459H449.713V211.835Z",
    fill: "#37474F"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 216.405H446.517V220.029H449.713V216.405Z",
    fill: "#37474F"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 220.976H446.517V224.6H449.713V220.976Z",
    fill: "#37474F"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 225.547H446.517V229.171H449.713V225.547Z",
    fill: "#37474F"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 230.115H446.517V233.739H449.713V230.115Z",
    fill: "#37474F"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 234.684H446.517V238.308H449.713V234.684Z",
    fill: "#37474F"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 239.254H446.517V242.878H449.713V239.254Z",
    fill: "#37474F"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 243.825H446.517V247.449H449.713V243.825Z",
    fill: "#37474F"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 193.555H446.517V197.179H449.713V193.555Z",
    fill: "#37474F"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 198.128H446.517V201.752H449.713V198.128Z",
    fill: "#37474F"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 202.697H446.517V206.321H449.713V202.697Z",
    fill: "#37474F"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 207.265H446.517V210.889H449.713V207.265Z",
    fill: "#37474F"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 211.835H446.517V215.459H449.713V211.835Z",
    fill: "#37474F"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 216.405H446.517V220.029H449.713V216.405Z",
    fill: "#37474F"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 220.976H446.517V224.6H449.713V220.976Z",
    fill: "#37474F"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 225.547H446.517V229.171H449.713V225.547Z",
    fill: "#37474F"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 230.115H446.517V233.739H449.713V230.115Z",
    fill: "#37474F"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 234.684H446.517V238.308H449.713V234.684Z",
    fill: "#37474F"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 239.254H446.517V242.878H449.713V239.254Z",
    fill: "#37474F"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M449.713 243.825H446.517V247.449H449.713V243.825Z",
    fill: "#37474F"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M609.966 196.286H599.699V249.475H609.966V196.286Z",
    fill: "#FFC727"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M609.966 196.286H599.699V249.475H609.966V196.286Z",
    fill: "black"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M599.699 196.286H610.579V194.543H599.699V196.286Z",
    fill: "#FFC727"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M599.698 194.542H608.923V191.821H599.698V194.542Z",
    fill: "#FFC727"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.698 194.542H608.923V191.821H599.698V194.542Z",
    fill: "black"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M599.701 191.822H606.759V185.82H599.701V191.822Z",
    fill: "#FFC727"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M599.701 191.822H606.759V185.82H599.701V191.822Z",
    fill: "black"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 198.304H600.684V203.898H602.075V198.304Z",
    fill: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 205.925H600.684V211.52H602.075V205.925Z",
    fill: "black"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 213.546H600.684V219.141H602.075V213.546Z",
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 221.17H600.684V226.765H602.075V221.17Z",
    fill: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 228.79H600.684V234.385H602.075V228.79Z",
    fill: "black"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.075 236.411H600.684V242.006H602.075V236.411Z",
    fill: "black"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 198.304H602.985V203.898H604.377V198.304Z",
    fill: "black"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 205.925H602.985V211.52H604.377V205.925Z",
    fill: "black"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 213.546H602.985V219.141H604.377V213.546Z",
    fill: "black"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 221.17H602.985V226.765H604.377V221.17Z",
    fill: "black"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 228.79H602.985V234.385H604.377V228.79Z",
    fill: "black"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.377 236.411H602.985V242.006H604.377V236.411Z",
    fill: "black"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 198.304H605.287V203.898H606.679V198.304Z",
    fill: "black"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 205.925H605.287V211.52H606.679V205.925Z",
    fill: "black"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 213.546H605.287V219.141H606.679V213.546Z",
    fill: "black"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 221.17H605.287V226.765H606.679V221.17Z",
    fill: "black"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 228.79H605.287V234.385H606.679V228.79Z",
    fill: "black"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.679 236.411H605.287V242.006H606.679V236.411Z",
    fill: "black"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.978 198.304H607.587V203.898H608.978V198.304Z",
    fill: "black"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.98 205.925H607.589V211.52H608.98V205.925Z",
    fill: "black"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.978 213.546H607.587V219.141H608.978V213.546Z",
    fill: "black"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.978 221.168H607.587V226.763H608.978V221.168Z",
    fill: "black"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.978 228.79H607.587V234.385H608.978V228.79Z",
    fill: "black"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.978 236.411H607.587V242.006H608.978V236.411Z",
    fill: "black"
  }))), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M599.699 196.286H578.652V249.475H599.699V196.286Z",
    fill: "#FFC727"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M599.699 191.825H579.661V194.546H599.699V191.825Z",
    fill: "#FFC727"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M599.695 185.823H584.619V191.826H599.695V185.823Z",
    fill: "#FFC727"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.695 185.823H584.619V191.826H599.695V185.823Z",
    fill: "black"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M599.698 194.547H578.022V196.29H599.698V194.547Z",
    fill: "#FFC727"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.698 194.547H578.022V196.29H599.698V194.547Z",
    fill: "black"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 198.304H580.662V203.898H583.518V198.304Z",
    fill: "black"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 205.925H580.662V211.52H583.518V205.925Z",
    fill: "black"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 213.546H580.662V219.141H583.518V213.546Z",
    fill: "black"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 221.17H580.662V226.765H583.518V221.17Z",
    fill: "black"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 228.79H580.662V234.385H583.518V228.79Z",
    fill: "black"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.518 236.411H580.662V242.006H583.518V236.411Z",
    fill: "black"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 198.304H585.384V203.898H588.24V198.304Z",
    fill: "black"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 205.925H585.384V211.52H588.24V205.925Z",
    fill: "black"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 213.548H585.384V219.143H588.24V213.548Z",
    fill: "black"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 221.168H585.384V226.763H588.24V221.168Z",
    fill: "black"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 228.79H585.384V234.385H588.24V228.79Z",
    fill: "black"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.24 236.411H585.384V242.006H588.24V236.411Z",
    fill: "black"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 198.304H590.109V203.898H592.965V198.304Z",
    fill: "black"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 205.925H590.109V211.52H592.965V205.925Z",
    fill: "black"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 213.548H590.109V219.143H592.965V213.548Z",
    fill: "black"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 221.17H590.109V226.765H592.965V221.17Z",
    fill: "black"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 228.79H590.109V234.385H592.965V228.79Z",
    fill: "black"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.965 236.411H590.109V242.006H592.965V236.411Z",
    fill: "black"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 198.304H594.832V203.898H597.688V198.304Z",
    fill: "black"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 205.925H594.832V211.52H597.688V205.925Z",
    fill: "black"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 213.546H594.832V219.141H597.688V213.546Z",
    fill: "black"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 221.168H594.832V226.763H597.688V221.168Z",
    fill: "black"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 228.79H594.832V234.385H597.688V228.79Z",
    fill: "black"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.688 236.411H594.832V242.006H597.688V236.411Z",
    fill: "black"
  }))), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M592.962 244.204H585.385V249.475H592.962V244.204Z",
    fill: "black"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M631.026 219.147H620.76V249.478H631.026V219.147Z",
    fill: "#FFC727"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M631.026 219.147H620.76V249.478H631.026V219.147Z",
    fill: "black"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M620.762 219.146H631.643V217.402H620.762V219.146Z",
    fill: "#FFC727"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M620.765 217.401H629.989V214.68H620.765V217.401Z",
    fill: "#FFC727"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M620.765 217.401H629.989V214.68H620.765V217.401Z",
    fill: "black"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.138 221.161H621.746V226.756H623.138V221.161Z",
    fill: "black"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.138 228.785H621.746V234.38H623.138V228.785Z",
    fill: "black"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.138 236.405H621.746V242H623.138V236.405Z",
    fill: "black"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.439 221.161H624.048V226.756H625.439V221.161Z",
    fill: "black"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.439 228.785H624.048V234.38H625.439V228.785Z",
    fill: "black"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.439 236.405H624.048V242H625.439V236.405Z",
    fill: "black"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.741 221.161H626.35V226.756H627.741V221.161Z",
    fill: "black"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.741 228.785H626.35V234.38H627.741V228.785Z",
    fill: "black"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.741 236.405H626.35V242H627.741V236.405Z",
    fill: "black"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.043 221.161H628.651V226.756H630.043V221.161Z",
    fill: "black"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.043 228.785H628.651V234.38H630.043V228.785Z",
    fill: "black"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.043 236.405H628.651V242H630.043V236.405Z",
    fill: "black"
  }))), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M620.764 219.147H599.718V249.478H620.764V219.147Z",
    fill: "#FFC727"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M620.764 214.684H600.726V217.405H620.764V214.684Z",
    fill: "#FFC727"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M620.764 217.404H599.088V219.148H620.764V217.404Z",
    fill: "#FFC727"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M620.764 217.404H599.088V219.148H620.764V217.404Z",
    fill: "black"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.584 221.161H601.728V226.756H604.584V221.161Z",
    fill: "black"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.584 228.785H601.728V234.38H604.584V228.785Z",
    fill: "black"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.584 236.405H601.728V242H604.584V236.405Z",
    fill: "black"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.306 221.163H606.45V226.758H609.306V221.163Z",
    fill: "black"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.306 228.783H606.45V234.378H609.306V228.783Z",
    fill: "black"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.306 236.405H606.45V242H609.306V236.405Z",
    fill: "black"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.029 221.163H611.173V226.758H614.029V221.163Z",
    fill: "black"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.025 228.785H611.169V234.38H614.025V228.785Z",
    fill: "black"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.029 236.405H611.173V242H614.029V236.405Z",
    fill: "black"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.751 221.161H615.895V226.756H618.751V221.161Z",
    fill: "black"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.751 228.785H615.895V234.38H618.751V228.785Z",
    fill: "black"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.751 236.405H615.895V242H618.751V236.405Z",
    fill: "black"
  }))), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M489.68 219.356H482.065V249.475H489.68V219.356Z",
    fill: "#FFC727"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M489.68 219.356H482.065V249.475H489.68V219.356Z",
    fill: "black"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M482.066 219.356H456.99V249.475H482.066V219.356Z",
    fill: "#FFC727"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M477.362 223.021H479.212V222.22H477.362V223.021Z",
    fill: "black"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M478.393 222.008H480.243V221.208H478.393V222.008Z",
    fill: "black"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M476.332 222.008H478.183V221.208H476.332V222.008Z",
    fill: "black"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M459.842 222.008H461.692V221.208H459.842V222.008Z",
    fill: "black"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M459.842 244.759H461.692V243.959H459.842V244.759Z",
    fill: "black"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M458.81 243.75H460.66V242.95H458.81V243.75Z",
    fill: "black"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M486.253 239.644H488.104V238.843H486.253V239.644Z",
    fill: "black"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M485.219 238.632H487.069V237.832H485.219V238.632Z",
    fill: "black"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M478.393 244.755H480.243V243.955H478.393V244.755Z",
    fill: "black"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M486.714 226.963H488.564V226.163H486.714V226.963Z",
    fill: "black"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M476.228 230.687H474.378V231.487H476.228V230.687Z",
    fill: "black"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M475.196 231.695H473.346V232.495H475.196V231.695Z",
    fill: "black"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M482.712 228.561H456.345V229.37H482.712V228.561Z",
    fill: "#FFC727"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M482.712 228.561H456.345V229.37H482.712V228.561Z",
    fill: "black"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M482.712 224.298H456.345V225.107H482.712V224.298Z",
    fill: "#FFC727"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M482.712 224.298H456.345V225.107H482.712V224.298Z",
    fill: "black"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M482.066 225.106H456.99V228.559H482.066V225.106Z",
    fill: "white"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M482.712 218.95H456.345V219.76H482.712V218.95Z",
    fill: "#FFC727"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M482.712 218.95H456.345V219.76H482.712V218.95Z",
    fill: "black"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M490.608 218.95H482.711V219.76H490.608V218.95Z",
    fill: "#FFC727"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M490.608 218.95H482.711V219.76H490.608V218.95Z",
    fill: "black"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M490.608 248.669H482.711V249.478H490.608V248.669Z",
    fill: "#FFC727"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M490.608 248.669H482.711V249.478H490.608V248.669Z",
    fill: "black"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M482.712 248.669H456.345V249.478H482.712V248.669Z",
    fill: "#FFC727"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M482.712 248.669H456.345V249.478H482.712V248.669Z",
    fill: "black"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M481.144 230.072H474.882V233.706H481.144V230.072Z",
    fill: "#263238"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.142 230.072V231.8L479.283 233.706H477.198L480.741 230.072H481.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.732 230.072L475.189 233.706H474.879V233.572L478.291 230.072H478.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.188 230.072L474.879 232.438V231.554L476.325 230.072H477.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.141 232.413V233.294L480.743 233.705H479.88L481.141 232.413Z",
    fill: "white"
  }))), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M481.144 234.473H474.882V249.476H481.144V234.473Z",
    fill: "#455A64"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 235.452H475.813V242.821H480.213V235.452Z",
    fill: "#263238"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 235.452H475.813V235.617H480.213V235.452Z",
    fill: "white"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 235.687H475.813V235.852H480.213V235.687Z",
    fill: "white"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 235.92H475.813V236.085H480.213V235.92Z",
    fill: "white"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 236.156H475.813V236.321H480.213V236.156Z",
    fill: "white"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 236.391H475.813V236.556H480.213V236.391Z",
    fill: "white"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 236.623H475.813V236.788H480.213V236.623Z",
    fill: "white"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 236.86H475.813V237.025H480.213V236.86Z",
    fill: "white"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 237.094H475.813V237.259H480.213V237.094Z",
    fill: "white"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 237.329H475.813V237.494H480.213V237.329Z",
    fill: "white"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 237.563H475.813V237.728H480.213V237.563Z",
    fill: "white"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 237.797H475.813V237.962H480.213V237.797Z",
    fill: "white"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 238.034H475.813V238.199H480.213V238.034Z",
    fill: "white"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 238.268H475.813V238.433H480.213V238.268Z",
    fill: "white"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 238.504H475.813V238.669H480.213V238.504Z",
    fill: "white"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 238.738H475.813V238.903H480.213V238.738Z",
    fill: "white"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 238.971H475.813V239.136H480.213V238.971Z",
    fill: "white"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 239.207H475.813V239.372H480.213V239.207Z",
    fill: "white"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 239.441H475.813V239.606H480.213V239.441Z",
    fill: "white"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 239.674H475.813V239.839H480.213V239.674Z",
    fill: "white"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 239.912H475.813V240.077H480.213V239.912Z",
    fill: "white"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 240.144H475.813V240.309H480.213V240.144Z",
    fill: "white"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 240.381H475.813V240.546H480.213V240.381Z",
    fill: "white"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M480.213 240.614H475.813V240.779H480.213V240.614Z",
    fill: "white"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.217 235.453V236.34L475.817 240.849V238.713L478.999 235.453H480.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.217 240.111V242.247L479.655 242.82H477.57L480.217 240.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.216 239.175V239.626L477.096 242.821H476.655L480.216 239.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.555 235.453L475.817 238.258V237.374L477.692 235.453H478.555Z",
    fill: "white"
  }))), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M479.506 243.654H476.209V244.445H479.506V243.654Z",
    fill: "#263238"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M480.727 243.174H480.341V244.444H480.727V243.174Z",
    fill: "#A6A6A6"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M475.813 248.227C475.813 248.009 475.795 247.794 475.786 247.576C475.777 247.358 475.771 247.143 475.765 246.928C475.765 246.496 475.746 246.063 475.74 245.633V245.559H475.813C476.144 245.559 476.476 245.559 476.807 245.559H477.8L478.794 245.58L479.289 245.602C479.456 245.602 479.62 245.602 479.787 245.627L479.289 245.652L478.794 245.671C478.463 245.671 478.131 245.689 477.8 245.692H476.807H475.813L475.886 245.618C475.886 246.047 475.886 246.48 475.865 246.913C475.865 247.128 475.865 247.346 475.844 247.56C475.822 247.775 475.828 248.009 475.813 248.227Z",
    fill: "#37474F"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M480.215 245.639C480.215 245.853 480.233 246.068 480.242 246.286C480.251 246.504 480.257 246.719 480.263 246.934C480.263 247.367 480.282 247.799 480.288 248.232V248.307H479.209C478.875 248.307 478.541 248.307 478.206 248.307C477.872 248.307 477.538 248.307 477.204 248.285L476.702 248.263L476.201 248.241C476.368 248.241 476.535 248.223 476.702 248.217L477.204 248.195C477.538 248.195 477.872 248.176 478.206 248.173H479.209H480.215L480.142 248.251C480.142 247.818 480.142 247.385 480.163 246.953C480.163 246.738 480.163 246.52 480.184 246.305C480.206 246.09 480.2 245.847 480.215 245.639Z",
    fill: "#37474F"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M476.385 247.735C476.363 247.467 476.348 247.2 476.336 246.929C476.336 246.795 476.336 246.661 476.336 246.524C476.336 246.387 476.336 246.256 476.336 246.122V246.051H476.406C476.652 246.051 476.895 246.051 477.141 246.051C477.387 246.051 477.633 246.051 477.876 246.051C478.119 246.051 478.369 246.051 478.612 246.076C478.855 246.101 479.104 246.101 479.35 246.122C479.104 246.144 478.858 246.157 478.612 246.169C478.366 246.182 478.122 246.188 477.876 246.191C477.63 246.194 477.387 246.191 477.141 246.191H476.406L476.476 246.119C476.476 246.253 476.476 246.387 476.476 246.521C476.476 246.655 476.476 246.792 476.476 246.926C476.421 247.196 476.406 247.467 476.385 247.735Z",
    fill: "#37474F"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M479.632 246.123C479.653 246.391 479.668 246.662 479.677 246.929C479.686 247.197 479.699 247.468 479.702 247.736V247.82H479.632H478.887C478.641 247.82 478.392 247.82 478.146 247.82C477.9 247.82 477.651 247.82 477.402 247.795C477.152 247.77 476.906 247.77 476.657 247.748C476.906 247.73 477.156 247.714 477.402 247.705C477.648 247.695 477.897 247.683 478.146 247.68C478.395 247.677 478.641 247.68 478.887 247.68H479.632L479.562 247.748C479.562 247.48 479.562 247.213 479.586 246.942C479.611 246.671 479.632 246.391 479.632 246.123Z",
    fill: "#37474F"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M473.61 229.662H458.057V244.08H473.61V229.662Z",
    fill: "white"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M473.223 230.072H458.444V243.668H473.223V230.072Z",
    fill: "#263238"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.226 239.279V241.412L471.023 243.669H468.938L473.226 239.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.344 230.072L458.442 241.243V239.107L467.26 230.072H469.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.641 230.072L458.442 242.572V242.121L470.201 230.072H470.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.225 235.844V236.292L466.027 243.668H465.59L473.225 235.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.224 242.228V243.109L472.677 243.669H471.817L473.224 242.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.455 230.072L458.442 237.255V236.371L464.592 230.072H465.455Z",
    fill: "white"
  }))), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M457.219 232.895L457.144 232.907L457.998 238.487L458.073 238.474L457.219 232.895Z",
    fill: "#263238"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M458.194 238.48C458.194 238.51 458.186 238.539 458.169 238.564C458.153 238.59 458.13 238.609 458.102 238.621C458.075 238.632 458.045 238.635 458.016 238.629C457.987 238.623 457.961 238.609 457.94 238.588C457.919 238.566 457.905 238.539 457.899 238.509C457.894 238.48 457.897 238.449 457.908 238.421C457.919 238.393 457.938 238.37 457.963 238.353C457.987 238.336 458.016 238.327 458.045 238.327C458.085 238.327 458.123 238.343 458.151 238.372C458.179 238.4 458.194 238.439 458.194 238.48Z",
    fill: "white"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M474.425 232.897L473.574 238.477L473.649 238.489L474.5 232.909L474.425 232.897Z",
    fill: "#263238"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M473.459 238.48C473.459 238.51 473.468 238.539 473.484 238.564C473.5 238.59 473.524 238.609 473.551 238.621C473.578 238.632 473.608 238.635 473.637 238.629C473.666 238.623 473.692 238.609 473.713 238.588C473.734 238.566 473.748 238.539 473.754 238.509C473.76 238.48 473.757 238.449 473.745 238.421C473.734 238.393 473.715 238.37 473.691 238.353C473.666 238.336 473.637 238.327 473.608 238.327C473.568 238.327 473.531 238.343 473.503 238.372C473.475 238.4 473.459 238.439 473.459 238.48Z",
    fill: "white"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M474.921 232.841H456.752C457.38 231.769 457.822 230.593 458.058 229.366H473.612C473.849 230.593 474.292 231.769 474.921 232.841V232.841Z",
    fill: "#455A64"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M474.922 232.841V233.252C474.924 233.3 474.917 233.347 474.901 233.392C474.885 233.437 474.86 233.479 474.828 233.514C474.797 233.549 474.759 233.578 474.716 233.598C474.674 233.618 474.628 233.63 474.581 233.632H473.861C473.815 233.63 473.769 233.618 473.727 233.598C473.685 233.578 473.647 233.549 473.615 233.514C473.584 233.478 473.56 233.437 473.544 233.392C473.528 233.347 473.522 233.299 473.524 233.252C473.526 233.3 473.519 233.347 473.503 233.392C473.487 233.437 473.462 233.479 473.431 233.514C473.399 233.549 473.361 233.578 473.319 233.598C473.276 233.618 473.23 233.63 473.184 233.632H472.464C472.417 233.63 472.371 233.618 472.329 233.598C472.287 233.578 472.249 233.549 472.218 233.514C472.186 233.478 472.162 233.437 472.146 233.392C472.131 233.347 472.124 233.299 472.126 233.252C472.128 233.3 472.121 233.347 472.105 233.392C472.089 233.437 472.065 233.479 472.033 233.514C472.001 233.549 471.963 233.578 471.921 233.598C471.879 233.618 471.833 233.63 471.786 233.632H471.066C471.019 233.63 470.974 233.618 470.931 233.598C470.889 233.578 470.851 233.549 470.82 233.514C470.789 233.478 470.764 233.437 470.749 233.392C470.733 233.347 470.726 233.299 470.729 233.252C470.733 233.348 470.7 233.442 470.637 233.513C470.573 233.584 470.485 233.627 470.391 233.632H469.668C469.575 233.627 469.486 233.584 469.423 233.513C469.36 233.442 469.327 233.348 469.331 233.252C469.335 233.348 469.302 233.442 469.239 233.513C469.176 233.584 469.088 233.627 468.994 233.632H468.271C468.177 233.627 468.089 233.584 468.026 233.513C467.962 233.442 467.929 233.348 467.933 233.252C467.938 233.348 467.904 233.442 467.841 233.513C467.778 233.584 467.69 233.627 467.596 233.632H466.873C466.779 233.627 466.691 233.584 466.628 233.513C466.565 233.442 466.532 233.348 466.536 233.252C466.54 233.348 466.507 233.442 466.444 233.513C466.38 233.584 466.292 233.627 466.199 233.632H465.475C465.382 233.627 465.294 233.584 465.23 233.513C465.167 233.442 465.134 233.348 465.138 233.252C465.142 233.348 465.109 233.442 465.046 233.513C464.983 233.584 464.895 233.627 464.801 233.632H464.078C464.031 233.63 463.985 233.618 463.943 233.598C463.901 233.578 463.863 233.549 463.832 233.514C463.8 233.478 463.776 233.437 463.761 233.392C463.745 233.347 463.738 233.299 463.741 233.252C463.745 233.348 463.712 233.442 463.648 233.513C463.585 233.584 463.497 233.627 463.403 233.632H462.68C462.586 233.627 462.498 233.584 462.435 233.513C462.372 233.442 462.339 233.348 462.343 233.252C462.347 233.348 462.314 233.442 462.251 233.513C462.187 233.584 462.099 233.627 462.006 233.632H461.282C461.189 233.627 461.101 233.584 461.037 233.513C460.974 233.442 460.941 233.348 460.945 233.252C460.949 233.348 460.916 233.442 460.853 233.513C460.79 233.584 460.702 233.627 460.608 233.632H459.885C459.791 233.627 459.703 233.584 459.64 233.513C459.577 233.442 459.543 233.348 459.548 233.252C459.552 233.348 459.519 233.442 459.455 233.513C459.392 233.584 459.304 233.627 459.21 233.632H458.487C458.393 233.627 458.305 233.584 458.242 233.513C458.179 233.442 458.146 233.348 458.15 233.252C458.154 233.348 458.121 233.442 458.058 233.513C457.995 233.584 457.906 233.627 457.813 233.632H457.09C456.996 233.627 456.908 233.584 456.844 233.513C456.781 233.442 456.748 233.348 456.752 233.252V232.841H474.922Z",
    fill: "#37474F"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M458.147 233.251C458.147 233.114 458.147 232.977 458.147 232.84C458.302 232.576 458.451 232.302 458.573 232.022C458.694 231.741 458.819 231.458 458.925 231.172C459.03 230.882 459.118 230.587 459.19 230.287L459.241 230.06C459.256 229.985 459.266 229.908 459.281 229.833C459.314 229.68 459.32 229.522 459.345 229.372C459.339 229.686 459.305 229.999 459.244 230.306C459.183 230.611 459.099 230.911 458.992 231.203C458.889 231.495 458.769 231.781 458.634 232.059C458.564 232.199 458.491 232.333 458.415 232.47C458.339 232.607 458.26 232.734 458.172 232.862C458.157 232.977 458.154 233.114 458.147 233.251Z",
    fill: "white"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M459.547 233.251C459.547 233.114 459.547 232.977 459.547 232.84C459.623 232.71 459.696 232.576 459.763 232.442C459.829 232.308 459.887 232.165 459.945 232.028C460.064 231.748 460.166 231.461 460.249 231.168C460.27 231.097 460.291 231.022 460.306 230.951C460.322 230.879 460.346 230.804 460.361 230.729C460.389 230.58 460.422 230.418 460.443 230.281C460.49 229.98 460.521 229.677 460.537 229.372C460.548 229.679 460.535 229.986 460.498 230.291C460.462 230.595 460.402 230.896 460.319 231.19C460.239 231.485 460.137 231.773 460.015 232.053C459.892 232.333 459.746 232.602 459.577 232.856V232.856C459.556 232.977 459.553 233.114 459.547 233.251Z",
    fill: "white"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M465.136 233.252C465.136 232.928 465.136 232.604 465.136 232.28C465.136 231.969 465.136 231.633 465.136 231.309C465.136 230.985 465.151 230.661 465.166 230.338L465.184 229.852C465.184 229.69 465.203 229.541 465.215 229.366V229.855V230.341C465.215 230.652 465.215 230.988 465.215 231.312C465.215 231.636 465.215 231.96 465.187 232.283C465.16 232.607 465.157 232.931 465.136 233.252Z",
    fill: "white"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M466.536 233.252C466.514 232.94 466.499 232.607 466.487 232.283C466.475 231.96 466.469 231.636 466.457 231.312C466.444 230.988 466.457 230.664 466.457 230.341V229.855C466.457 229.693 466.457 229.528 466.457 229.366C466.457 229.528 466.475 229.678 466.484 229.852L466.505 230.338C466.505 230.649 466.523 230.985 466.533 231.309C466.542 231.633 466.533 231.957 466.533 232.28C466.533 232.604 466.545 232.928 466.536 233.252Z",
    fill: "white"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M463.736 233.252C463.736 233.115 463.736 232.978 463.718 232.841C463.754 232.551 463.772 232.262 463.797 231.975C463.821 231.689 463.83 231.396 463.848 231.107C463.867 230.817 463.87 230.527 463.882 230.238L463.906 229.366C463.906 229.513 463.921 229.659 463.927 229.802C463.933 229.945 463.927 230.095 463.927 230.238C463.927 230.531 463.927 230.82 463.912 231.11C463.897 231.399 463.879 231.692 463.854 231.981C463.854 232.125 463.824 232.271 463.806 232.414C463.788 232.557 463.766 232.701 463.739 232.844C463.745 232.978 463.742 233.115 463.736 233.252Z",
    fill: "white"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M462.34 233.251C462.34 233.114 462.34 232.977 462.325 232.84C462.419 232.565 462.49 232.281 462.538 231.994C462.565 231.85 462.586 231.707 462.608 231.561C462.629 231.414 462.647 231.271 462.662 231.128C462.699 230.835 462.714 230.543 462.738 230.253L462.766 229.814C462.766 229.668 462.766 229.522 462.787 229.372C462.787 229.522 462.787 229.668 462.787 229.814C462.787 229.96 462.787 230.107 462.787 230.256C462.787 230.549 462.76 230.842 462.729 231.134C462.7 231.428 462.655 231.72 462.596 232.009C462.568 232.152 462.532 232.296 462.492 232.436C462.455 232.579 462.407 232.72 462.35 232.856V232.856C462.35 232.977 462.346 233.114 462.34 233.251Z",
    fill: "white"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M460.944 233.251C460.944 233.114 460.944 232.977 460.929 232.84C461.051 232.572 461.153 232.294 461.233 232.009C461.321 231.726 461.384 231.436 461.445 231.147C461.506 230.857 461.542 230.561 461.573 230.266C461.594 230.116 461.6 229.954 461.615 229.82C461.631 229.687 461.631 229.509 461.643 229.372C461.643 229.522 461.643 229.683 461.643 229.82V230.045C461.643 230.119 461.643 230.194 461.643 230.269L461.628 230.493L461.6 230.717C461.582 230.866 461.555 231.013 461.53 231.162C461.477 231.457 461.404 231.747 461.312 232.031C461.265 232.174 461.213 232.314 461.157 232.451C461.1 232.59 461.035 232.725 460.962 232.856V232.856C460.953 232.977 460.95 233.114 460.944 233.251Z",
    fill: "white"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M473.523 233.252C473.523 233.115 473.523 232.978 473.523 232.841C473.438 232.713 473.359 232.582 473.28 232.448C473.201 232.315 473.131 232.178 473.065 232.037C472.929 231.759 472.808 231.473 472.703 231.181C472.599 230.889 472.516 230.589 472.454 230.285C472.392 229.977 472.357 229.664 472.351 229.351C472.375 229.506 472.384 229.662 472.414 229.811C472.43 229.886 472.442 229.964 472.457 230.039L472.509 230.266C472.58 230.566 472.668 230.861 472.773 231.15C472.879 231.437 472.992 231.723 473.122 232C473.253 232.277 473.393 232.554 473.551 232.819C473.533 232.978 473.529 233.115 473.523 233.252Z",
    fill: "white"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M472.126 233.251C472.126 233.114 472.126 232.977 472.126 232.84C471.955 232.588 471.808 232.319 471.688 232.037C471.567 231.757 471.466 231.469 471.384 231.175C471.303 230.88 471.244 230.579 471.208 230.275C471.169 229.97 471.156 229.663 471.169 229.356C471.182 229.661 471.213 229.965 471.26 230.266C471.281 230.415 471.315 230.577 471.345 230.714C471.36 230.789 471.378 230.86 471.397 230.935C471.415 231.01 471.433 231.081 471.457 231.153C471.54 231.446 471.642 231.733 471.761 232.012C471.819 232.149 471.883 232.289 471.947 232.426C472.01 232.563 472.086 232.694 472.162 232.825C472.135 232.977 472.132 233.114 472.126 233.251Z",
    fill: "white"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M467.93 233.251C467.93 233.114 467.93 232.977 467.915 232.84C467.885 232.697 467.867 232.553 467.848 232.41C467.83 232.267 467.812 232.121 467.8 231.978C467.772 231.688 467.751 231.398 467.739 231.106C467.727 230.813 467.721 230.527 467.739 230.234C467.739 230.091 467.739 229.945 467.739 229.798C467.739 229.652 467.739 229.509 467.76 229.362L467.788 230.234C467.788 230.524 467.803 230.813 467.821 231.103C467.839 231.392 467.848 231.682 467.873 231.971C467.897 232.261 467.915 232.547 467.952 232.837C467.94 232.977 467.937 233.114 467.93 233.251Z",
    fill: "white"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M469.329 233.251C469.329 233.114 469.329 232.977 469.314 232.84C469.256 232.704 469.207 232.563 469.168 232.42C469.128 232.28 469.092 232.137 469.064 231.993C469.006 231.704 468.962 231.412 468.934 231.119C468.903 230.826 468.882 230.533 468.873 230.241C468.873 230.091 468.873 229.945 468.873 229.799C468.873 229.652 468.873 229.506 468.873 229.356C468.873 229.506 468.873 229.652 468.894 229.799L468.919 230.238C468.943 230.527 468.961 230.82 468.998 231.112C469.013 231.256 469.034 231.402 469.049 231.545C469.064 231.688 469.095 231.835 469.122 231.978C469.17 232.266 469.241 232.549 469.335 232.825C469.338 232.977 469.335 233.114 469.329 233.251Z",
    fill: "white"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M470.726 233.251C470.726 233.114 470.726 232.977 470.711 232.84C470.639 232.709 470.574 232.574 470.516 232.436C470.458 232.298 470.407 232.158 470.364 232.015C470.273 231.731 470.199 231.441 470.143 231.147C470.118 230.997 470.091 230.835 470.076 230.701C470.076 230.627 470.055 230.552 470.049 230.477L470.03 230.253C470.03 230.178 470.03 230.104 470.03 230.029V229.805C470.03 229.655 470.03 229.493 470.03 229.356C470.03 229.506 470.03 229.668 470.058 229.805C470.085 229.942 470.079 230.101 470.097 230.25C470.131 230.546 470.173 230.838 470.228 231.131C470.282 231.424 470.352 231.71 470.437 231.993C470.517 232.278 470.619 232.556 470.741 232.825V232.825C470.735 232.977 470.732 233.114 470.726 233.251Z",
    fill: "white"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.133 247.565C458.118 247.351 458.112 247.136 458.103 246.918C458.094 246.7 458.103 246.485 458.082 246.27C458.082 245.838 458.064 245.405 458.061 244.975V244.9H459.13C459.461 244.9 459.789 244.9 460.121 244.9L461.114 244.922L461.612 244.944C461.776 244.944 461.944 244.944 462.108 244.969L461.612 244.991L461.099 245.019C460.768 245.019 460.437 245.037 460.105 245.04C459.774 245.044 459.446 245.04 459.115 245.04H458.121L458.194 244.966C458.194 245.395 458.194 245.828 458.173 246.261C458.173 246.476 458.173 246.694 458.149 246.909C458.124 247.123 458.146 247.351 458.133 247.565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.534 244.975C462.534 245.189 462.555 245.404 462.565 245.622C462.574 245.84 462.58 246.055 462.586 246.27C462.586 246.703 462.604 247.135 462.607 247.565V247.64H461.532C461.197 247.64 460.863 247.64 460.529 247.64C460.195 247.64 459.857 247.64 459.523 247.618L459.022 247.596C458.855 247.596 458.688 247.596 458.521 247.571L459.022 247.549L459.523 247.528C459.857 247.528 460.195 247.509 460.529 247.506C460.863 247.503 461.197 247.506 461.532 247.506H462.534L462.461 247.58C462.461 247.151 462.461 246.718 462.483 246.285C462.483 246.071 462.483 245.853 462.504 245.638C462.525 245.423 462.522 245.189 462.534 244.975Z",
    fill: "black"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.7 247.075C458.7 246.807 458.682 246.536 458.679 246.268V245.864C458.679 245.73 458.679 245.596 458.679 245.462V245.428H459.45H460.186H460.921C461.167 245.428 461.41 245.428 461.656 245.453L460.921 245.474C460.675 245.474 460.429 245.474 460.186 245.474H458.712L458.749 245.44C458.749 245.574 458.749 245.708 458.749 245.842V246.247C458.721 246.536 458.712 246.807 458.7 247.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.961 245.462C461.961 245.73 461.982 246.001 461.985 246.268C461.988 246.536 461.985 246.807 461.985 247.075V247.112H461.219H460.475H459.731C459.485 247.112 459.235 247.112 458.989 247.087L459.731 247.065C459.98 247.065 460.229 247.065 460.475 247.065H461.961L461.927 247.1C461.927 246.832 461.927 246.561 461.927 246.293C461.927 246.025 461.952 245.73 461.961 245.462Z",
    fill: "black"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.2 247.075C464.2 246.807 464.182 246.536 464.179 246.268V245.864C464.179 245.73 464.179 245.596 464.179 245.462V245.428H464.947H465.683H466.421C466.664 245.428 466.91 245.428 467.156 245.453L466.421 245.474C466.175 245.474 465.929 245.474 465.683 245.474H464.212L464.246 245.44C464.246 245.574 464.246 245.708 464.246 245.842V246.247C464.218 246.536 464.209 246.807 464.2 247.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.476 245.462C467.476 245.73 467.494 246.001 467.5 246.268C467.506 246.536 467.5 246.807 467.5 247.075V247.112H466.725H465.981C465.732 247.112 465.486 247.112 465.236 247.112C464.987 247.112 464.741 247.112 464.495 247.087L465.236 247.065C465.486 247.065 465.732 247.065 465.981 247.065H467.476L467.442 247.1C467.442 246.832 467.442 246.561 467.442 246.293C467.442 246.025 467.451 245.73 467.476 245.462Z",
    fill: "black"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.635 247.565C463.635 247.351 463.614 247.136 463.605 246.918C463.596 246.7 463.59 246.485 463.584 246.27C463.584 245.838 463.566 245.405 463.562 244.975V244.9H464.629H465.623L466.616 244.922L467.114 244.944C467.278 244.944 467.446 244.944 467.61 244.969L467.114 244.991L466.616 245.012C466.285 245.012 465.954 245.031 465.623 245.034H464.629H463.638L463.711 244.96C463.711 245.389 463.711 245.822 463.687 246.255C463.687 246.47 463.687 246.687 463.666 246.902C463.645 247.117 463.648 247.351 463.635 247.565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.036 244.975C468.036 245.189 468.057 245.404 468.067 245.622C468.076 245.84 468.067 246.055 468.088 246.27C468.088 246.703 468.103 247.135 468.109 247.565V247.64H467.033C466.699 247.64 466.365 247.64 466.031 247.64C465.694 247.64 465.359 247.64 465.025 247.618L464.524 247.596C464.357 247.596 464.19 247.596 464.022 247.571L464.524 247.549L465.025 247.528C465.359 247.528 465.694 247.509 466.031 247.506C466.368 247.503 466.699 247.506 467.033 247.506H468.036L467.963 247.58C467.963 247.151 467.963 246.718 467.984 246.285C467.984 246.071 467.984 245.853 468.006 245.638C468.027 245.423 468.024 245.189 468.036 244.975Z",
    fill: "black"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.706 247.075C469.706 246.807 469.688 246.536 469.682 246.268V245.864C469.682 245.73 469.682 245.596 469.682 245.462V245.428H470.45H471.186C471.432 245.428 471.678 245.428 471.921 245.428C472.164 245.428 472.413 245.428 472.659 245.453L471.921 245.474C471.678 245.474 471.432 245.474 471.186 245.474H469.715L469.748 245.44C469.748 245.574 469.748 245.708 469.748 245.842V246.247C469.724 246.536 469.715 246.807 469.706 247.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.965 245.462C472.965 245.73 472.983 246.001 472.986 246.268C472.99 246.536 472.986 246.807 472.986 247.075V247.112H472.209H471.467C471.218 247.112 470.972 247.112 470.723 247.112C470.474 247.112 470.228 247.112 469.979 247.087L470.723 247.065C470.972 247.065 471.218 247.065 471.467 247.065H472.953L472.92 247.1C472.92 246.832 472.92 246.561 472.92 246.293C472.92 246.025 472.947 245.73 472.965 245.462Z",
    fill: "black"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.14 247.565C469.125 247.351 469.119 247.136 469.11 246.918C469.101 246.7 469.095 246.485 469.089 246.27C469.089 245.838 469.071 245.405 469.064 244.975V244.9H470.131H471.124L472.118 244.922L472.616 244.944C472.78 244.944 472.947 244.944 473.112 244.969L472.616 244.991L472.118 245.012C471.787 245.012 471.456 245.031 471.124 245.034H470.131H469.14L469.213 244.96C469.213 245.389 469.213 245.822 469.189 246.255C469.189 246.47 469.189 246.687 469.168 246.902C469.146 247.117 469.153 247.351 469.14 247.565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.539 244.975C473.539 245.189 473.56 245.404 473.569 245.622C473.579 245.84 473.569 246.055 473.591 246.27C473.591 246.703 473.591 247.135 473.612 247.565V247.64H472.536H471.531C471.196 247.64 470.862 247.64 470.528 247.618L470.027 247.596C469.86 247.596 469.693 247.596 469.525 247.571L470.027 247.549L470.519 247.509C470.853 247.509 471.187 247.49 471.522 247.487H472.527H473.53L473.457 247.562C473.457 247.132 473.457 246.699 473.478 246.267C473.478 246.052 473.478 245.834 473.5 245.619C473.521 245.404 473.527 245.189 473.539 244.975Z",
    fill: "black"
  }))), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M511.238 225.882H485.467V249.475H511.238V225.882Z",
    fill: "#455A64"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M517.065 225.882H511.237V249.475H517.065V225.882Z",
    fill: "#37474F"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M488.488 246.417H487.215V246.968H488.488V246.417Z",
    fill: "#37474F"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M487.779 247.111H486.506V247.662H487.779V247.111Z",
    fill: "#37474F"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M489.198 247.111H487.925V247.662H489.198V247.111Z",
    fill: "#37474F"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M506.089 226.615H504.815V227.166H506.089V226.615Z",
    fill: "#37474F"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M505.378 227.307H504.104V227.858H505.378V227.307Z",
    fill: "#37474F"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M506.796 227.307H505.522V227.858H506.796V227.307Z",
    fill: "#37474F"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M509.488 247.111H508.215V247.662H509.488V247.111Z",
    fill: "#37474F"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M498.439 228.807H497.166V229.358H498.439V228.807Z",
    fill: "#37474F"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M509.488 238.333H508.215V238.884H509.488V238.333Z",
    fill: "#37474F"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M510.202 239.026H508.929V239.577H510.202V239.026Z",
    fill: "#37474F"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M487.779 238.333H486.506V238.884H487.779V238.333Z",
    fill: "#37474F"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M498.227 242.46H499.5V241.909H498.227V242.46Z",
    fill: "#37474F"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M498.935 241.768H500.208V241.217H498.935V241.768Z",
    fill: "#37474F"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M490.896 227.723H487.45V233.127H490.896V227.723Z",
    fill: "#DBDBDB"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M490.612 228.012H487.729V232.844H490.612V228.012Z",
    fill: "#455A64"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.616 228.012V228.594L487.732 231.548V230.147L489.82 228.012H490.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.614 231.064V232.462L490.246 232.839H488.879L490.614 231.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.615 230.448V230.744L488.57 232.839H488.281L490.615 230.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.528 228.012L487.732 229.852V229.273L488.963 228.012H489.528Z",
    fill: "white"
  }))), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M490.612 229.395H487.729V229.681H490.612V229.395Z",
    fill: "#DBDBDB"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M495.701 227.723H492.256V233.127H495.701V227.723Z",
    fill: "#DBDBDB"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M495.416 228.012H492.532V232.844H495.416V228.012Z",
    fill: "#455A64"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.413 228.012V228.594L492.529 231.548V230.147L494.617 228.012H495.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.412 231.064V232.462L495.044 232.839H493.677L495.412 231.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.413 230.45V230.746L493.368 232.841H493.079L495.413 230.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.325 228.012L492.529 229.852V229.273L493.76 228.012H494.325Z",
    fill: "white"
  }))), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M495.416 229.395H492.532V229.681H495.416V229.395Z",
    fill: "#DBDBDB"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M504.04 227.723H500.595V233.127H504.04V227.723Z",
    fill: "#DBDBDB"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M503.759 228.012H500.876V232.844H503.759V228.012Z",
    fill: "#455A64"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.757 228.012V228.594L500.874 231.548V230.147L502.961 228.012H503.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.755 231.064V232.462L503.388 232.839H502.021L503.755 231.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.757 230.448V230.744L501.712 232.839H501.424L503.757 230.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.67 228.012L500.874 229.852V229.273L502.105 228.012H502.67Z",
    fill: "white"
  }))), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M503.759 229.395H500.876V229.681H503.759V229.395Z",
    fill: "#DBDBDB"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M508.84 227.723H505.395V233.127H508.84V227.723Z",
    fill: "#DBDBDB"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M508.562 228.012H505.679V232.844H508.562V228.012Z",
    fill: "#455A64"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.564 228.012V228.594L505.681 231.548V230.147L507.765 228.012H508.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.563 231.064V232.462L508.195 232.839H506.828L508.563 231.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.564 230.448V230.744L506.519 232.839H506.23L508.564 230.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.476 228.012L505.681 229.852V229.273L506.911 228.012H507.476Z",
    fill: "white"
  }))), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M508.562 229.395H505.679V229.681H508.562V229.395Z",
    fill: "#DBDBDB"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M511.644 248.929H485.062V249.477H511.644V248.929Z",
    fill: "#37474F"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M511.644 225.887H485.062V226.435H511.644V225.887Z",
    fill: "#455A64"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M504.391 239.163H500.01V249.475H504.391V239.163Z",
    fill: "#263238"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M503.644 239.934H500.761V244.766H503.644V239.934Z",
    fill: "#455A64"
  })), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.641 239.933V240.515L500.758 243.469V242.071L502.845 239.933H503.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.64 242.985V244.383L503.273 244.763H501.905L503.64 242.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.641 242.374V242.67L501.596 244.765H501.308L503.641 242.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.553 239.933L500.758 241.773V241.194L501.988 239.933H502.553Z",
    fill: "white"
  }))), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M504.099 245.223H503.835V246.412H504.099V245.223Z",
    fill: "white"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M504.462 249.478H508.844V239.166H504.462V249.478Z",
    fill: "#263238"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M508.099 239.934H505.216V244.766H508.099V239.934Z",
    fill: "#455A64"
  })), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.213 239.933V240.515L508.099 243.469V242.071L506.012 239.933H505.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.213 242.985V244.383L505.584 244.763H506.948L505.213 242.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.213 242.374V242.67L507.261 244.765H507.546L505.213 242.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.302 239.933L508.097 241.773V241.194L506.867 239.933H506.302Z",
    fill: "white"
  }))), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M504.756 246.412H505.021V245.223H504.756V246.412Z",
    fill: "white"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M509.573 223.444H487.135V225.882H509.573V223.444Z",
    fill: "#37474F"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M488.135 223.881H487.722V225.472H488.135V223.881Z",
    fill: "#455A64"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M489.235 223.881H488.821V225.472H489.235V223.881Z",
    fill: "#455A64"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M490.329 223.881H489.916V225.472H490.329V223.881Z",
    fill: "#455A64"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M491.428 223.881H491.015V225.472H491.428V223.881Z",
    fill: "#455A64"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M492.524 223.881H492.11V225.472H492.524V223.881Z",
    fill: "#455A64"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M493.621 223.881H493.208V225.472H493.621V223.881Z",
    fill: "#455A64"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M494.718 223.881H494.305V225.472H494.718V223.881Z",
    fill: "#455A64"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M495.818 223.881H495.405V225.472H495.818V223.881Z",
    fill: "#455A64"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M496.914 223.881H496.501V225.472H496.914V223.881Z",
    fill: "#455A64"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M498.011 223.881H497.598V225.472H498.011V223.881Z",
    fill: "#455A64"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M499.11 223.881H498.696V225.472H499.11V223.881Z",
    fill: "#455A64"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M500.205 223.881H499.792V225.472H500.205V223.881Z",
    fill: "#455A64"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M501.303 223.881H500.89V225.472H501.303V223.881Z",
    fill: "#455A64"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M502.399 223.881H501.985V225.472H502.399V223.881Z",
    fill: "#455A64"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M503.496 223.881H503.083V225.472H503.496V223.881Z",
    fill: "#455A64"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M504.593 223.881H504.18V225.472H504.593V223.881Z",
    fill: "#455A64"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M505.691 223.881H505.277V225.472H505.691V223.881Z",
    fill: "#455A64"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M506.785 223.881H506.372V225.472H506.785V223.881Z",
    fill: "#455A64"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M507.887 223.881H507.474V225.472H507.887V223.881Z",
    fill: "#455A64"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M508.984 223.881H508.57V225.472H508.984V223.881Z",
    fill: "#455A64"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M516.213 223.444H509.547V225.882H516.213V223.444Z",
    fill: "#263238"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M510.188 223.881H509.924V225.472H510.188V223.881Z",
    fill: "#37474F"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M510.89 223.881H510.626V225.472H510.89V223.881Z",
    fill: "#37474F"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M511.591 223.881H511.326V225.472H511.591V223.881Z",
    fill: "#37474F"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M512.295 223.881H512.03V225.472H512.295V223.881Z",
    fill: "#37474F"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M512.995 223.881H512.73V225.472H512.995V223.881Z",
    fill: "#37474F"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M513.699 223.881H513.435V225.472H513.699V223.881Z",
    fill: "#37474F"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M514.397 223.881H514.133V225.472H514.397V223.881Z",
    fill: "#37474F"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M515.098 223.881H514.834V225.472H515.098V223.881Z",
    fill: "#37474F"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8 223.881H515.536V225.472H515.8V223.881Z",
    fill: "#37474F"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M492.318 241.661V245.92H487.457V241.661C487.457 241 487.713 240.367 488.169 239.899C488.625 239.432 489.243 239.17 489.888 239.17C490.532 239.17 491.151 239.432 491.606 239.899C492.062 240.367 492.318 241 492.318 241.661Z",
    fill: "#DBDBDB"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M492.037 241.661V245.64H487.729V241.661C487.729 241.076 487.955 240.515 488.359 240.101C488.763 239.687 489.311 239.454 489.883 239.454C490.454 239.454 491.002 239.687 491.406 240.101C491.81 240.515 492.037 241.076 492.037 241.661Z",
    fill: "#455A64"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M492.037 241.662V245.64H487.729V241.662C487.729 241.516 487.742 241.372 487.768 241.229C487.852 240.801 488.058 240.408 488.36 240.099C488.662 239.791 489.046 239.58 489.463 239.495C489.602 239.467 489.742 239.453 489.883 239.454C489.953 239.454 490.019 239.454 490.086 239.454C490.416 239.482 490.734 239.589 491.016 239.765C491.306 239.951 491.55 240.204 491.727 240.503C491.804 240.633 491.867 240.771 491.915 240.914C491.944 240.992 491.966 241.072 491.982 241.154C492.02 241.32 492.039 241.491 492.037 241.662V241.662Z",
    fill: "#455A64"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M492.037 241.62H487.729V241.907H492.037V241.62Z",
    fill: "#DBDBDB"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M489.237 241.621V239.364H488.958V241.621H489.237Z",
    fill: "#DBDBDB"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M490.808 241.621V239.364H490.528V241.621H490.808Z",
    fill: "#DBDBDB"
  })), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.731 240.521L487.732 244.618V243.149L491.02 239.78C491.311 239.966 491.554 240.22 491.731 240.521V240.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.986 241.174L487.732 245.532V245.221L491.919 240.931C491.948 241.01 491.97 241.091 491.986 241.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.09 239.463L487.732 241.879V241.662C487.733 241.516 487.746 241.372 487.772 241.229L489.467 239.495C489.605 239.467 489.746 239.453 489.887 239.454C489.966 239.454 490.023 239.457 490.09 239.463Z",
    fill: "white"
  }))), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M498.312 241.661V245.92H493.45V241.661C493.45 241 493.706 240.367 494.162 239.899C494.618 239.432 495.236 239.17 495.881 239.17C496.526 239.17 497.144 239.432 497.6 239.899C498.055 240.367 498.312 241 498.312 241.661Z",
    fill: "#DBDBDB"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M498.033 241.661V245.64H493.725V241.661C493.725 241.076 493.952 240.515 494.356 240.101C494.76 239.687 495.307 239.454 495.879 239.454C496.45 239.454 496.998 239.687 497.402 240.101C497.806 240.515 498.033 241.076 498.033 241.661Z",
    fill: "#455A64"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M498.033 241.662V245.64H493.725V241.662C493.725 241.516 493.738 241.372 493.764 241.229C493.849 240.801 494.055 240.408 494.356 240.099C494.658 239.791 495.042 239.58 495.46 239.495C495.598 239.467 495.738 239.453 495.879 239.454C495.949 239.454 496.016 239.454 496.082 239.454C496.412 239.482 496.73 239.589 497.012 239.765C497.302 239.951 497.546 240.204 497.723 240.503C497.8 240.633 497.864 240.771 497.911 240.914C497.94 240.992 497.962 241.072 497.978 241.154C498.016 241.32 498.035 241.491 498.033 241.662Z",
    fill: "#455A64"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M498.033 241.62H493.725V241.907H498.033V241.62Z",
    fill: "#DBDBDB"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M495.234 241.621V239.364H494.955V241.621H495.234Z",
    fill: "#DBDBDB"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M496.8 241.621V239.364H496.52V241.621H496.8Z",
    fill: "#DBDBDB"
  })), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.722 240.521L493.724 244.618V243.149L497.011 239.78C497.302 239.966 497.545 240.22 497.722 240.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.977 241.174L493.724 245.532V245.221L497.91 240.931C497.939 241.01 497.961 241.091 497.977 241.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.081 239.463L493.724 241.879V241.662C493.724 241.516 493.738 241.372 493.763 241.229L495.459 239.495C495.597 239.467 495.737 239.453 495.878 239.454C495.948 239.454 496.015 239.457 496.081 239.463Z",
    fill: "white"
  }))), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M511.183 234.603H485.467V237.781H511.183V234.603Z",
    fill: "#263238"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M511.183 237.212H485.467V237.277H511.183V237.212Z",
    fill: "white"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M511.183 235.107H485.467V235.173H511.183V235.107Z",
    fill: "white"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M712.67 169.098C714.388 169.098 757.268 168.792 769.383 168.792C770.229 168.792 769.161 167.29 768.693 167.185C767.204 166.845 765.652 166.845 764.14 166.672C762.646 166.528 761.182 166.153 759.798 165.56C758.608 165.044 757.417 164.446 756.127 164.242C753.633 163.841 751.444 165.227 749.103 165.839C748.392 166.049 747.646 166.104 746.913 166.001C746.18 165.898 745.477 165.639 744.847 165.241C743.766 164.561 742.781 163.78 741.65 163.202C739.485 162.11 737.123 161.488 734.713 161.375C732.302 161.262 729.895 161.661 727.641 162.546C726.566 162.968 725.537 163.507 724.573 164.153C723.433 164.921 722.448 165.904 721.3 166.661C718.76 168.361 715.619 167.8 712.849 168.765C712.694 168.806 712.515 169.098 712.67 169.098Z",
    fill: "#EBEBEB"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M660.3 199.634C662.572 199.634 700.798 199.893 703.203 199.811C703.375 199.811 703.468 199.546 703.296 199.471C701.78 198.703 700.062 198.856 698.49 198.312C697.565 197.993 696.994 197.371 696.351 196.661C695.818 196.04 695.13 195.579 694.361 195.329C693.657 195.113 692.91 195.089 692.195 195.261C691.419 195.451 690.746 195.906 690.003 196.192C688.169 196.902 686.385 196.226 685.071 194.832C683.99 193.684 682.929 192.6 681.456 191.981C680.856 191.704 680.206 191.556 679.548 191.546C678.89 191.537 678.236 191.667 677.629 191.927C676.226 192.579 675.264 193.888 673.948 194.676C672.385 195.611 670.518 195.39 668.794 195.672C667.069 195.954 665.752 197.446 664.237 198.292C663.741 198.618 663.167 198.799 662.578 198.815C662.247 198.815 661.915 198.713 661.584 198.669C661.063 198.605 660.569 198.618 660.217 199.063C660.131 199.172 660.151 199.634 660.3 199.634Z",
    fill: "#EBEBEB"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M703.75 124.083C705.408 124.083 733.317 124.27 735.071 124.216C735.197 124.216 735.267 124.022 735.141 123.957C734.036 123.397 732.779 123.509 731.632 123.111C731.016 122.858 730.477 122.442 730.07 121.905C729.681 121.452 729.179 121.116 728.617 120.933C728.104 120.775 727.56 120.758 727.038 120.882C726.492 121.073 725.958 121.3 725.44 121.562C724.113 122.078 722.787 121.585 721.838 120.569C721.049 119.73 720.273 118.941 719.185 118.489C718.746 118.287 718.272 118.179 717.791 118.172C717.31 118.165 716.833 118.259 716.389 118.449C715.368 118.924 714.664 119.879 713.703 120.457C712.562 121.137 711.199 120.977 709.938 121.184C708.678 121.392 707.713 122.476 706.622 123.101C706.263 123.339 705.846 123.471 705.418 123.482C705.173 123.482 704.93 123.407 704.685 123.376C704.509 123.326 704.324 123.327 704.148 123.378C703.973 123.429 703.814 123.528 703.69 123.665C703.627 123.747 703.64 124.083 703.75 124.083Z",
    fill: "#EBEBEB"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M698.1 190.133C699.759 190.133 727.667 190.32 729.422 190.262C729.548 190.262 729.617 190.069 729.491 190.008C728.384 189.443 727.13 189.559 725.982 189.161C725.367 188.908 724.828 188.492 724.42 187.955C724.032 187.501 723.529 187.165 722.968 186.983C722.455 186.825 721.911 186.808 721.389 186.932C720.843 187.125 720.309 187.352 719.79 187.612C718.447 188.132 717.137 187.639 716.189 186.623C715.399 185.783 714.623 184.992 713.536 184.543C713.097 184.339 712.623 184.23 712.142 184.223C711.661 184.216 711.183 184.311 710.74 184.502C709.715 184.978 709.015 185.933 708.053 186.507C706.912 187.187 705.549 187.031 704.289 187.234C703.029 187.438 702.064 188.529 700.972 189.155C700.612 189.391 700.196 189.523 699.769 189.535C699.523 189.535 699.281 189.46 699.036 189.43C698.86 189.38 698.674 189.38 698.499 189.431C698.323 189.482 698.165 189.582 698.041 189.719C697.978 189.797 697.991 190.133 698.1 190.133Z",
    fill: "#EBEBEB"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M754.536 161.582C756.194 161.582 784.106 161.768 785.86 161.711C785.986 161.711 786.053 161.517 785.93 161.452C784.822 160.892 783.569 161.004 782.421 160.61C781.805 160.356 781.266 159.94 780.859 159.403C780.47 158.95 779.968 158.613 779.406 158.431C778.892 158.274 778.347 158.256 777.824 158.38C777.278 158.572 776.744 158.799 776.226 159.06C774.899 159.58 773.573 159.087 772.627 158.068C771.838 157.232 771.062 156.44 769.974 155.991C769.536 155.787 769.062 155.678 768.58 155.671C768.099 155.664 767.622 155.759 767.178 155.95C766.154 156.426 765.45 157.381 764.489 157.955C763.351 158.635 761.988 158.475 760.728 158.683C759.467 158.89 758.502 159.974 757.411 160.599C757.051 160.836 756.635 160.969 756.207 160.983C755.962 160.983 755.72 160.909 755.474 160.878C755.299 160.828 755.113 160.828 754.938 160.878C754.762 160.928 754.604 161.027 754.479 161.164C754.416 161.245 754.43 161.582 754.536 161.582Z",
    fill: "#EBEBEB"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M741.834 213.077H789.224C789.416 213.077 789.486 212.87 789.294 212.778C787.596 211.959 785.695 212.173 783.937 211.606C782.903 211.266 782.259 210.586 781.53 209.825C780.925 209.149 780.152 208.656 779.294 208.398C778.509 208.172 777.68 208.163 776.89 208.37C776.034 208.598 775.298 209.118 774.485 209.454C772.462 210.287 770.469 209.58 768.983 208.065C767.759 206.817 766.555 205.641 764.91 205.006C764.238 204.711 763.514 204.561 762.783 204.567C762.052 204.572 761.33 204.732 760.662 205.037C759.123 205.791 758.085 207.266 756.642 208.17C754.931 209.244 752.855 209.043 750.951 209.397C749.048 209.75 747.456 210.593 745.797 211.578C745.257 211.95 744.629 212.163 743.98 212.197C743.605 212.197 743.237 212.098 742.865 212.061C742.285 212 741.738 212.027 741.36 212.53C741.267 212.649 740.706 213.077 741.834 213.077Z",
    fill: "#EBEBEB"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M762.343 175.694L773.095 169.217C773.97 168.678 774.896 168.229 775.858 167.878L778.226 167.001C778.302 166.971 770.193 172.778 770.193 172.778L762.343 175.694Z",
    fill: "#DBDBDB"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M767.366 173.823C770.259 171.585 773.285 169.534 776.427 167.682C773.535 169.92 770.508 171.971 767.366 173.823Z",
    fill: "#C7C7C7"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M781.866 171.427L781.942 171.688L782.447 171.821L782.801 171.712L783.153 171.318L783.077 171.053L781.866 171.427Z",
    fill: "#37474F"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M782.177 172.487C782.214 172.609 782.284 172.718 782.381 172.799C782.477 172.88 782.594 172.93 782.718 172.943C782.842 172.955 782.967 172.93 783.077 172.87C783.187 172.81 783.277 172.718 783.336 172.605C783.395 172.492 783.42 172.365 783.408 172.237C783.396 172.11 783.347 171.99 783.268 171.891C783.189 171.792 783.084 171.72 782.964 171.682C782.845 171.645 782.718 171.645 782.599 171.682C782.519 171.706 782.446 171.747 782.381 171.8C782.317 171.854 782.264 171.92 782.225 171.995C782.186 172.07 782.162 172.152 782.153 172.236C782.145 172.321 782.153 172.406 782.177 172.487Z",
    fill: "#263238"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M782.457 172.403C782.469 172.447 782.49 172.488 782.517 172.523C782.545 172.559 782.58 172.589 782.619 172.61C782.659 172.632 782.702 172.645 782.746 172.649C782.791 172.653 782.836 172.648 782.878 172.634C782.94 172.613 782.995 172.575 783.035 172.523C783.076 172.47 783.1 172.407 783.106 172.341C783.112 172.275 783.099 172.208 783.068 172.149C783.037 172.09 782.99 172.042 782.933 172.011C782.875 171.979 782.81 171.966 782.745 171.972C782.68 171.978 782.619 172.004 782.568 172.046C782.517 172.087 782.48 172.144 782.46 172.207C782.44 172.271 782.439 172.339 782.457 172.403Z",
    fill: "#DBDBDB"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M760.163 178.105L760.239 178.37L760.743 178.502L761.098 178.394L761.45 177.996L761.37 177.734L760.163 178.105Z",
    fill: "#37474F"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M760.47 179.17C760.506 179.293 760.576 179.403 760.673 179.485C760.769 179.567 760.887 179.618 761.012 179.632C761.137 179.645 761.263 179.62 761.373 179.56C761.484 179.5 761.575 179.408 761.635 179.294C761.695 179.181 761.72 179.053 761.708 178.925C761.696 178.797 761.648 178.675 761.568 178.576C761.489 178.476 761.383 178.403 761.263 178.365C761.143 178.328 761.015 178.327 760.895 178.365C760.815 178.389 760.741 178.429 760.676 178.482C760.612 178.536 760.559 178.602 760.519 178.677C760.48 178.752 760.455 178.834 760.447 178.918C760.438 179.003 760.446 179.089 760.47 179.17Z",
    fill: "#263238"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M760.751 179.093C760.777 179.183 760.837 179.259 760.918 179.304C760.998 179.349 761.093 179.359 761.181 179.332C761.269 179.306 761.343 179.245 761.387 179.162C761.431 179.079 761.441 178.982 761.415 178.892C761.403 178.848 761.382 178.806 761.354 178.77C761.326 178.733 761.292 178.703 761.252 178.681C761.212 178.659 761.168 178.646 761.123 178.642C761.078 178.638 761.033 178.643 760.99 178.658C760.946 178.669 760.904 178.689 760.867 178.717C760.831 178.745 760.8 178.781 760.778 178.822C760.756 178.863 760.742 178.908 760.737 178.954C760.732 179.001 760.737 179.048 760.751 179.093Z",
    fill: "#DBDBDB"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M758.36 178.659L758.437 178.924L758.944 179.056L759.299 178.947L759.647 178.55L759.571 178.288L758.36 178.659Z",
    fill: "#37474F"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M758.674 179.723C758.709 179.846 758.78 179.956 758.877 180.038C758.973 180.12 759.092 180.17 759.217 180.184C759.341 180.197 759.467 180.171 759.578 180.111C759.689 180.051 759.78 179.958 759.839 179.844C759.898 179.731 759.923 179.602 759.911 179.474C759.899 179.346 759.85 179.225 759.77 179.125C759.69 179.026 759.583 178.953 759.463 178.916C759.343 178.879 759.215 178.88 759.095 178.917C759.015 178.942 758.942 178.982 758.878 179.036C758.813 179.09 758.76 179.156 758.721 179.231C758.682 179.305 758.658 179.387 758.65 179.472C758.641 179.556 758.65 179.641 758.674 179.723Z",
    fill: "#263238"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M758.944 179.633C758.956 179.678 758.976 179.72 759.004 179.756C759.032 179.793 759.067 179.823 759.107 179.845C759.146 179.866 759.19 179.88 759.235 179.884C759.28 179.888 759.325 179.883 759.368 179.868C759.456 179.841 759.53 179.78 759.574 179.698C759.618 179.615 759.628 179.518 759.602 179.428C759.576 179.338 759.516 179.262 759.436 179.217C759.355 179.172 759.261 179.162 759.173 179.188C759.128 179.2 759.086 179.221 759.05 179.251C759.013 179.28 758.984 179.317 758.962 179.359C758.94 179.401 758.928 179.447 758.925 179.494C758.921 179.542 758.928 179.589 758.944 179.633Z",
    fill: "#DBDBDB"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M742.666 178.771L738.05 172.297L739.376 171.957C740.136 171.76 740.939 171.835 741.652 172.171L746.003 174.231C746.99 174.683 748.048 174.948 749.127 175.016L753.147 175.312L742.666 178.771Z",
    fill: "#FFC727"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M741.699 179.134C743.562 178.407 751.711 175.596 762.752 172.198C773.793 168.8 779.059 167.311 780.529 166.954C781.998 166.598 783.719 167.25 783.719 167.25L784.81 167.75C784.81 167.75 786.293 167.967 786.468 168.609C786.644 169.252 784.986 170.73 780.605 172.191C773.328 174.618 762.901 177.775 756.232 179.328C753.598 179.936 743.519 179.987 742.365 179.987C741.576 179.987 741.277 179.889 741.145 179.722C741.012 179.556 741.367 179.26 741.699 179.134Z",
    fill: "#EBEBEB"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M744.598 179.718L742.246 181.713L738.847 182.76L741.457 179.694L744.598 179.718Z",
    fill: "#DBDBDB"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M750.418 179.818C752.856 179.719 755.164 179.563 756.235 179.318C762.905 177.775 773.332 174.622 780.608 172.182C784.99 170.72 786.661 169.242 786.472 168.6C786.25 168.871 783.766 170.037 781.053 170.873C778.731 171.597 756.676 178.003 750.418 179.818Z",
    fill: "#FFC727"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M769.898 177.672L766.379 178.755C766.081 178.847 765.759 178.814 765.485 178.662C765.211 178.511 765.006 178.255 764.917 177.949L764.881 177.825C764.791 177.52 764.824 177.19 764.971 176.909C765.119 176.628 765.369 176.419 765.667 176.327L769.187 175.244L769.898 177.672Z",
    fill: "#EBEBEB"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M768.895 176.653C769.094 177.333 769.539 177.778 769.89 177.673C770.242 177.567 770.374 176.932 770.175 176.262C769.976 175.593 769.535 175.137 769.18 175.243C768.826 175.348 768.703 175.984 768.895 176.653Z",
    fill: "#C7C7C7"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M769.062 176.607C769.228 177.171 769.59 177.562 769.875 177.473C770.16 177.385 770.253 176.855 770.084 176.291C769.915 175.727 769.557 175.336 769.271 175.421C768.986 175.506 768.897 176.036 769.062 176.607Z",
    fill: "#263238"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M769.889 173.35L758.812 179.202C757.905 179.682 756.954 180.07 755.973 180.361L753.562 181.101C753.482 181.129 761.897 175.81 761.897 175.81L769.889 173.35Z",
    fill: "#DBDBDB"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M764.781 174.924C761.77 176.993 758.637 178.868 755.398 180.538C758.409 178.468 761.542 176.593 764.781 174.924Z",
    fill: "#C7C7C7"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M783.244 167.44L784.193 168.028C784.403 167.956 784.607 167.862 784.8 167.75L783.708 167.25C783.536 167.325 783.38 167.386 783.244 167.44Z",
    fill: "#37474F"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M782.411 168.636C783.174 168.402 783.698 168.218 784.069 168.082L783.121 167.494C782.594 167.688 782.219 167.797 782.219 167.797L782.411 168.636Z",
    fill: "#37474F"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M778.342 169.71L778.659 169.612L778.501 169.072L778.183 169.17L778.342 169.71Z",
    fill: "#37474F"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M777.749 169.893L778.066 169.795L777.908 169.255L777.59 169.352L777.749 169.893Z",
    fill: "#37474F"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M777.154 170.064L777.472 169.966L777.313 169.426L776.996 169.523L777.154 170.064Z",
    fill: "#37474F"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M776.552 170.263L776.87 170.165L776.712 169.625L776.394 169.723L776.552 170.263Z",
    fill: "#37474F"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M775.958 170.442L776.275 170.345L776.117 169.804L775.799 169.902L775.958 170.442Z",
    fill: "#37474F"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M775.364 170.613L775.682 170.516L775.523 169.975L775.206 170.073L775.364 170.613Z",
    fill: "#37474F"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M774.763 170.81L775.081 170.712L774.923 170.172L774.605 170.269L774.763 170.81Z",
    fill: "#37474F"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M774.172 170.978L774.489 170.88L774.331 170.34L774.013 170.437L774.172 170.978Z",
    fill: "#37474F"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M773.57 171.181L773.888 171.083L773.729 170.543L773.412 170.64L773.57 171.181Z",
    fill: "#37474F"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M772.975 171.361L773.293 171.264L773.135 170.723L772.817 170.821L772.975 171.361Z",
    fill: "#37474F"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M772.381 171.53L772.698 171.433L772.54 170.892L772.222 170.99L772.381 171.53Z",
    fill: "#37474F"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M771.782 171.733L772.1 171.635L771.941 171.094L771.624 171.192L771.782 171.733Z",
    fill: "#37474F"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M771.185 171.911L771.503 171.813L771.345 171.273L771.027 171.371L771.185 171.911Z",
    fill: "#37474F"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M770.589 172.086L770.906 171.988L770.748 171.448L770.43 171.546L770.589 172.086Z",
    fill: "#37474F"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M769.991 172.278L770.309 172.181L770.15 171.64L769.833 171.738L769.991 172.278Z",
    fill: "#37474F"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M769.393 172.464L769.711 172.366L769.553 171.826L769.235 171.924L769.393 172.464Z",
    fill: "#37474F"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M768.799 172.635L769.116 172.537L768.958 171.997L768.64 172.095L768.799 172.635Z",
    fill: "#37474F"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M768.201 172.827L768.519 172.729L768.36 172.189L768.043 172.287L768.201 172.827Z",
    fill: "#37474F"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M767.608 172.995L767.926 172.897L767.767 172.357L767.45 172.455L767.608 172.995Z",
    fill: "#37474F"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M767.01 173.185L767.328 173.087L767.17 172.547L766.852 172.644L767.01 173.185Z",
    fill: "#37474F"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M766.412 173.375L766.729 173.277L766.571 172.737L766.253 172.835L766.412 173.375Z",
    fill: "#37474F"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M765.815 173.553L766.133 173.455L765.974 172.915L765.657 173.013L765.815 173.553Z",
    fill: "#37474F"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M765.215 173.751L765.532 173.653L765.374 173.113L765.056 173.211L765.215 173.751Z",
    fill: "#37474F"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M764.624 173.928L764.941 173.83L764.783 173.29L764.465 173.388L764.624 173.928Z",
    fill: "#37474F"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M764.026 174.105L764.344 174.007L764.185 173.467L763.868 173.564L764.026 174.105Z",
    fill: "#37474F"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M763.43 174.296L763.748 174.198L763.59 173.658L763.272 173.756L763.43 174.296Z",
    fill: "#37474F"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M762.831 174.482L763.148 174.384L762.99 173.844L762.672 173.941L762.831 174.482Z",
    fill: "#37474F"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M762.236 174.653L762.554 174.556L762.395 174.015L762.078 174.113L762.236 174.653Z",
    fill: "#37474F"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M759.849 175.399L760.167 175.301L760.009 174.76L759.691 174.858L759.849 175.399Z",
    fill: "#37474F"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M759.252 175.574L759.569 175.477L759.411 174.936L759.093 175.034L759.252 175.574Z",
    fill: "#37474F"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M758.659 175.766L758.977 175.668L758.818 175.128L758.501 175.225L758.659 175.766Z",
    fill: "#37474F"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M758.06 175.95L758.378 175.853L758.22 175.312L757.902 175.41L758.06 175.95Z",
    fill: "#37474F"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M757.466 176.126L757.783 176.028L757.625 175.488L757.307 175.586L757.466 176.126Z",
    fill: "#37474F"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M756.869 176.317L757.187 176.219L757.028 175.678L756.711 175.776L756.869 176.317Z",
    fill: "#37474F"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M756.27 176.499L756.588 176.401L756.43 175.861L756.112 175.959L756.27 176.499Z",
    fill: "#37474F"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M755.675 176.675L755.992 176.577L755.834 176.037L755.516 176.135L755.675 176.675Z",
    fill: "#37474F"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M755.074 176.868L755.392 176.771L755.233 176.23L754.916 176.328L755.074 176.868Z",
    fill: "#37474F"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M754.482 177.042L754.8 176.944L754.641 176.404L754.324 176.502L754.482 177.042Z",
    fill: "#37474F"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M753.885 177.228L754.202 177.13L754.044 176.59L753.726 176.687L753.885 177.228Z",
    fill: "#37474F"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M779.655 170.869C780.05 170.73 780.418 170.587 780.786 170.465L780.75 170.529C780.534 169.877 780.342 169.218 780.14 168.558L780.243 168.616L779.095 168.956L779.145 168.864C779.321 169.513 779.476 170.169 779.655 170.869ZM779.655 170.869C779.437 170.227 779.198 169.53 778.992 168.83L779.062 168.81L780.203 168.446L780.282 168.419L780.306 168.504C780.498 169.184 780.697 169.863 780.869 170.543C780.461 170.662 780.047 170.757 779.662 170.859L779.655 170.869Z",
    fill: "#C7C7C7"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M741.202 179.456C742.814 178.647 756.873 174.324 764.252 172.054C770.149 170.239 778.019 167.826 780.835 167.204C781.417 167.067 782.009 166.984 782.606 166.956C781.918 166.815 781.21 166.815 780.523 166.956C779.054 167.313 773.784 168.802 762.746 172.2C751.709 175.598 743.554 178.412 741.7 179.133C741.512 179.201 741.342 179.311 741.202 179.456Z",
    fill: "#DBDBDB"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M744.741 178.075L744.184 178.258L742.668 178.754L739.879 174.826L739.076 173.694C740.579 173.575 742.234 173.64 743.219 174.289C744.386 175.074 744.701 176.732 744.741 178.075Z",
    fill: "#37474F"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M744.184 178.272L742.668 178.755L739.879 174.826C741.351 175.227 742.92 175.863 743.646 176.828C743.952 177.249 744.138 177.749 744.184 178.272Z",
    fill: "#FFC727"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M693.745 161.209H677.04V251.956H693.745V161.209Z",
    fill: "#FFC727"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.745 161.209H677.04V251.956H693.745V161.209Z",
    fill: "white"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M677.04 161.209V162.762L693.745 164.234V161.209H677.04Z",
    fill: "#FFC727"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.745 189.368H677.04V193.929H693.745V189.368Z",
    fill: "#FFC727"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.745 198.258H677.04V202.818H693.745V198.258Z",
    fill: "#FFC727"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.745 207.149H677.04V211.71H693.745V207.149Z",
    fill: "#FFC727"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M693.745 216.039H677.04V251.957H693.745V216.039Z",
    fill: "#FFC727"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M692.213 161.209H688.001V251.956H692.213V161.209Z",
    fill: "white"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M692.805 132.312H677.983V137.097H692.805V132.312Z",
    fill: "#455A64"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M681.559 132.312H677.983V137.097H681.559V132.312Z",
    fill: "white"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M688.053 123.463H682.727V132.312H688.053V123.463Z",
    fill: "#FFC727"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M685.072 123.463H683.51V132.312H685.072V123.463Z",
    fill: "white"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M688.053 125.902H682.727V126.949H688.053V125.902Z",
    fill: "#455A64"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M688.053 127.769H682.727V128.815H688.053V127.769Z",
    fill: "#455A64"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M688.053 129.636H682.727V130.682H688.053V129.636Z",
    fill: "#455A64"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M686.166 116.392H684.62V123.464H686.166V116.392Z",
    fill: "#455A64"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M685.617 111.81H685.166V118.63H685.617V111.81Z",
    fill: "#455A64"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M707.483 132.781C705.264 134.368 701.844 134.086 699.238 131.921C696.631 129.756 695.636 126.395 696.687 123.84L707.483 132.781Z",
    fill: "#C7C7C7"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M697.587 137.097H696.592V133.937L702.834 126.939L703.566 127.626L697.587 134.334V137.097Z",
    fill: "#C7C7C7"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M707.701 140.648L701.851 161.212H668.931L663.084 140.648H707.701Z",
    fill: "#FFC727"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M707.701 140.648L701.851 161.212H668.931L663.084 140.648H707.701Z",
    fill: "white"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M663.084 140.648L663.92 143.591L707.28 142.12L707.701 140.648H663.084Z",
    fill: "#FFC727"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M667.154 145.156V152.296H666.394L664.361 145.156H667.154Z",
    fill: "#455A64"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M666.691 153.346H667.152V154.967L666.691 153.346Z",
    fill: "#455A64"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M674.244 145.156H668.168V152.296H674.244V145.156Z",
    fill: "#455A64"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M674.244 153.346H668.168V157.774H674.244V153.346Z",
    fill: "#455A64"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M681.337 145.156H675.274V152.296H681.337V145.156Z",
    fill: "#455A64"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M681.337 153.346H675.274V157.774H681.337V153.346Z",
    fill: "#455A64"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M688.424 145.156H682.361V152.296H688.424V145.156Z",
    fill: "#455A64"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M688.424 153.346H682.361V157.774H688.424V153.346Z",
    fill: "#455A64"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M695.509 145.156H689.446V152.296H695.509V145.156Z",
    fill: "#455A64"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M695.509 153.346H689.446V157.774H695.509V153.346Z",
    fill: "#455A64"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M702.614 145.156H696.538V152.296H702.614V145.156Z",
    fill: "#455A64"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M702.614 153.346H696.538V157.774H702.614V153.346Z",
    fill: "#455A64"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M703.621 153.346H704.085L703.621 154.977V153.346Z",
    fill: "#455A64"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M706.417 145.156L704.384 152.296H703.621V145.156H706.417Z",
    fill: "#455A64"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M664.364 145.156H667.157V147.073H664.911L664.364 145.156Z",
    fill: "black"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.251 145.156H668.175V147.073H674.251V145.156Z",
    fill: "black"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M681.337 145.156H675.274V147.073H681.337V145.156Z",
    fill: "black"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M688.426 145.156H682.363V147.073H688.426V145.156Z",
    fill: "black"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.513 145.156H689.45V147.073H695.513V145.156Z",
    fill: "black"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M702.616 145.156H696.54V147.073H702.616V145.156Z",
    fill: "black"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M706.424 145.156L705.877 147.073H703.628V145.156H706.424Z",
    fill: "black"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M672.344 140.648L677.863 161.212H672.46L666.613 140.648H672.344Z",
    fill: "white"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M674.977 140.648L680.496 161.212H679.471L673.624 140.648H674.977Z",
    fill: "white"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M707.701 140.648H663.084L666.401 137.097H704.385L707.701 140.648Z",
    fill: "#FFC727"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M707.701 140.648H663.084L666.401 137.097H704.385L707.701 140.648Z",
    fill: "white"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M667.571 135.476H666.403V137.097H667.571V135.476Z",
    fill: "#FFC727"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M704.362 135.477V134.281H666.398V135.477H704.362Z",
    fill: "#FFC727"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M679.833 135.476H678.666V137.097H679.833V135.476Z",
    fill: "#FFC727"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M692.097 135.476H690.93V137.097H692.097V135.476Z",
    fill: "#FFC727"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M704.361 135.476H703.193V137.097H704.361V135.476Z",
    fill: "#FFC727"
  })), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.569 135.477H666.401V137.098H667.569V135.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.361 135.477V134.281H666.397V135.477H704.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.834 135.477H678.667V137.098H679.834V135.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.097 135.477H690.93V137.098H692.097V135.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.365 135.477H703.197V137.098H704.365V135.477Z",
    fill: "white"
  }))), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M698.422 167.489H672.36V178.49H698.422V167.489Z",
    fill: "#FFC727"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M698.422 167.489H672.36V178.49H698.422V167.489Z",
    fill: "white"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M676.957 167.489H672.36V178.49H676.957V167.489Z",
    fill: "#455A64"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M682.324 167.489H677.737V178.49H682.324V167.489Z",
    fill: "#455A64"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M687.687 167.489H683.101V178.49H687.687V167.489Z",
    fill: "#455A64"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M693.051 167.489H688.464V178.49H693.051V167.489Z",
    fill: "#455A64"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M698.422 167.489H693.825V178.49H698.422V167.489Z",
    fill: "#455A64"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M676.96 167.492H672.36V169.409H676.96V167.492Z",
    fill: "black"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M682.324 167.492H677.737V169.409H682.324V167.492Z",
    fill: "black"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M687.687 167.492H683.101V169.409H687.687V167.492Z",
    fill: "black"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M693.051 167.492H688.464V169.409H693.051V167.492Z",
    fill: "black"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.425 167.492H693.825V169.409H698.425V167.492Z",
    fill: "black"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M678.518 167.489H674.243V178.49H678.518V167.489Z",
    fill: "white"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M680.668 167.489H679.567V178.49H680.668V167.489Z",
    fill: "white"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M672.36 178.494H698.422L696.485 180.639H674.297L672.36 178.494Z",
    fill: "#FFC727"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M672.36 178.494H698.422L696.485 180.639H674.297L672.36 178.494Z",
    fill: "white"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M699.791 166.674H670.993V167.489H699.791V166.674Z",
    fill: "#FFC727"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M699.791 166.674H670.993V167.489H699.791V166.674Z",
    fill: "white"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M760.796 222.764H688.774C688.774 202.839 705.357 186.687 724.785 186.687C744.214 186.687 760.796 202.839 760.796 222.764Z",
    fill: "#FFC727"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M760.796 222.764H688.774C688.774 202.839 705.357 186.687 724.785 186.687C744.214 186.687 760.796 202.839 760.796 222.764Z",
    fill: "white"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M756.555 222.763H690.835C690.835 204.528 705.952 189.741 723.695 189.741C741.439 189.741 756.555 204.528 756.555 222.763Z",
    fill: "#FFC727"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M696.675 208.29V210.615H695.644C695.955 209.826 696.304 209.048 696.675 208.29Z",
    fill: "#455A64"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M695.311 211.485H696.674V218.085H693.659C693.979 215.831 694.533 213.619 695.311 211.485Z",
    fill: "#455A64"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M693.547 218.954H696.675V222.764H693.328C693.329 221.491 693.402 220.219 693.547 218.954Z",
    fill: "#455A64"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M705.902 196.978V203.149H699.826C701.57 200.82 703.614 198.744 705.902 196.978Z",
    fill: "#455A64"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M699.198 204.015H705.9V210.614H697.52V206.676C698.037 205.761 698.584 204.871 699.198 204.015Z",
    fill: "#455A64"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M705.9 211.482H697.52V218.086H705.9V211.482Z",
    fill: "#455A64"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M705.9 218.951H697.52V222.761H705.9V218.951Z",
    fill: "#455A64"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M715.13 192.08V195.679H707.721C710.026 194.151 712.517 192.941 715.13 192.08Z",
    fill: "#455A64"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M715.131 196.546H706.75V203.149H715.131V196.546Z",
    fill: "#455A64"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M715.131 204.012H706.75V210.615H715.131V204.012Z",
    fill: "#455A64"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M715.131 211.482H706.75V218.086H715.131V211.482Z",
    fill: "#455A64"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M715.131 218.951H706.75V222.761H715.131V218.951Z",
    fill: "#455A64"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M724.363 190.538V195.68H715.979V191.816C718.704 191.002 721.524 190.572 724.363 190.538Z",
    fill: "#455A64"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M724.363 196.546H715.979V203.149H724.363V196.546Z",
    fill: "#455A64"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M724.363 204.012H715.979V210.615H724.363V204.012Z",
    fill: "#455A64"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M724.363 211.482H715.979V218.086H724.363V211.482Z",
    fill: "#455A64"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M724.363 218.951H715.979V222.761H724.363V218.951Z",
    fill: "#455A64"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M733.591 191.816V195.68H725.207V190.538C728.045 190.572 730.866 191.001 733.591 191.816Z",
    fill: "#455A64"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M733.587 196.546H725.203V203.149H733.587V196.546Z",
    fill: "#455A64"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M733.587 204.012H725.203V210.615H733.587V204.012Z",
    fill: "#455A64"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M733.587 211.482H725.203V218.086H733.587V211.482Z",
    fill: "#455A64"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M733.587 218.951H725.203V222.761H733.587V218.951Z",
    fill: "#455A64"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M741.842 195.679H734.437V192.08C737.049 192.941 739.539 194.151 741.842 195.679Z",
    fill: "#455A64"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M742.816 196.546H734.436V203.149H742.816V196.546Z",
    fill: "#455A64"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M742.816 204.012H734.436V210.615H742.816V204.012Z",
    fill: "#455A64"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M742.816 211.482H734.436V218.086H742.816V211.482Z",
    fill: "#455A64"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M742.816 218.951H734.436V222.761H742.816V218.951Z",
    fill: "#455A64"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M749.742 203.149H743.663V196.978C745.953 198.743 747.998 200.819 749.742 203.149Z",
    fill: "#455A64"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M752.047 206.676V210.614H743.663V204.015H750.369C750.973 204.872 751.533 205.76 752.047 206.676Z",
    fill: "#455A64"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M752.044 211.482H743.663V218.086H752.044V211.482Z",
    fill: "#455A64"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M752.044 218.951H743.663V222.761H752.044V218.951Z",
    fill: "#455A64"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M753.926 210.615H752.895V208.29C753.269 209.048 753.614 209.826 753.926 210.615Z",
    fill: "#455A64"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M755.909 218.085H752.895V211.485H754.258C755.035 213.619 755.589 215.831 755.909 218.085Z",
    fill: "#455A64"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M756.238 222.764H752.895V218.954H756.022C756.166 220.219 756.238 221.491 756.238 222.764Z",
    fill: "#455A64"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M693.328 222.765C693.328 202.908 709.533 190.164 724.785 190.538C724.785 190.538 701.712 198.647 701.278 222.765H693.328Z",
    fill: "black"
  })), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.35 218.95H715.136V222.763H710.632L714.35 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.977 218.95H718.981L715.977 222.033V218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.483 210.614L724.361 208.69V210.614H722.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.641 211.479H724.361V213.437L719.83 218.079H715.977V217.284L721.641 211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.205 211.479H726.276L725.205 212.574V211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.933 204.012H733.566L727.119 210.615H725.205V207.828L728.933 204.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.773 203.147L733.591 199.235V203.147H729.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.215 196.548H740.848L734.434 203.12V198.373L736.215 196.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.756 195.617L741.696 195.678H737.057L738.795 193.897C739.811 194.417 740.799 194.991 741.756 195.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.606 210.614L752.047 208.112V210.614H749.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.32 218.079L742.818 217.569V218.079H742.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.473 218.95H742.82V222.318L742.385 222.763H737.752L741.473 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.664 218.95H746.105L743.664 221.451V218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.048 211.479V212.859L746.954 218.079H743.664V216.703L748.762 211.479H752.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.895 211.479H753.395L752.895 211.993V211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.924 210.617H752.896V208.289C753.27 209.044 753.609 209.825 753.924 210.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.905 218.95H704.966L701.245 222.763H698.188L701.905 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.9 214.857V217.991L705.814 218.079H702.753L705.9 214.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.193 211.479H712.254L706.749 217.121V213.988L709.193 211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.135 205.397V208.534L713.102 210.614H710.041L715.135 205.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.487 204.012H719.545L715.977 207.672V204.535L716.487 204.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.771 196.548H724.361V199.076L720.388 203.148H717.33L723.771 196.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.205 196.548H726.833L725.205 198.213V196.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.898 191.358L727.683 195.677H725.205V195.079L729.321 190.865C730.19 190.984 731.052 191.154 731.898 191.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.657 204.012H700.035L697.644 206.462C697.839 206.122 698.042 205.782 698.254 205.442L699.657 204.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.902 197.608V197.999L700.877 203.148H700.496L705.902 197.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.938 196.548H707.319L706.749 197.129V196.742L706.938 196.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.865 194.951L708.159 195.678H707.777L707.887 195.566C708.218 195.352 708.534 195.148 708.865 194.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.392 222.762L733.592 221.532V221.92L732.773 222.762H732.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.108 218.95H736.49L734.434 221.057V220.666L736.108 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.956 218.079L742.816 212.077V212.465L737.337 218.079H736.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.664 211.479H743.78L743.664 211.602V211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.654 204.436L744.618 210.618H744.24L750.495 204.205L750.654 204.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.195 218.95H738.576L734.855 222.763H734.474L738.195 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.043 218.08L742.817 214.213V214.604L739.421 218.08H739.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.485 211.479H745.866L743.664 213.736V213.345L745.485 211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.489 205.722L746.713 210.615H746.345L751.356 205.48C751.392 205.559 751.442 205.637 751.489 205.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.831 218.95H712.213L708.491 222.763H708.113L711.831 218.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.682 218.08L715.136 215.568V215.959L713.063 218.08H712.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.121 211.479H719.502L715.977 215.095V214.705L719.121 211.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.966 210.613L724.36 206.11V206.501L720.347 210.613H719.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.794 204.012L725.205 205.64V205.249L726.412 204.012H726.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.593 196.652V197.043L727.636 203.147H727.255L733.593 196.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.343 193.204L734.928 195.678H734.547L737.077 193.085L737.343 193.204Z",
    fill: "white"
  }))), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M781.99 225.799H667.603V251.956H781.99V225.799Z",
    fill: "#FFC727"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M781.99 225.799H667.603V251.956H781.99V225.799Z",
    fill: "white"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M663.085 251.956H667.603V218.169H663.085V251.956Z",
    fill: "#FFC727"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M663.085 251.956H667.603V218.169H663.085V251.956Z",
    fill: "white"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M781.97 251.956H786.487V218.169H781.97V251.956Z",
    fill: "#FFC727"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M781.97 251.956H786.487V218.169H781.97V251.956Z",
    fill: "white"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M776.778 244.511H780.947V233.316H776.778V244.511Z",
    fill: "#455A64"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M771.633 244.511H775.802V233.316H771.633V244.511Z",
    fill: "#455A64"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M766.481 244.511H770.649V233.316H766.481V244.511Z",
    fill: "#455A64"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M761.33 244.511H765.499V233.316H761.33V244.511Z",
    fill: "#455A64"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M756.187 244.511H760.355V233.316H756.187V244.511Z",
    fill: "#455A64"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M751.032 244.511H755.201V233.316H751.032V244.511Z",
    fill: "#455A64"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M745.882 244.511H750.051V233.316H745.882V244.511Z",
    fill: "#455A64"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M740.736 244.511H744.905V233.316H740.736V244.511Z",
    fill: "#455A64"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M735.584 244.511H739.753V233.316H735.584V244.511Z",
    fill: "#455A64"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M730.435 244.511H734.604V233.316H730.435V244.511Z",
    fill: "#455A64"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M725.285 244.511H729.454V233.316H725.285V244.511Z",
    fill: "#455A64"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M720.136 244.511H724.305V233.316H720.136V244.511Z",
    fill: "#455A64"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M714.986 244.511H719.155V233.316H714.986V244.511Z",
    fill: "#455A64"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M709.836 244.511H714.005V233.316H709.836V244.511Z",
    fill: "#455A64"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M704.689 244.511H708.857V233.316H704.689V244.511Z",
    fill: "#455A64"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M699.539 244.511H703.708V233.316H699.539V244.511Z",
    fill: "#455A64"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M694.391 244.511H698.56V233.316H694.391V244.511Z",
    fill: "#455A64"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M689.238 244.511H693.407V233.316H689.238V244.511Z",
    fill: "#455A64"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M684.089 244.511H688.258V233.316H684.089V244.511Z",
    fill: "#455A64"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M678.94 244.511H683.109V233.316H678.94V244.511Z",
    fill: "#455A64"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M673.792 244.511H677.961V233.316H673.792V244.511Z",
    fill: "#455A64"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M668.645 244.511H672.813V233.316H668.645V244.511Z",
    fill: "#455A64"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M776.778 232.086H780.947V225.795H776.778V232.086Z",
    fill: "#455A64"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M771.633 232.086H775.802V225.795H771.633V232.086Z",
    fill: "#455A64"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M766.481 232.086H770.649V225.795H766.481V232.086Z",
    fill: "#455A64"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M761.33 232.086H765.499V225.795H761.33V232.086Z",
    fill: "#455A64"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M756.187 232.086H760.355V225.795H756.187V232.086Z",
    fill: "#455A64"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M751.032 232.086H755.201V225.795H751.032V232.086Z",
    fill: "#455A64"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M745.882 232.086H750.051V225.795H745.882V232.086Z",
    fill: "#455A64"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M740.736 232.086H744.905V225.795H740.736V232.086Z",
    fill: "#455A64"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M735.584 232.086H739.753V225.795H735.584V232.086Z",
    fill: "#455A64"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M730.435 232.086H734.604V225.795H730.435V232.086Z",
    fill: "#455A64"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M725.285 232.086H729.454V225.795H725.285V232.086Z",
    fill: "#455A64"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M720.136 232.086H724.305V225.795H720.136V232.086Z",
    fill: "#455A64"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M714.986 232.086H719.155V225.795H714.986V232.086Z",
    fill: "#455A64"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M709.836 232.086H714.005V225.795H709.836V232.086Z",
    fill: "#455A64"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M704.689 232.086H708.857V225.795H704.689V232.086Z",
    fill: "#455A64"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M699.539 232.086H703.708V225.795H699.539V232.086Z",
    fill: "#455A64"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M694.391 232.086H698.56V225.795H694.391V232.086Z",
    fill: "#455A64"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M689.238 232.086H693.407V225.795H689.238V232.086Z",
    fill: "#455A64"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M684.089 232.086H688.258V225.795H684.089V232.086Z",
    fill: "#455A64"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M678.94 232.086H683.109V225.795H678.94V232.086Z",
    fill: "#455A64"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M673.792 232.086H677.961V225.795H673.792V232.086Z",
    fill: "#455A64"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M668.645 232.086H672.813V225.795H668.645V232.086Z",
    fill: "#455A64"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M776.778 251.952H780.947V245.662H776.778V251.952Z",
    fill: "#455A64"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M771.633 251.952H775.802V245.662H771.633V251.952Z",
    fill: "#455A64"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M766.481 251.952H770.649V245.662H766.481V251.952Z",
    fill: "#455A64"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M761.33 251.952H765.499V245.662H761.33V251.952Z",
    fill: "#455A64"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M756.183 251.952H765.499V245.662H756.183V251.952Z",
    fill: "#455A64"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M751.032 251.952H755.201V245.662H751.032V251.952Z",
    fill: "#455A64"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M745.882 251.952H750.051V245.662H745.882V251.952Z",
    fill: "#455A64"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M740.74 251.952H750.056V245.662H740.74V251.952Z",
    fill: "#455A64"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M735.584 251.952H739.753V245.662H735.584V251.952Z",
    fill: "#455A64"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M730.435 251.952H734.604V245.662H730.435V251.952Z",
    fill: "#455A64"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M725.285 251.952H729.454V245.662H725.285V251.952Z",
    fill: "#455A64"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M720.136 251.952H724.305V245.662H720.136V251.952Z",
    fill: "#455A64"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M714.986 251.952H719.155V245.662H714.986V251.952Z",
    fill: "#455A64"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M709.836 251.952H714.005V245.662H709.836V251.952Z",
    fill: "#455A64"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M704.689 251.952H708.857V245.662H704.689V251.952Z",
    fill: "#455A64"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M699.541 251.952H708.857V245.662H699.541V251.952Z",
    fill: "#455A64"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M694.391 251.952H698.56V245.662H694.391V251.952Z",
    fill: "#455A64"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M689.238 251.952H693.407V245.662H689.238V251.952Z",
    fill: "#455A64"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M684.091 251.952H693.407V245.662H684.091V251.952Z",
    fill: "#455A64"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M678.94 251.952H683.109V245.662H678.94V251.952Z",
    fill: "#455A64"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M673.792 251.952H677.961V245.662H673.792V251.952Z",
    fill: "#455A64"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M668.645 251.952H672.813V245.662H668.645V251.952Z",
    fill: "#455A64"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M669.736 225.799H668.642V232.086H669.736V225.799Z",
    fill: "black"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M669.736 233.32H668.642V244.511H669.736V233.32Z",
    fill: "black"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M669.736 245.667H668.642V251.957H669.736V245.667Z",
    fill: "black"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.884 225.799H673.79V232.086H674.884V225.799Z",
    fill: "black"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.884 233.32H673.79V244.511H674.884V233.32Z",
    fill: "black"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.884 245.667H673.79V251.957H674.884V245.667Z",
    fill: "black"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M680.034 225.799H678.942V232.086H680.034V225.799Z",
    fill: "black"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M680.034 233.32H678.942V244.511H680.034V233.32Z",
    fill: "black"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M680.034 245.667H678.942V251.957H680.034V245.667Z",
    fill: "black"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M685.183 225.799H684.092V232.086H685.183V225.799Z",
    fill: "black"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M685.183 233.32H684.092V244.511H685.183V233.32Z",
    fill: "black"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M685.183 245.667H684.092V251.957H685.183V245.667Z",
    fill: "black"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M690.332 225.799H689.241V232.086H690.332V225.799Z",
    fill: "black"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M690.332 233.32H689.241V244.511H690.332V233.32Z",
    fill: "black"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.48 225.799H694.389V232.086H695.48V225.799Z",
    fill: "black"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.48 233.32H694.389V244.511H695.48V233.32Z",
    fill: "black"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M695.48 245.667H694.389V251.957H695.48V245.667Z",
    fill: "black"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M700.633 225.799H699.542V232.086H700.633V225.799Z",
    fill: "black"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M700.633 233.32H699.542V244.511H700.633V233.32Z",
    fill: "black"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M700.633 245.667H699.542V251.957H700.633V245.667Z",
    fill: "black"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M705.781 225.799H704.689V232.086H705.781V225.799Z",
    fill: "black"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M705.781 233.32H704.689V244.511H705.781V233.32Z",
    fill: "black"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M710.935 225.799H709.844V232.086H710.935V225.799Z",
    fill: "black"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M710.935 233.32H709.844V244.511H710.935V233.32Z",
    fill: "black"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M710.935 245.667H709.844V251.957H710.935V245.667Z",
    fill: "black"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M716.081 225.799H714.986V232.086H716.081V225.799Z",
    fill: "black"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M716.081 233.32H714.986V244.511H716.081V233.32Z",
    fill: "black"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M716.081 245.667H714.986V251.957H716.081V245.667Z",
    fill: "black"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M721.233 225.799H720.139V232.086H721.233V225.799Z",
    fill: "black"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M721.233 233.32H720.139V244.511H721.233V233.32Z",
    fill: "black"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M721.233 245.667H720.139V251.957H721.233V245.667Z",
    fill: "black"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M726.383 225.799H725.288V232.086H726.383V225.799Z",
    fill: "black"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M726.383 233.32H725.288V244.511H726.383V233.32Z",
    fill: "black"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M726.383 245.667H725.288V251.957H726.383V245.667Z",
    fill: "black"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.532 225.799H730.438V232.086H731.532V225.799Z",
    fill: "black"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.532 233.32H730.438V244.511H731.532V233.32Z",
    fill: "black"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.532 245.667H730.438V251.957H731.532V245.667Z",
    fill: "black"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M736.676 225.799H735.585V232.086H736.676V225.799Z",
    fill: "black"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M736.676 233.32H735.585V244.511H736.676V233.32Z",
    fill: "black"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M736.676 245.667H735.585V251.957H736.676V245.667Z",
    fill: "black"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M741.826 225.799H740.734V232.086H741.826V225.799Z",
    fill: "black"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M741.826 233.32H740.734V244.511H741.826V233.32Z",
    fill: "black"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M741.826 245.667H740.734V251.957H741.826V245.667Z",
    fill: "black"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M746.977 225.799H745.886V232.086H746.977V225.799Z",
    fill: "black"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M746.977 233.32H745.886V244.511H746.977V233.32Z",
    fill: "black"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M752.127 225.799H751.036V232.086H752.127V225.799Z",
    fill: "black"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M752.127 233.32H751.036V244.511H752.127V233.32Z",
    fill: "black"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M752.127 245.667H751.036V251.957H752.127V245.667Z",
    fill: "black"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M757.276 225.799H756.185V232.086H757.276V225.799Z",
    fill: "black"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M757.276 233.32H756.185V244.511H757.276V233.32Z",
    fill: "black"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M757.276 245.667H756.185V251.957H757.276V245.667Z",
    fill: "black"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M762.426 225.799H761.335V232.086H762.426V225.799Z",
    fill: "black"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M762.426 233.32H761.335V244.511H762.426V233.32Z",
    fill: "black"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M767.575 225.799H766.48V232.086H767.575V225.799Z",
    fill: "black"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M767.575 233.32H766.48V244.511H767.575V233.32Z",
    fill: "black"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M767.575 245.667H766.48V251.957H767.575V245.667Z",
    fill: "black"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M772.726 225.799H771.632V232.086H772.726V225.799Z",
    fill: "black"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M772.726 233.32H771.632V244.511H772.726V233.32Z",
    fill: "black"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M772.726 245.667H771.632V251.957H772.726V245.667Z",
    fill: "black"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M777.875 225.799H776.78V232.086H777.875V225.799Z",
    fill: "black"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M777.875 233.32H776.78V244.511H777.875V233.32Z",
    fill: "black"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M777.875 245.667H776.78V251.957H777.875V245.667Z",
    fill: "black"
  })), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.645 233.316H669.573L668.645 234.271V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.273 225.8H672.81V230.004L670.777 232.087H668.645V229.521L672.273 225.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.91 225.8L673.792 228.994V225.8H676.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.826 232.086L714.007 230.876V232.086H712.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.709 244.513H700.694L703.709 241.428V244.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.39 250.975L698.559 246.703V251.457L698.071 251.957H694.39V250.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.206 245.667L699.54 250.452V245.698L699.57 245.667H704.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.691 240.423L708.857 236.154V240.902L705.331 244.514H704.691V240.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.009 233.316V235.624L709.84 239.896V235.148L711.624 233.316H714.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.989 233.316H716.256L714.989 234.618V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.158 225.8V230.347L717.46 232.087H714.989V229.871L718.962 225.8H719.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.596 225.8L720.141 229.341V225.8H723.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.79 232.086L775.802 231.05V232.086H774.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.661 244.514L765.5 241.604V244.514H762.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.537 245.667H765.501V246.353L761.332 250.625L760.035 251.957H756.185V251.149L761.537 245.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.48 240.597L770.649 236.328V241.079L767.296 244.515H766.48V240.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.801 233.316V235.801L771.632 240.072V235.321L773.585 233.316H775.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.781 233.316H778.221L776.781 234.791V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.947 225.8V230.527L779.425 232.087H776.781V230.044L780.924 225.8H780.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.558 251.957L724.305 248.117V251.957H720.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.821 244.514L729.456 242.839V244.514H727.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 245.667H729.457V247.59L725.291 251.859V247.108L726.694 245.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.436 245.667H731.328L730.436 246.585V245.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.436 241.833L734.604 237.562V242.309L732.452 244.515H730.436V241.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.755 233.316V237.031L735.586 241.303V236.555L738.747 233.316H739.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.735 233.316H743.379L740.735 236.025V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.735 231.278L744.901 227.01V231.757L744.579 232.087H740.735V231.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.051 225.8V226.479L745.882 230.751V226.004L746.081 225.8H750.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.645 242.391L672.81 238.123V241.26L669.633 244.515H668.645V242.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.961 233.316V235.981L673.792 240.253V237.116L677.5 233.316H677.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.943 233.316H680.562L678.943 234.975V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.943 231.838L683.112 227.566V230.703L681.762 232.086H678.943V231.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.898 225.8L684.094 229.698V226.561L684.837 225.8H687.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.99 251.957L683.11 249.785V251.957H680.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.261 244.515H688.254L688.261 244.508V244.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.193 245.667L684.094 251.913V248.78L687.132 245.667H690.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.243 243.502L693.409 239.233V242.37L691.316 244.515H689.243V243.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.559 233.956V237.093L694.39 241.361V238.228L698.559 233.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.54 233.316H702.24L699.54 236.086V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.385 232.086L703.711 228.678V231.814L703.443 232.086H700.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.857 225.8V226.541L704.691 230.809V227.672L706.519 225.8H708.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.419 244.514L750.051 242.842V244.514H748.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.293 245.667H750.049V245.976L744.215 251.957H741.154L747.293 245.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.032 241.836L755.201 237.564V240.698L751.48 244.514H751.032V241.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.35 233.316V235.423L756.185 239.692V236.558L759.349 233.316H760.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.332 233.316H762.407L761.332 234.417V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.332 231.284L765.501 227.013V230.146L763.61 232.087H761.332V231.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.744 225.8L766.48 229.14V226.007L766.683 225.8H769.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.299 245.667H670.681L668.645 247.75V247.359L670.299 245.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.425 244.515L672.811 243.095V243.482L671.806 244.515H671.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.792 242.084L677.961 237.812V238.203L673.792 242.475V242.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.731 233.316L678.943 237.197V236.807L682.349 233.316H682.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.094 231.533L688.263 227.261V227.652L684.094 231.92V231.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.066 225.8L689.243 226.643V226.255L689.684 225.8H690.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.632 251.867L775.801 247.596V247.983L771.927 251.956H771.632V251.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.065 245.667L776.781 246.979V246.591L777.683 245.667H778.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.951 242.322V242.71L779.193 244.514H778.812L780.951 242.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.194 251.957L719.158 247.896V248.286L715.576 251.957H715.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.716 245.667L720.141 247.281V246.89L721.335 245.667H721.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.457 244.515L724.304 242.622V243.013L722.838 244.515H722.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.291 241.613L729.457 237.345V237.736L725.291 242.004V241.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.765 233.316L730.436 236.728V236.338L733.387 233.316H733.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.587 232.087L734.604 232.065V232.087H734.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.755 226.789V227.18L735.586 231.452V231.061L739.755 226.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.103 225.8L740.735 226.174V225.8H741.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.281 251.956L719.158 250.032V250.423L717.663 251.956H717.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.799 245.667L720.141 249.419V249.028L723.417 245.667H723.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.291 243.75L729.457 239.481V239.872L725.291 244.141V243.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.604 234.204V234.595L730.436 238.867V238.476L734.604 234.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.586 233.316H735.851L735.586 233.588V233.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.189 225.8L740.738 228.311L739.756 229.317L737.053 232.087H736.672L739.756 228.926L740.738 227.92L742.807 225.8H743.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.918 251.956L693.409 249.404V249.795L691.299 251.956H690.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.438 245.667L694.39 248.79V248.399L697.056 245.667H697.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.182 244.515L698.56 244.128V244.515H698.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.54 243.121L703.709 238.85V239.24L699.54 243.512V243.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.857 233.574V233.965L704.691 238.233V237.843L708.857 233.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.311 232.086L714.008 228.297V228.688L710.689 232.086H710.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.823 225.8L714.989 227.683V227.292L716.445 225.8H716.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.008 251.958L750.051 247.812V248.202L746.389 251.958H746.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.525 245.667L751.032 247.196V246.805L752.147 245.667H752.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.27 244.514L755.203 242.533V242.924L753.651 244.514H753.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.185 241.527L760.35 237.259V237.65L756.185 241.918V241.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.579 233.316L761.332 236.643V236.253L764.198 233.316H764.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.399 232.086L765.502 231.98V232.086H765.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.649 226.702V227.093L766.48 231.365V230.974L770.649 226.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.914 225.8L771.632 226.089V225.8H771.914Z",
    fill: "white"
  }))), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M722.54 251.952H727.057V225.795H722.54V251.952Z",
    fill: "#FFC727"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M722.54 251.952H727.057V225.795H722.54V251.952Z",
    fill: "white"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M781.99 218.166H667.603V225.799H781.99V218.166Z",
    fill: "#FFC727"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M781.99 218.166H667.603V225.799H781.99V218.166Z",
    fill: "white"
  })), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.177 223.029H700.043L699.818 223.651C699.797 223.7 699.764 223.742 699.721 223.771C699.678 223.801 699.627 223.817 699.575 223.818C699.546 223.823 699.515 223.823 699.486 223.818C699.422 223.793 699.369 223.744 699.34 223.68C699.311 223.617 699.307 223.544 699.33 223.478L700.361 220.664C700.381 220.614 700.415 220.571 700.459 220.541C700.503 220.512 700.554 220.496 700.607 220.497C700.66 220.495 700.713 220.51 700.757 220.54C700.802 220.57 700.836 220.613 700.856 220.664L701.887 223.478C701.91 223.544 701.906 223.617 701.877 223.68C701.848 223.744 701.795 223.793 701.731 223.818C701.703 223.823 701.673 223.823 701.645 223.818C701.593 223.819 701.542 223.803 701.5 223.773C701.457 223.744 701.424 223.701 701.406 223.651L701.177 223.029ZM700.985 222.506L700.607 221.486L700.232 222.506H700.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.023 220.739C703.023 220.704 703.029 220.67 703.042 220.638C703.055 220.605 703.073 220.576 703.097 220.552C703.121 220.527 703.149 220.507 703.18 220.494C703.212 220.481 703.245 220.474 703.279 220.474C703.313 220.473 703.347 220.48 703.379 220.493C703.411 220.506 703.44 220.525 703.464 220.55C703.488 220.575 703.508 220.604 703.521 220.637C703.534 220.669 703.541 220.704 703.541 220.739V223.556C703.54 223.591 703.533 223.625 703.52 223.657C703.506 223.689 703.487 223.718 703.463 223.742C703.438 223.767 703.41 223.786 703.378 223.799C703.347 223.812 703.313 223.818 703.279 223.818C703.245 223.818 703.212 223.812 703.181 223.799C703.149 223.786 703.121 223.766 703.097 223.742C703.073 223.718 703.055 223.689 703.042 223.657C703.029 223.625 703.023 223.59 703.023 223.556V220.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.037 223.424C707.049 223.457 707.054 223.492 707.053 223.528C707.051 223.563 707.042 223.597 707.027 223.629C707.012 223.661 706.99 223.689 706.964 223.712C706.938 223.735 706.908 223.753 706.875 223.764C706.84 223.767 706.806 223.767 706.772 223.764C706.708 223.763 706.645 223.746 706.589 223.713C706.527 223.669 706.476 223.61 706.44 223.543C706.365 223.363 706.332 223.167 706.344 222.972C706.343 222.899 706.323 222.827 706.288 222.764C706.25 222.709 706.201 222.663 706.145 222.628C706.065 222.576 705.978 222.537 705.886 222.513H705.336V223.532C705.335 223.567 705.328 223.602 705.315 223.634C705.301 223.666 705.282 223.695 705.258 223.719C705.233 223.743 705.205 223.762 705.173 223.775C705.141 223.788 705.108 223.795 705.074 223.794C705.006 223.794 704.941 223.767 704.893 223.717C704.845 223.668 704.818 223.602 704.818 223.532V220.715C704.818 220.681 704.824 220.646 704.837 220.614C704.849 220.582 704.868 220.553 704.892 220.528C704.916 220.503 704.944 220.484 704.975 220.47C705.006 220.457 705.04 220.45 705.074 220.45H705.91C706.122 220.441 706.331 220.502 706.507 220.624C706.683 220.746 706.817 220.922 706.888 221.127C706.959 221.332 706.964 221.555 706.903 221.764C706.841 221.972 706.716 222.155 706.546 222.285C706.609 222.335 706.664 222.394 706.709 222.462C706.81 222.614 706.865 222.794 706.865 222.978C706.858 223.073 706.864 223.168 706.881 223.261C706.918 223.273 706.951 223.295 706.978 223.323C707.005 223.351 707.026 223.386 707.037 223.424ZM706.374 221.504C706.374 221.438 706.362 221.374 706.338 221.313C706.314 221.253 706.279 221.198 706.234 221.152C706.19 221.105 706.137 221.068 706.078 221.043C706.019 221.018 705.957 221.004 705.893 221.004H705.319V221.99H705.893C705.957 221.991 706.02 221.98 706.08 221.957C706.139 221.933 706.193 221.898 706.239 221.853C706.285 221.807 706.322 221.753 706.347 221.693C706.373 221.633 706.386 221.569 706.387 221.504H706.374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.355 222.52H708.781V223.539C708.781 223.61 708.754 223.677 708.705 223.727C708.657 223.777 708.591 223.804 708.522 223.804C708.454 223.804 708.388 223.777 708.339 223.727C708.291 223.677 708.264 223.61 708.264 223.539V220.722C708.263 220.687 708.27 220.653 708.282 220.621C708.295 220.589 708.314 220.56 708.337 220.535C708.361 220.51 708.389 220.491 708.421 220.477C708.452 220.464 708.485 220.457 708.519 220.457H709.355C709.619 220.457 709.872 220.564 710.058 220.756C710.245 220.947 710.35 221.206 710.35 221.477C710.35 221.747 710.245 222.006 710.058 222.197C709.872 222.389 709.619 222.496 709.355 222.496V222.52ZM708.781 221.99H709.355C709.482 221.99 709.605 221.938 709.695 221.845C709.785 221.753 709.836 221.628 709.836 221.497C709.836 221.366 709.785 221.241 709.695 221.149C709.605 221.056 709.482 221.004 709.355 221.004H708.781V221.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.019 220.891C714.321 221.217 714.49 221.65 714.49 222.099C714.49 222.549 714.321 222.981 714.019 223.307C713.878 223.466 713.706 223.594 713.514 223.681C713.322 223.769 713.115 223.815 712.905 223.817C712.691 223.816 712.479 223.77 712.283 223.682C712.087 223.594 711.911 223.467 711.764 223.307C711.467 222.978 711.303 222.547 711.303 222.099C711.303 221.651 711.467 221.22 711.764 220.891C711.909 220.73 712.086 220.601 712.282 220.513C712.478 220.424 712.69 220.378 712.905 220.378C713.115 220.379 713.323 220.425 713.515 220.514C713.707 220.602 713.879 220.731 714.019 220.891ZM713.959 222.098C713.959 221.789 713.847 221.491 713.644 221.262C713.55 221.155 713.434 221.071 713.306 221.013C713.177 220.955 713.038 220.925 712.898 220.925C712.758 220.925 712.619 220.955 712.49 221.013C712.362 221.071 712.247 221.155 712.152 221.262C711.941 221.487 711.822 221.786 711.82 222.098C711.821 222.409 711.94 222.707 712.152 222.93C712.245 223.039 712.36 223.125 712.489 223.185C712.617 223.245 712.757 223.275 712.898 223.275C713.039 223.275 713.179 223.245 713.307 223.185C713.436 223.125 713.551 223.039 713.644 222.93C713.847 222.703 713.96 222.406 713.959 222.098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.037 223.424C718.049 223.457 718.054 223.492 718.052 223.528C718.05 223.563 718.041 223.598 718.026 223.629C718.011 223.661 717.99 223.689 717.964 223.712C717.937 223.736 717.907 223.753 717.874 223.764C717.84 223.767 717.805 223.767 717.771 223.764C717.707 223.765 717.644 223.747 717.589 223.713C717.527 223.669 717.476 223.611 717.44 223.543C717.363 223.363 717.329 223.167 717.34 222.972C717.34 222.899 717.321 222.827 717.284 222.765C717.248 222.709 717.201 222.662 717.144 222.629C717.065 222.576 716.978 222.537 716.886 222.513H716.332V223.533C716.33 223.603 716.302 223.669 716.253 223.718C716.204 223.767 716.138 223.794 716.07 223.794C716.036 223.795 716.003 223.788 715.972 223.775C715.94 223.762 715.912 223.743 715.888 223.719C715.865 223.694 715.846 223.665 715.833 223.633C715.82 223.601 715.814 223.567 715.815 223.533V220.715C715.814 220.681 715.82 220.646 715.832 220.614C715.845 220.581 715.863 220.552 715.887 220.527C715.911 220.502 715.939 220.483 715.971 220.47C716.002 220.456 716.036 220.45 716.07 220.45H716.906C717.112 220.449 717.313 220.513 717.482 220.634C717.651 220.755 717.78 220.927 717.849 221.126C717.919 221.325 717.926 221.541 717.871 221.744C717.815 221.948 717.699 222.128 717.539 222.262C717.602 222.311 717.657 222.371 717.702 222.438C717.802 222.591 717.855 222.771 717.854 222.955C717.85 223.049 717.857 223.144 717.874 223.237C717.914 223.251 717.951 223.276 717.979 223.309C718.007 223.342 718.027 223.381 718.037 223.424ZM717.373 221.504C717.374 221.439 717.363 221.374 717.339 221.314C717.315 221.253 717.28 221.199 717.236 221.152C717.192 221.106 717.139 221.069 717.08 221.043C717.022 221.018 716.959 221.005 716.896 221.004H716.332V221.99H716.906C717.032 221.99 717.153 221.939 717.242 221.848C717.332 221.757 717.382 221.633 717.383 221.504H717.373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.159 221.004H720.42V223.556C720.413 223.621 720.382 223.68 720.335 223.724C720.288 223.767 720.226 223.791 720.163 223.791C720.099 223.791 720.038 223.767 719.99 223.724C719.943 223.68 719.913 223.621 719.906 223.556V221.004H719.169C719.101 221.003 719.036 220.975 718.989 220.925C718.941 220.875 718.914 220.808 718.914 220.739C718.914 220.704 718.92 220.67 718.933 220.638C718.945 220.605 718.964 220.576 718.988 220.551C719.011 220.527 719.04 220.507 719.071 220.494C719.102 220.481 719.136 220.474 719.169 220.474H721.159C721.193 220.474 721.227 220.481 721.258 220.494C721.289 220.507 721.317 220.527 721.341 220.551C721.365 220.576 721.384 220.605 721.396 220.638C721.409 220.67 721.415 220.704 721.415 220.739C721.414 220.808 721.387 220.875 721.339 220.924C721.292 220.973 721.227 221.002 721.159 221.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.515 221.004H725.782V223.556C725.783 223.59 725.776 223.625 725.764 223.657C725.751 223.689 725.732 223.718 725.708 223.742C725.685 223.766 725.656 223.786 725.625 223.799C725.594 223.812 725.561 223.818 725.527 223.818C725.459 223.818 725.394 223.79 725.345 223.741C725.297 223.692 725.269 223.626 725.268 223.556V221.004H724.522C724.454 221.003 724.389 220.975 724.341 220.925C724.293 220.875 724.267 220.808 724.267 220.739C724.266 220.704 724.272 220.67 724.285 220.638C724.298 220.605 724.316 220.576 724.34 220.551C724.364 220.527 724.392 220.507 724.423 220.494C724.455 220.481 724.488 220.474 724.522 220.474H726.512C726.546 220.474 726.579 220.481 726.61 220.494C726.642 220.507 726.67 220.527 726.694 220.551C726.717 220.576 726.736 220.605 726.749 220.638C726.761 220.67 726.768 220.704 726.767 220.739C726.766 220.808 726.74 220.874 726.693 220.923C726.646 220.972 726.582 221.001 726.515 221.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.01 223.556V220.739C728.009 220.704 728.015 220.669 728.027 220.637C728.04 220.605 728.059 220.575 728.082 220.55C728.106 220.526 728.135 220.506 728.166 220.493C728.198 220.48 728.231 220.473 728.265 220.474H729.791C729.859 220.474 729.925 220.502 729.974 220.551C730.022 220.601 730.05 220.668 730.05 220.739C730.05 220.809 730.022 220.876 729.974 220.926C729.925 220.976 729.859 221.004 729.791 221.004H728.527V221.881H729.612C729.68 221.881 729.746 221.909 729.795 221.958C729.843 222.008 729.87 222.075 729.87 222.146C729.87 222.216 729.843 222.283 729.795 222.333C729.746 222.383 729.68 222.411 729.612 222.411H728.527V223.288H729.791C729.859 223.288 729.925 223.315 729.974 223.365C730.022 223.415 730.05 223.482 730.05 223.553C730.05 223.623 730.022 223.69 729.974 223.74C729.925 223.79 729.859 223.818 729.791 223.818H728.265C728.232 223.818 728.198 223.812 728.167 223.799C728.136 223.786 728.107 223.766 728.084 223.742C728.06 223.718 728.041 223.689 728.028 223.657C728.016 223.625 728.009 223.59 728.01 223.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.491 223.424C733.503 223.457 733.508 223.492 733.506 223.528C733.504 223.563 733.496 223.598 733.48 223.629C733.465 223.661 733.444 223.689 733.418 223.713C733.392 223.736 733.361 223.753 733.328 223.764C733.294 223.767 733.26 223.767 733.225 223.764C733.162 223.765 733.1 223.747 733.046 223.713C732.983 223.67 732.932 223.611 732.897 223.543C732.821 223.363 732.787 223.168 732.798 222.972C732.798 222.899 732.778 222.827 732.741 222.765C732.706 222.709 732.658 222.662 732.602 222.629C732.521 222.575 732.433 222.536 732.34 222.513H731.786V223.533C731.784 223.603 731.756 223.669 731.707 223.718C731.658 223.767 731.592 223.794 731.524 223.794C731.49 223.795 731.457 223.788 731.426 223.775C731.395 223.762 731.366 223.743 731.342 223.719C731.319 223.694 731.3 223.665 731.287 223.633C731.274 223.601 731.268 223.567 731.269 223.533V220.715C731.268 220.681 731.274 220.646 731.286 220.614C731.299 220.581 731.317 220.552 731.341 220.527C731.365 220.502 731.394 220.483 731.425 220.47C731.456 220.456 731.49 220.45 731.524 220.45H732.356C732.563 220.448 732.765 220.512 732.934 220.633C733.104 220.753 733.233 220.925 733.303 221.124C733.373 221.323 733.38 221.54 733.325 221.743C733.27 221.947 733.154 222.128 732.993 222.262C733.056 222.311 733.111 222.371 733.156 222.438C733.256 222.591 733.31 222.771 733.308 222.955C733.304 223.049 733.311 223.144 733.328 223.237C733.369 223.251 733.405 223.276 733.433 223.309C733.461 223.342 733.481 223.381 733.491 223.424ZM732.827 221.504C732.828 221.438 732.816 221.374 732.793 221.313C732.769 221.253 732.734 221.197 732.689 221.151C732.644 221.104 732.591 221.068 732.532 221.042C732.473 221.017 732.41 221.004 732.347 221.004H731.786V221.99H732.356C732.419 221.99 732.481 221.978 732.539 221.954C732.598 221.93 732.65 221.894 732.695 221.849C732.74 221.804 732.775 221.75 732.8 221.691C732.824 221.632 732.837 221.568 732.837 221.504H732.827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.519 220.739V223.556C737.517 223.626 737.489 223.693 737.44 223.741C737.391 223.79 737.325 223.818 737.257 223.818C737.223 223.818 737.19 223.812 737.159 223.799C737.127 223.786 737.099 223.766 737.075 223.742C737.052 223.718 737.033 223.689 737.02 223.657C737.007 223.625 737.001 223.59 737.002 223.556V221.544L736.338 222.499C736.315 222.534 736.284 222.562 736.247 222.581C736.211 222.601 736.17 222.611 736.129 222.611C736.088 222.611 736.047 222.601 736.01 222.581C735.973 222.562 735.941 222.534 735.917 222.499L735.254 221.544V223.556C735.254 223.626 735.226 223.694 735.178 223.743C735.129 223.793 735.064 223.821 734.995 223.821C734.926 223.821 734.861 223.793 734.812 223.743C734.764 223.694 734.736 223.626 734.736 223.556V220.739C734.737 220.669 734.764 220.603 734.812 220.553C734.859 220.504 734.924 220.475 734.992 220.474C735.032 220.474 735.072 220.484 735.108 220.504C735.144 220.523 735.174 220.552 735.197 220.586L736.126 221.904L737.058 220.586C737.082 220.551 737.114 220.523 737.151 220.503C737.188 220.484 737.229 220.474 737.27 220.474C737.336 220.479 737.397 220.509 737.443 220.558C737.489 220.607 737.516 220.671 737.519 220.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.148 220.739C739.148 220.704 739.154 220.67 739.167 220.638C739.18 220.605 739.198 220.576 739.222 220.551C739.246 220.527 739.274 220.507 739.305 220.494C739.337 220.481 739.37 220.474 739.404 220.474C739.473 220.474 739.539 220.501 739.588 220.551C739.637 220.601 739.665 220.668 739.666 220.739V223.556C739.664 223.626 739.636 223.693 739.587 223.741C739.538 223.79 739.472 223.818 739.404 223.818C739.37 223.818 739.337 223.812 739.306 223.799C739.274 223.786 739.246 223.766 739.222 223.742C739.198 223.718 739.18 223.689 739.167 223.657C739.154 223.625 739.148 223.59 739.148 223.556V220.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.516 223.555C741.52 223.592 741.517 223.629 741.506 223.664C741.495 223.699 741.477 223.731 741.453 223.759C741.429 223.786 741.399 223.808 741.367 223.824C741.334 223.839 741.298 223.846 741.262 223.846C741.226 223.846 741.191 223.839 741.158 223.824C741.125 223.808 741.096 223.786 741.072 223.759C741.048 223.731 741.03 223.699 741.019 223.664C741.008 223.629 741.004 223.592 741.008 223.555V220.778C741.005 220.722 741.02 220.667 741.051 220.62C741.081 220.574 741.126 220.539 741.177 220.52C741.229 220.502 741.285 220.501 741.337 220.518C741.389 220.535 741.435 220.569 741.466 220.615L742.972 222.75V220.782C742.973 220.714 743 220.649 743.047 220.601C743.094 220.554 743.158 220.527 743.224 220.527C743.291 220.527 743.355 220.554 743.402 220.601C743.45 220.649 743.478 220.714 743.479 220.782V223.558C743.478 223.627 743.451 223.694 743.404 223.742C743.356 223.791 743.291 223.819 743.224 223.82C743.187 223.82 743.151 223.811 743.117 223.794C743.084 223.778 743.055 223.754 743.032 223.725L743.008 223.698L741.516 221.577V223.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.731 223.029H745.6L745.371 223.651C745.352 223.7 745.318 223.742 745.275 223.772C745.232 223.802 745.181 223.817 745.129 223.817C745.1 223.823 745.069 223.823 745.04 223.817C744.975 223.793 744.923 223.744 744.894 223.68C744.865 223.617 744.861 223.544 744.884 223.478L745.915 220.664C745.935 220.613 745.969 220.57 746.014 220.54C746.058 220.51 746.111 220.495 746.164 220.497C746.217 220.495 746.269 220.51 746.313 220.54C746.357 220.57 746.391 220.613 746.409 220.664L747.441 223.478C747.463 223.544 747.46 223.617 747.43 223.68C747.401 223.744 747.349 223.793 747.285 223.817C747.256 223.823 747.227 223.823 747.199 223.817C747.147 223.819 747.096 223.803 747.053 223.773C747.01 223.744 746.978 223.701 746.96 223.651L746.731 223.029ZM746.539 222.506L746.164 221.486L745.786 222.506H746.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.544 223.556V220.739C748.544 220.668 748.571 220.601 748.62 220.551C748.668 220.502 748.734 220.474 748.803 220.474C748.871 220.474 748.937 220.502 748.986 220.551C749.034 220.601 749.061 220.668 749.061 220.739V223.288H750.325C750.394 223.288 750.459 223.315 750.508 223.365C750.556 223.415 750.584 223.482 750.584 223.553C750.584 223.623 750.556 223.69 750.508 223.74C750.459 223.79 750.394 223.818 750.325 223.818H748.803C748.769 223.818 748.735 223.812 748.704 223.799C748.673 223.786 748.644 223.767 748.62 223.742C748.596 223.718 748.577 223.689 748.564 223.657C748.551 223.625 748.544 223.591 748.544 223.556Z",
    fill: "black"
  }))), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M701.015 222.778H699.884L699.655 223.4C699.635 223.449 699.602 223.491 699.559 223.521C699.516 223.55 699.465 223.566 699.413 223.566C699.37 223.568 699.328 223.559 699.29 223.539C699.252 223.52 699.219 223.491 699.195 223.455C699.171 223.419 699.156 223.377 699.152 223.334C699.147 223.29 699.154 223.246 699.171 223.206L700.199 220.396C700.219 220.345 700.254 220.302 700.298 220.272C700.343 220.242 700.395 220.226 700.448 220.226C700.501 220.225 700.553 220.241 700.597 220.271C700.641 220.301 700.674 220.345 700.693 220.396L701.725 223.206C701.746 223.272 701.742 223.344 701.713 223.407C701.685 223.47 701.635 223.519 701.572 223.546C701.543 223.552 701.512 223.552 701.483 223.546C701.431 223.547 701.38 223.532 701.337 223.502C701.294 223.472 701.262 223.429 701.244 223.379L701.015 222.778ZM700.826 222.251L700.448 221.232L700.07 222.251H700.826Z",
    fill: "#FFC727"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M702.86 220.484C702.86 220.45 702.867 220.415 702.88 220.383C702.893 220.351 702.912 220.322 702.936 220.298C702.96 220.274 702.989 220.255 703.02 220.242C703.052 220.229 703.085 220.222 703.119 220.223C703.187 220.223 703.252 220.25 703.301 220.299C703.349 220.348 703.377 220.415 703.378 220.484V223.305C703.377 223.375 703.349 223.441 703.301 223.49C703.252 223.539 703.187 223.567 703.119 223.567C703.085 223.567 703.052 223.561 703.02 223.548C702.989 223.535 702.96 223.516 702.936 223.491C702.912 223.467 702.893 223.438 702.88 223.406C702.867 223.374 702.86 223.34 702.86 223.305V220.484Z",
    fill: "#FFC727"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M706.876 223.169C706.898 223.236 706.894 223.309 706.863 223.373C706.833 223.436 706.779 223.485 706.713 223.508C706.679 223.512 706.645 223.512 706.611 223.508C706.546 223.509 706.483 223.49 706.428 223.454C706.366 223.411 706.315 223.354 706.279 223.287C706.206 223.107 706.173 222.912 706.183 222.717C706.182 222.644 706.162 222.572 706.126 222.509C706.09 222.453 706.043 222.406 705.987 222.37C705.907 222.318 705.818 222.28 705.725 222.258H705.175V223.294C705.175 223.365 705.147 223.432 705.099 223.482C705.05 223.531 704.985 223.559 704.916 223.559C704.847 223.559 704.782 223.531 704.733 223.482C704.684 223.432 704.657 223.365 704.657 223.294V220.474C704.657 220.439 704.664 220.405 704.677 220.373C704.69 220.341 704.709 220.312 704.733 220.287C704.757 220.263 704.786 220.244 704.817 220.231C704.849 220.218 704.882 220.211 704.916 220.212H705.748C705.955 220.211 706.156 220.275 706.325 220.396C706.494 220.517 706.622 220.689 706.692 220.888C706.761 221.086 706.769 221.303 706.713 221.506C706.658 221.709 706.542 221.89 706.382 222.023C706.446 222.072 706.501 222.132 706.544 222.2C706.648 222.351 706.702 222.532 706.7 222.717C706.694 222.81 706.701 222.904 706.72 222.995C706.757 223.01 706.79 223.034 706.817 223.064C706.844 223.094 706.864 223.13 706.876 223.169ZM706.213 221.248C706.213 221.183 706.201 221.119 706.177 221.059C706.153 220.999 706.118 220.944 706.073 220.898C706.028 220.852 705.975 220.815 705.917 220.79C705.858 220.765 705.795 220.752 705.732 220.752H705.158V221.738H705.732C705.859 221.738 705.981 221.686 706.071 221.595C706.161 221.503 706.212 221.379 706.213 221.248Z",
    fill: "#FFC727"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M709.2 222.268H708.626V223.305C708.626 223.375 708.599 223.443 708.55 223.492C708.501 223.542 708.436 223.57 708.367 223.57C708.298 223.57 708.233 223.542 708.184 223.492C708.136 223.443 708.108 223.375 708.108 223.305V220.484C708.109 220.415 708.137 220.348 708.185 220.299C708.234 220.25 708.299 220.223 708.367 220.223H709.2C709.463 220.223 709.716 220.33 709.903 220.521C710.09 220.712 710.194 220.972 710.194 221.242C710.194 221.513 710.09 221.772 709.903 221.963C709.716 222.154 709.463 222.262 709.2 222.262V222.268ZM708.626 221.738H709.2C709.327 221.738 709.449 221.686 709.54 221.594C709.63 221.502 709.68 221.376 709.68 221.246C709.68 221.115 709.63 220.99 709.54 220.897C709.449 220.805 709.327 220.753 709.2 220.753H708.626V221.738Z",
    fill: "#FFC727"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M713.857 220.636C714.159 220.962 714.328 221.395 714.328 221.846C714.328 222.296 714.159 222.729 713.857 223.055C713.715 223.214 713.543 223.341 713.351 223.429C713.16 223.517 712.952 223.563 712.742 223.565C712.528 223.564 712.316 223.518 712.119 223.431C711.922 223.343 711.745 223.215 711.598 223.055C711.301 222.726 711.137 222.294 711.137 221.846C711.137 221.397 711.301 220.965 711.598 220.636C711.745 220.475 711.922 220.347 712.119 220.259C712.316 220.172 712.528 220.126 712.742 220.126C712.952 220.127 713.16 220.173 713.352 220.261C713.544 220.349 713.715 220.476 713.857 220.636ZM713.794 221.846C713.789 221.534 713.671 221.236 713.462 221.01C713.369 220.903 713.256 220.818 713.129 220.76C713.002 220.701 712.865 220.67 712.726 220.67C712.584 220.669 712.443 220.699 712.313 220.758C712.182 220.816 712.066 220.902 711.97 221.01C711.764 221.237 711.652 221.536 711.655 221.846C711.651 222.154 711.764 222.453 711.97 222.678C712.063 222.787 712.178 222.874 712.306 222.933C712.435 222.993 712.575 223.023 712.716 223.023C712.857 223.023 712.997 222.993 713.125 222.933C713.254 222.874 713.369 222.787 713.462 222.678C713.671 222.453 713.79 222.156 713.794 221.846Z",
    fill: "#FFC727"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M717.87 223.169C717.881 223.202 717.886 223.237 717.884 223.272C717.882 223.307 717.873 223.342 717.858 223.373C717.843 223.405 717.822 223.433 717.796 223.456C717.77 223.48 717.74 223.497 717.707 223.508C717.673 223.512 717.639 223.512 717.605 223.508C717.54 223.509 717.477 223.49 717.422 223.454C717.36 223.412 717.308 223.355 717.273 223.287C717.198 223.107 717.165 222.912 717.177 222.717C717.176 222.644 717.156 222.572 717.12 222.509C717.082 222.454 717.034 222.406 716.978 222.37C716.898 222.318 716.811 222.28 716.719 222.258H716.162V223.294C716.161 223.329 716.154 223.363 716.141 223.395C716.128 223.427 716.108 223.456 716.084 223.481C716.059 223.505 716.031 223.524 715.999 223.537C715.968 223.55 715.934 223.556 715.9 223.556C715.832 223.556 715.767 223.528 715.719 223.479C715.671 223.43 715.645 223.364 715.645 223.294V220.474C715.644 220.439 715.65 220.405 715.663 220.373C715.676 220.341 715.695 220.312 715.718 220.288C715.742 220.263 715.77 220.244 715.802 220.231C715.833 220.218 715.866 220.211 715.9 220.212H716.736C716.942 220.211 717.143 220.275 717.312 220.396C717.481 220.517 717.61 220.689 717.679 220.888C717.749 221.086 717.756 221.303 717.701 221.506C717.645 221.709 717.529 221.89 717.369 222.023C717.432 222.073 717.487 222.132 717.532 222.2C717.634 222.352 717.688 222.532 717.688 222.717C717.676 222.809 717.676 222.903 717.688 222.995C717.73 223.005 717.769 223.027 717.801 223.057C717.833 223.088 717.857 223.126 717.87 223.169ZM717.207 221.248C717.207 221.183 717.195 221.119 717.171 221.059C717.147 220.999 717.112 220.944 717.067 220.898C717.022 220.852 716.969 220.815 716.911 220.79C716.852 220.765 716.789 220.752 716.726 220.752H716.162V221.738H716.736C716.799 221.738 716.861 221.726 716.92 221.702C716.978 221.677 717.032 221.641 717.077 221.596C717.122 221.55 717.157 221.496 717.182 221.437C717.207 221.377 717.219 221.313 717.22 221.248H717.207Z",
    fill: "#FFC727"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M720.998 220.753H720.255V223.305C720.255 223.34 720.249 223.374 720.236 223.406C720.224 223.438 720.205 223.467 720.181 223.491C720.157 223.515 720.129 223.535 720.098 223.548C720.066 223.561 720.033 223.567 719.999 223.567C719.931 223.567 719.866 223.539 719.818 223.49C719.769 223.441 719.742 223.375 719.741 223.305V220.753H719.004C718.97 220.752 718.937 220.745 718.906 220.731C718.874 220.718 718.846 220.698 718.822 220.673C718.799 220.648 718.78 220.618 718.767 220.586C718.755 220.554 718.749 220.519 718.749 220.484C718.749 220.45 718.755 220.416 718.768 220.384C718.78 220.352 718.799 220.323 718.823 220.298C718.847 220.274 718.875 220.255 718.906 220.242C718.937 220.229 718.971 220.222 719.004 220.223H720.994C721.062 220.223 721.127 220.25 721.175 220.299C721.223 220.348 721.25 220.415 721.25 220.484C721.25 220.554 721.224 220.621 721.177 220.671C721.13 220.721 721.065 220.75 720.998 220.753Z",
    fill: "#FFC727"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M726.35 220.753H725.607V223.305C725.608 223.34 725.601 223.374 725.589 223.406C725.576 223.438 725.557 223.467 725.533 223.491C725.51 223.515 725.481 223.535 725.45 223.548C725.419 223.561 725.386 223.567 725.352 223.567C725.284 223.567 725.219 223.539 725.171 223.49C725.123 223.441 725.097 223.374 725.097 223.305V220.753H724.36C724.326 220.753 724.292 220.746 724.261 220.732C724.229 220.719 724.2 220.699 724.176 220.674C724.152 220.649 724.133 220.619 724.12 220.587C724.108 220.554 724.101 220.519 724.102 220.484C724.102 220.45 724.108 220.415 724.121 220.383C724.134 220.351 724.153 220.322 724.178 220.298C724.202 220.274 724.23 220.255 724.262 220.242C724.293 220.229 724.326 220.222 724.36 220.223H726.35C726.418 220.223 726.483 220.25 726.531 220.299C726.579 220.348 726.606 220.415 726.606 220.484C726.606 220.554 726.579 220.622 726.531 220.672C726.483 220.722 726.419 220.751 726.35 220.753Z",
    fill: "#FFC727"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M727.842 223.305V220.484C727.84 220.448 727.846 220.413 727.858 220.379C727.87 220.346 727.889 220.315 727.913 220.29C727.938 220.264 727.967 220.244 727.999 220.231C728.031 220.217 728.066 220.211 728.101 220.212H729.626C729.694 220.213 729.758 220.241 729.806 220.29C729.854 220.339 729.881 220.405 729.882 220.474C729.882 220.544 729.855 220.611 729.807 220.661C729.76 220.711 729.695 220.74 729.626 220.742H728.363V221.616H729.447C729.516 221.616 729.581 221.645 729.629 221.694C729.678 221.744 729.705 221.811 729.706 221.881C729.706 221.951 729.679 222.018 729.63 222.068C729.582 222.118 729.516 222.146 729.447 222.146H728.363V223.026H729.626C729.695 223.026 729.761 223.054 729.809 223.104C729.858 223.153 729.885 223.221 729.885 223.291C729.885 223.361 729.858 223.429 729.809 223.478C729.761 223.528 729.695 223.556 729.626 223.556H728.101C728.034 223.557 727.97 223.531 727.922 223.484C727.873 223.437 727.845 223.373 727.842 223.305Z",
    fill: "#FFC727"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M733.328 223.169C733.34 223.202 733.344 223.237 733.342 223.272C733.34 223.307 733.332 223.342 733.317 223.373C733.301 223.405 733.28 223.433 733.254 223.456C733.228 223.48 733.198 223.497 733.166 223.508C733.131 223.512 733.097 223.512 733.063 223.508C732.998 223.509 732.935 223.49 732.88 223.454C732.818 223.412 732.766 223.355 732.731 223.287C732.655 223.108 732.621 222.912 732.632 222.717C732.631 222.644 732.613 222.573 732.579 222.509C732.54 222.454 732.492 222.406 732.436 222.37C732.356 222.318 732.269 222.28 732.177 222.258H731.627V223.294C731.626 223.329 731.619 223.363 731.606 223.395C731.592 223.427 731.573 223.456 731.549 223.481C731.524 223.505 731.496 223.524 731.464 223.537C731.432 223.55 731.399 223.556 731.365 223.556C731.297 223.556 731.232 223.528 731.184 223.479C731.136 223.43 731.109 223.364 731.109 223.294V220.474C731.109 220.439 731.115 220.405 731.128 220.373C731.141 220.341 731.159 220.312 731.183 220.288C731.207 220.263 731.235 220.244 731.267 220.231C731.298 220.218 731.331 220.211 731.365 220.212H732.201C732.407 220.211 732.608 220.275 732.777 220.396C732.946 220.517 733.074 220.689 733.144 220.888C733.213 221.086 733.221 221.303 733.165 221.506C733.11 221.709 732.994 221.89 732.834 222.023C732.897 222.073 732.952 222.132 732.997 222.2C733.099 222.352 733.153 222.532 733.152 222.717C733.146 222.81 733.152 222.903 733.169 222.995C733.207 223.009 733.241 223.032 733.269 223.062C733.297 223.092 733.317 223.129 733.328 223.169ZM732.665 221.248C732.666 221.184 732.654 221.119 732.63 221.059C732.607 220.999 732.572 220.944 732.527 220.898C732.483 220.852 732.43 220.815 732.372 220.79C732.313 220.765 732.251 220.752 732.187 220.752H731.614V221.738H732.187C732.251 221.739 732.314 221.728 732.373 221.704C732.432 221.68 732.486 221.644 732.531 221.598C732.577 221.553 732.613 221.498 732.638 221.438C732.662 221.378 732.675 221.314 732.675 221.248H732.665Z",
    fill: "#FFC727"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M737.357 220.484V223.305C737.355 223.375 737.326 223.441 737.278 223.49C737.229 223.539 737.163 223.566 737.095 223.566C737.027 223.566 736.962 223.539 736.914 223.49C736.866 223.441 736.839 223.374 736.839 223.305V221.293L736.176 222.248C736.152 222.282 736.12 222.31 736.083 222.328C736.046 222.347 736.005 222.357 735.964 222.356C735.919 222.36 735.875 222.352 735.834 222.334C735.794 222.316 735.758 222.287 735.731 222.251L735.068 221.296V223.308C735.068 223.378 735.041 223.446 734.992 223.495C734.944 223.545 734.878 223.573 734.809 223.573C734.741 223.573 734.675 223.545 734.627 223.495C734.578 223.446 734.551 223.378 734.551 223.308V220.487C734.552 220.418 734.579 220.352 734.627 220.303C734.674 220.254 734.739 220.226 734.806 220.226H734.823C734.862 220.226 734.902 220.236 734.937 220.255C734.972 220.274 735.002 220.301 735.025 220.334L735.954 221.653L736.882 220.334C736.906 220.3 736.937 220.273 736.974 220.254C737.01 220.235 737.05 220.225 737.091 220.226C737.16 220.225 737.226 220.251 737.275 220.299C737.325 220.348 737.354 220.414 737.357 220.484Z",
    fill: "#FFC727"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M738.983 220.484C738.983 220.45 738.99 220.415 739.003 220.383C739.016 220.351 739.035 220.322 739.059 220.298C739.083 220.274 739.112 220.255 739.143 220.242C739.175 220.229 739.208 220.222 739.242 220.223C739.31 220.223 739.375 220.25 739.424 220.299C739.472 220.348 739.5 220.415 739.501 220.484V223.305C739.5 223.375 739.472 223.441 739.424 223.49C739.375 223.539 739.31 223.567 739.242 223.567C739.208 223.567 739.175 223.561 739.143 223.548C739.112 223.535 739.083 223.516 739.059 223.491C739.035 223.467 739.016 223.438 739.003 223.406C738.99 223.374 738.983 223.34 738.983 223.305V220.484Z",
    fill: "#FFC727"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M741.369 223.305C741.374 223.342 741.37 223.379 741.359 223.414C741.348 223.449 741.33 223.481 741.306 223.509C741.282 223.536 741.253 223.558 741.22 223.574C741.187 223.589 741.152 223.596 741.116 223.596C741.08 223.596 741.044 223.589 741.011 223.574C740.978 223.558 740.949 223.536 740.925 223.509C740.901 223.481 740.883 223.449 740.872 223.414C740.861 223.379 740.858 223.342 740.862 223.305V220.528C740.859 220.472 740.874 220.417 740.904 220.37C740.935 220.324 740.979 220.289 741.031 220.27C741.083 220.252 741.139 220.251 741.191 220.268C741.243 220.285 741.288 220.319 741.32 220.365L742.825 222.5V220.532C742.826 220.464 742.853 220.398 742.9 220.35C742.947 220.302 743.011 220.274 743.077 220.274C743.145 220.274 743.209 220.301 743.257 220.349C743.305 220.397 743.332 220.463 743.333 220.532V223.308C743.332 223.377 743.305 223.444 743.257 223.492C743.209 223.541 743.145 223.569 743.077 223.57C743.041 223.57 743.004 223.561 742.971 223.544C742.938 223.528 742.908 223.504 742.885 223.475L742.862 223.444L741.369 221.324V223.305Z",
    fill: "#FFC727"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M746.566 222.778H745.435L745.206 223.4C745.186 223.449 745.153 223.491 745.11 223.521C745.066 223.55 745.016 223.566 744.964 223.566C744.921 223.568 744.879 223.559 744.841 223.539C744.803 223.52 744.77 223.491 744.746 223.455C744.721 223.419 744.707 223.377 744.702 223.334C744.698 223.29 744.705 223.246 744.722 223.206L745.75 220.396C745.77 220.345 745.805 220.302 745.849 220.272C745.893 220.242 745.945 220.226 745.999 220.226C746.052 220.225 746.103 220.241 746.147 220.271C746.191 220.301 746.225 220.345 746.244 220.396L747.275 223.206C747.296 223.272 747.292 223.344 747.264 223.407C747.236 223.47 747.185 223.519 747.123 223.546C747.093 223.552 747.063 223.552 747.033 223.546C746.982 223.547 746.931 223.531 746.888 223.501C746.846 223.471 746.813 223.429 746.795 223.379L746.566 222.778ZM746.377 222.251L746.012 221.232L745.634 222.251H746.377Z",
    fill: "#FFC727"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M748.383 223.305V220.484C748.382 220.45 748.389 220.416 748.401 220.384C748.414 220.352 748.433 220.323 748.457 220.298C748.48 220.274 748.509 220.255 748.54 220.242C748.571 220.229 748.605 220.222 748.638 220.223C748.707 220.223 748.772 220.25 748.821 220.299C748.87 220.348 748.898 220.414 748.9 220.484V223.037H750.164C750.232 223.037 750.298 223.064 750.347 223.114C750.395 223.164 750.422 223.231 750.422 223.302C750.422 223.372 750.395 223.439 750.347 223.489C750.298 223.539 750.232 223.567 750.164 223.567H748.638C748.605 223.567 748.571 223.561 748.54 223.548C748.509 223.535 748.48 223.515 748.457 223.491C748.433 223.467 748.414 223.438 748.401 223.406C748.389 223.374 748.382 223.34 748.383 223.305Z",
    fill: "#FFC727"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M658.699 251.958C701.038 251.751 748.531 251.751 790.87 251.958C748.531 252.169 701.038 252.166 658.699 251.958Z",
    fill: "#263238"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2391 19.7588H99.6995C87.6814 19.7588 77.9447 29.8909 77.9447 42.3885C77.9447 54.8861 87.676 65.0293 99.6995 65.0293H94.2391C82.221 65.0293 72.4844 54.8972 72.4844 42.3885C72.4844 29.8798 82.221 19.7588 94.2391 19.7588Z",
    fill: "#0A8200"
  })), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1337 19.7598H99.594C87.5759 19.7598 77.8392 29.8919 77.8392 42.3895C77.8392 54.8871 87.5705 65.0303 99.594 65.0303H94.1337C82.1156 65.0303 72.3789 54.8982 72.3789 42.3895C72.3789 29.8808 82.1156 19.7598 94.1337 19.7598Z",
    fill: "black"
  }))), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6986 129.25H94.2383C116.323 102.887 137.007 73.9862 133.969 42.0775C131.99 21.4088 118.291 0.823242 94.2383 0.823242H99.6986C123.756 0.823242 137.451 21.4088 139.424 42.0775C142.489 73.9862 121.805 102.887 99.6986 129.25Z",
    fill: "#0A8200"
  })), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7533 129.243H94.293C116.378 102.879 137.062 73.9784 134.024 42.0697C132.045 21.401 118.345 0.81543 94.293 0.81543H99.7533C123.811 0.81543 137.505 21.401 139.478 42.0697C142.544 73.9784 121.859 102.879 99.7533 129.243Z",
    fill: "black"
  }))), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M133.964 42.0788C137.008 73.9875 116.323 102.888 94.2389 129.257C72.1813 102.888 51.497 73.9875 54.5353 42.0788C56.514 21.4101 70.2135 0.830078 94.2389 0.830078C118.264 0.830078 131.991 21.4101 133.964 42.0788ZM94.2389 65.0298C106.284 65.0298 116.021 54.8977 116.021 42.389C116.021 29.8803 106.289 19.7593 94.2389 19.7593C82.1883 19.7593 72.4841 29.8914 72.4841 42.389C72.4841 54.8866 82.2154 65.0298 94.2389 65.0298Z",
    fill: "#0A8200"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M107.926 165.553C110.273 165.553 168.824 165.134 185.337 165.134C186.493 165.134 185.03 163.084 184.395 162.938C182.363 162.483 180.243 162.46 178.172 162.242C176.137 162.048 174.142 161.541 172.255 160.738C170.628 160.037 169.006 159.222 167.241 158.916C163.836 158.37 160.849 160.283 157.653 161.098C156.683 161.386 155.665 161.461 154.664 161.321C153.663 161.181 152.703 160.827 151.843 160.283C150.368 159.372 149.025 158.288 147.483 157.486C144.529 155.995 141.308 155.144 138.019 154.987C134.73 154.831 131.445 155.371 128.369 156.575C126.903 157.153 125.501 157.887 124.186 158.766C122.626 159.818 121.279 161.157 119.714 162.196C116.247 164.473 111.962 163.745 108.179 165.061C107.957 165.152 107.721 165.553 107.926 165.553Z",
    fill: "#EBEBEB"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M104.561 111.802C107.673 111.802 159.849 112.153 163.13 112.048C163.365 112.048 163.49 111.683 163.259 111.565C161.187 110.517 158.845 110.727 156.698 109.985C155.431 109.529 154.653 108.7 153.777 107.707C153.052 106.856 152.113 106.226 151.061 105.885C150.101 105.59 149.082 105.557 148.105 105.79C147.048 106.049 146.127 106.669 145.118 107.06C142.611 108.031 140.175 107.11 138.384 105.211C136.908 103.644 135.455 102.164 133.45 101.321C132.63 100.941 131.743 100.739 130.844 100.726C129.944 100.714 129.052 100.891 128.223 101.248C126.307 102.137 124.995 103.922 123.195 104.997C121.066 106.272 118.515 105.972 116.163 106.363C113.812 106.755 112.002 108.782 109.94 109.953C109.267 110.395 108.49 110.642 107.691 110.668C107.246 110.668 106.775 110.527 106.322 110.467C105.61 110.376 104.935 110.399 104.455 111.005C104.335 111.173 104.361 111.802 104.561 111.802Z",
    fill: "#EBEBEB"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M0.123867 139.591C2.38641 139.591 40.4852 139.851 42.8811 139.769C43.05 139.769 43.1434 139.505 42.9745 139.418C41.4631 138.653 39.7518 138.808 38.1827 138.266C37.2581 137.947 36.6936 137.327 36.0535 136.621C35.5223 136.002 34.8371 135.543 34.071 135.291C33.3691 135.076 32.6242 135.052 31.9107 135.223C31.1651 135.479 30.4362 135.784 29.7281 136.134C27.9012 136.84 26.1232 136.171 24.8163 134.768C23.7361 133.624 22.6782 132.545 21.2113 131.93C20.6136 131.652 19.9663 131.504 19.31 131.495C18.6537 131.485 18.0026 131.615 17.3975 131.875C15.9973 132.522 15.0371 133.829 13.7258 134.608C12.17 135.542 10.3076 135.319 8.59175 135.601C6.87595 135.884 5.55131 137.364 4.04443 138.22C3.55295 138.544 2.98403 138.724 2.39975 138.739C2.06637 138.739 1.73299 138.639 1.39961 138.598C1.15962 138.53 0.905843 138.53 0.665978 138.599C0.426113 138.668 0.209374 138.803 0.0394098 138.99C-0.0228214 139.136 -0.0228203 139.591 0.123867 139.591Z",
    fill: "#EBEBEB"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M141.709 140.607C143.976 140.607 182.075 140.867 184.466 140.785C184.639 140.785 184.733 140.52 184.559 140.434C183.052 139.669 181.341 139.824 179.772 139.282C178.847 138.963 178.283 138.343 177.643 137.637C177.112 137.018 176.426 136.559 175.66 136.307C174.958 136.091 174.214 136.068 173.5 136.239C172.754 136.495 172.026 136.799 171.317 137.15C169.486 137.856 167.708 137.186 166.401 135.783C165.325 134.64 164.263 133.561 162.801 132.946C162.202 132.668 161.554 132.52 160.897 132.51C160.24 132.501 159.588 132.631 158.982 132.891C157.587 133.538 156.626 134.845 155.315 135.624C153.759 136.535 151.897 136.335 150.177 136.617C148.456 136.899 147.141 138.38 145.634 139.236C145.148 139.569 144.582 139.76 143.998 139.787C143.662 139.757 143.328 139.708 142.998 139.641C142.757 139.574 142.504 139.575 142.264 139.645C142.024 139.715 141.807 139.851 141.638 140.038C141.544 140.147 141.562 140.607 141.709 140.607Z",
    fill: "#EBEBEB"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4387 178.603C39.7057 178.603 77.8045 178.863 80.2004 178.781C80.3693 178.781 80.4627 178.517 80.2938 178.43C78.7824 177.665 77.0711 177.82 75.502 177.278C74.5774 176.959 74.0129 176.339 73.3728 175.633C72.8416 175.014 72.1564 174.555 71.3903 174.303C70.6884 174.087 69.9435 174.064 69.23 174.235C68.4844 174.491 67.7555 174.796 67.0474 175.146C65.2205 175.852 63.438 175.182 62.1578 173.78C61.0777 172.636 60.0197 171.557 58.5529 170.942C57.9543 170.664 57.3063 170.516 56.6493 170.506C55.9922 170.497 55.3404 170.627 54.7345 170.887C53.3388 171.534 52.3786 172.841 51.0673 173.62C49.5116 174.531 47.6491 174.331 45.9333 174.613C44.2175 174.895 42.8928 176.376 41.386 177.232C40.8945 177.556 40.3256 177.736 39.7413 177.751C39.4056 177.721 39.0718 177.672 38.7411 177.606C38.5007 177.539 38.2469 177.54 38.0072 177.61C37.7675 177.68 37.551 177.815 37.3809 178.002C37.2742 178.148 37.3143 178.603 37.4387 178.603Z",
    fill: "#EBEBEB"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6738 156.662C20.7183 156.795 80.7269 156.662 79.9668 156.662C79.6245 156.662 80.4913 156.134 80.1535 155.961C78.2021 154.968 76.064 154.941 73.9304 154.74C72.6716 154.685 71.4359 154.376 70.2943 153.829C69.1652 153.224 68.4585 152.167 67.6584 151.197C66.4216 149.695 64.8318 148.542 63.039 147.845C61.2462 147.149 59.3097 146.932 57.4124 147.216C53.1452 147.904 49.7802 151.233 45.5085 151.844C42.9392 152.212 40.5122 151.197 38.0008 150.837C36.0601 150.563 34.0848 150.934 32.3644 151.894C31.0309 152.581 29.7596 153.16 28.2305 153.26C27.057 153.342 25.879 153.205 24.7011 153.192C22.7815 153.241 20.9452 154.005 19.5359 155.342C19.3225 155.51 18.718 156.662 20.6738 156.662Z",
    fill: "#EBEBEB"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M123.958 161.189H61.7979V250.063H123.958V161.189Z",
    fill: "#FFC727"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M123.958 161.189H61.7979V250.063H123.958V161.189Z",
    fill: "white"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M115.066 219.97H70.6865V222.261H115.066V219.97Z",
    fill: "#FFC727"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M106.461 222.261H79.3193V248.246H106.461V222.261Z",
    fill: "#455A64"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M104.636 224.179H81.1484V248.246H104.636V224.179Z",
    fill: "#37474F"
  })), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.635 234.222V238.69L95.3138 248.246H90.9531L104.635 234.222Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2811 224.179L81.1514 230.46V225.992L82.9161 224.179H87.2811Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.385 224.179L81.1514 243.892V241.66L98.2071 224.179H100.385Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.634 241.012V243.248L99.7577 248.245H97.5752L104.634 241.012Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.636 226.415V226.82L83.7351 248.246H83.3262L104.636 226.415Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8237 224.179L81.1514 233.065V232.651L89.4192 224.179H89.8237Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2203 224.179L81.1514 240.644V240.225L96.8114 224.179H97.2203Z",
    fill: "#455A64"
  }))), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M93.651 224.179H92.1396V248.246H93.651V224.179Z",
    fill: "#455A64"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1874 170.883H71.4971V186.274H81.1874V170.883Z",
    fill: "#455A64"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1905 172.011H72.4961V185.147H80.1905V172.011Z",
    fill: "#37474F"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5744 186.272H70.1104V188.486H82.5744V186.272Z",
    fill: "#FFC727"
  })), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1911 172.012V173.633L72.4922 181.522V178.521L78.8487 172.012H80.1911Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.191 181.75V183.249L78.3374 185.148H76.875L80.191 181.75Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0837 172.012L72.4922 174.667V173.164L73.6168 172.012H75.0837Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1932 179.399V179.882L75.0503 185.148H74.5791L80.1932 179.399Z",
    fill: "#455A64"
  }))), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1874 179.736H71.4971V180.861H81.1874V179.736Z",
    fill: "#455A64"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7245 170.883H88.0342V186.274H97.7245V170.883Z",
    fill: "#455A64"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7286 172.011H89.0342V185.147H96.7286V172.011Z",
    fill: "#37474F"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1105 186.272H86.6465V188.486H99.1105V186.272Z",
    fill: "#FFC727"
  })), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7272 172.012V173.633L89.0283 181.522V178.521L95.3848 172.012H96.7272Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7277 181.749V183.248L94.8741 185.147H93.4072L96.7277 181.749Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6198 172.012L89.0283 174.667V173.164L90.1529 172.012H91.6198Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7284 179.399V179.882L91.5854 185.148H91.1143L96.7284 179.399Z",
    fill: "#455A64"
  }))), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7245 179.736H88.0342V180.861H97.7245V179.736Z",
    fill: "#455A64"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 170.883H104.566V186.274H114.257V170.883Z",
    fill: "#455A64"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M113.264 172.011H105.569V185.147H113.264V172.011Z",
    fill: "#37474F"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M115.645 186.272H103.181V188.486H115.645V186.272Z",
    fill: "#FFC727"
  })), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.262 172.012V173.633L105.563 181.522V178.521L111.92 172.012H113.262Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.262 181.75V183.249L111.409 185.148H109.946L113.262 181.75Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.155 172.012L105.563 174.667V173.164L106.688 172.012H108.155Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.265 179.399V179.882L108.122 185.148H107.65L113.265 179.399Z",
    fill: "#455A64"
  }))), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 179.736H104.566V180.861H114.257V179.736Z",
    fill: "#455A64"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1874 194.125H71.4971V209.516H81.1874V194.125Z",
    fill: "#455A64"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1905 195.251H72.4961V208.387H80.1905V195.251Z",
    fill: "#37474F"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5744 209.517H70.1104V211.73H82.5744V209.517Z",
    fill: "#FFC727"
  })), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1911 195.251V196.877L72.4922 204.761V201.764L78.8487 195.251H80.1911Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.191 204.99V206.493L78.3374 208.393H76.875L80.191 204.99Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0837 195.251L72.4922 197.906V196.408L73.6168 195.251H75.0837Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1932 202.641V203.123L75.0503 208.393H74.5791L80.1932 202.641Z",
    fill: "#455A64"
  }))), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1874 202.98H71.4971V204.106H81.1874V202.98Z",
    fill: "#455A64"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7245 194.125H88.0342V209.516H97.7245V194.125Z",
    fill: "#455A64"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7286 195.251H89.0342V208.387H96.7286V195.251Z",
    fill: "#37474F"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1105 209.517H86.6465V211.73H99.1105V209.517Z",
    fill: "#FFC727"
  })), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7272 195.251V196.877L89.0283 204.761V201.764L95.3848 195.251H96.7272Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7248 204.989V206.492L94.8712 208.392H93.4043L96.7248 204.989Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6198 195.251L89.0283 197.906V196.408L90.1529 195.251H91.6198Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7284 202.641V203.123L91.5854 208.393H91.1143L96.7284 202.641Z",
    fill: "#455A64"
  }))), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7245 202.98H88.0342V204.106H97.7245V202.98Z",
    fill: "#455A64"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 194.125H104.566V209.516H114.257V194.125Z",
    fill: "#455A64"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M113.264 195.251H105.569V208.387H113.264V195.251Z",
    fill: "#37474F"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M115.645 209.517H103.181V211.73H115.645V209.517Z",
    fill: "#FFC727"
  })), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.262 195.251V196.877L105.563 204.761V201.764L111.92 195.251H113.262Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.262 204.99V206.493L111.409 208.393H109.946L113.262 204.99Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.155 195.251L105.563 197.906V196.408L106.688 195.251H108.155Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.265 202.639V203.121L108.122 208.391H107.65L113.265 202.639Z",
    fill: "#455A64"
  }))), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M114.257 202.98H104.566V204.106H114.257V202.98Z",
    fill: "#455A64"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.958 215.359H61.7979V216.138L123.958 215.747V215.359Z",
    fill: "#FFC727"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M123.958 214.275H61.7979V215.359H123.958V214.275Z",
    fill: "white"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.958 191.41H61.7979V192.194L123.958 191.802V191.41Z",
    fill: "#FFC727"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M123.958 190.326H61.7979V191.41H123.958V190.326Z",
    fill: "white"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.958 167.467H61.7979V168.25L123.958 167.859V167.467Z",
    fill: "#FFC727"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M123.958 166.382H61.7979V167.466H123.958V166.382Z",
    fill: "white"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7979 161.189H59.1309V250.063H61.7979V161.189Z",
    fill: "#FFC727"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M61.7979 161.189H59.1309V250.063H61.7979V161.189Z",
    fill: "white"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M126.627 161.189H123.96V250.063H126.627V161.189Z",
    fill: "#FFC727"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M126.627 161.189H123.96V250.063H126.627V161.189Z",
    fill: "white"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M113.189 222.261H110.896V248.246H113.189V222.261Z",
    fill: "#FFC727"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M113.189 222.261H110.896V248.246H113.189V222.261Z",
    fill: "white"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8591 222.261H72.5654V248.246H74.8591V222.261Z",
    fill: "#FFC727"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M74.8591 222.261H72.5654V248.246H74.8591V222.261Z",
    fill: "white"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M117.65 249.161H68.1006V250.077H117.65V249.161Z",
    fill: "#EBEBEB"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M115.237 248.246H70.5195V249.162H115.237V248.246Z",
    fill: "#EBEBEB"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M115.237 248.929L70.5195 248.701V249.161H115.237V248.929Z",
    fill: "#DBDBDB"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M59.136 185.812H3.8125V250.067H59.136V185.812Z",
    fill: "#FFC727"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.136 185.812H3.8125V250.067H59.136V185.812Z",
    fill: "white"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.136 240.352H3.8125V250.067H59.136V240.352Z",
    fill: "#FFC727"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7782 194.017H10.0879V209.407H19.7782V194.017Z",
    fill: "#455A64"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7823 195.142H11.0879V208.278H18.7823V195.142Z",
    fill: "#37474F"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1671 209.406H8.70312V211.62H21.1671V209.406Z",
    fill: "#FFC727"
  })), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7823 195.146V196.767L11.0879 204.656V201.654L17.4399 195.146H18.7823Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7799 204.884V206.382L16.9263 208.282H15.4639L18.7799 204.884Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6794 195.146L11.0879 197.801V196.298L12.2081 195.146H13.6794Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7835 202.533V203.011L13.645 208.281H13.1738L18.7835 202.533Z",
    fill: "#455A64"
  }))), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7782 202.869H10.0879V203.994H19.7782V202.869Z",
    fill: "#455A64"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3133 194.017H26.623V209.407H36.3133V194.017Z",
    fill: "#455A64"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3165 195.142H27.6221V208.278H35.3165V195.142Z",
    fill: "#37474F"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7003 209.406H25.2363V211.62H37.7003V209.406Z",
    fill: "#FFC727"
  })), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3194 195.146V196.767L27.625 204.656V201.654L33.977 195.146H35.3194Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.316 204.884V206.382L33.4624 208.282H32L35.316 204.884Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2165 195.146L27.625 197.801V196.298L28.7452 195.146H30.2165Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3206 202.533V203.011L30.1777 208.281H29.7109L35.3206 202.533Z",
    fill: "#455A64"
  }))), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3133 202.869H26.623V203.994H36.3133V202.869Z",
    fill: "#455A64"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 194.017H43.1592V209.407H52.8495V194.017Z",
    fill: "#455A64"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8536 195.142H44.1592V208.278H51.8536V195.142Z",
    fill: "#37474F"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2394 209.406H41.7754V211.62H54.2394V209.406Z",
    fill: "#FFC727"
  })), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8526 195.146V196.767L44.1582 204.656V201.654L50.5102 195.146H51.8526Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8492 204.884V206.382L49.9956 208.282H48.5332L51.8492 204.884Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7497 195.146L44.1582 197.801V196.298L45.2828 195.146H46.7497Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8538 202.533V203.011L46.7153 208.281H46.2441L51.8538 202.533Z",
    fill: "#455A64"
  }))), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 202.869H43.1592V203.994H52.8495V202.869Z",
    fill: "#455A64"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7782 217.256H10.0879V232.647H19.7782V217.256Z",
    fill: "#455A64"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7823 218.385H11.0879V231.521H18.7823V218.385Z",
    fill: "#37474F"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1671 232.649H8.70312V234.863H21.1671V232.649Z",
    fill: "#FFC727"
  })), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7823 218.385V220.011L11.0879 227.895V224.898L17.4399 218.385H18.7823Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7799 228.123V229.626L16.9263 231.521H15.4639L18.7799 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6794 218.385L11.0879 221.04V219.542L12.2081 218.385H13.6794Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7835 225.773V226.256L13.645 231.522H13.1738L18.7835 225.773Z",
    fill: "#455A64"
  }))), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7782 226.109H10.0879V227.234H19.7782V226.109Z",
    fill: "#455A64"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3133 217.256H26.623V232.647H36.3133V217.256Z",
    fill: "#455A64"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3165 218.385H27.6221V231.521H35.3165V218.385Z",
    fill: "#37474F"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7003 232.649H25.2363V234.863H37.7003V232.649Z",
    fill: "#FFC727"
  })), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3194 218.385V220.011L27.625 227.895V224.898L33.977 218.385H35.3194Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.316 228.123V229.626L33.4624 231.521H32L35.316 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2165 218.385L27.625 221.04V219.542L28.7452 218.385H30.2165Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3206 225.773V226.256L30.1777 231.522H29.7109L35.3206 225.773Z",
    fill: "#455A64"
  }))), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3133 226.109H26.623V227.234H36.3133V226.109Z",
    fill: "#455A64"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 217.256H43.1592V232.647H52.8495V217.256Z",
    fill: "#455A64"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8536 218.385H44.1592V231.521H51.8536V218.385Z",
    fill: "#37474F"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2394 232.649H41.7754V234.863H54.2394V232.649Z",
    fill: "#FFC727"
  })), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8526 218.385V220.011L44.1582 227.895V224.898L50.5102 218.385H51.8526Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8492 228.123V229.626L49.9956 231.521H48.5332L51.8492 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7497 218.385L44.1582 221.04V219.542L45.2828 218.385H46.7497Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8538 225.773V226.256L46.7153 231.522H46.2441L51.8538 225.773Z",
    fill: "#455A64"
  }))), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 226.109H43.1592V227.234H52.8495V226.109Z",
    fill: "#455A64"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1301 182.61H1.92188V185.812H59.1301V182.61Z",
    fill: "#FFC727"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1315 214.636H3.8125V215.415L59.1315 215.023V214.636Z",
    fill: "#FFC727"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M59.136 213.552H3.8125V214.636H59.136V213.552Z",
    fill: "white"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.0723 185.812H59.1306V250.067H57.8282L55.0723 185.812Z",
    fill: "#FFC727"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M126.62 250.067H181.943V185.813H126.62V250.067Z",
    fill: "#FFC727"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M126.62 250.067H181.943V185.813H126.62V250.067Z",
    fill: "white"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M142.593 194.017H132.902V209.407H142.593V194.017Z",
    fill: "#455A64"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M141.596 195.142H133.901V208.278H141.596V195.142Z",
    fill: "#37474F"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M143.98 209.406H131.516V211.62H143.98V209.406Z",
    fill: "#FFC727"
  })), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.596 195.146V196.768L133.901 204.657V201.655L140.253 195.146H141.596Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.596 204.886V206.384L139.743 208.284H138.28L141.596 204.886Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.493 195.146L133.901 197.802V196.299L135.026 195.146H136.493Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.598 202.535V203.013L136.459 208.283H135.988L141.598 202.535Z",
    fill: "#455A64"
  }))), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M142.593 202.872H132.902V203.997H142.593V202.872Z",
    fill: "#455A64"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M159.127 194.017H149.437V209.407H159.127V194.017Z",
    fill: "#455A64"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M158.133 195.142H150.438V208.278H158.133V195.142Z",
    fill: "#37474F"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M160.514 209.406H148.05V211.62H160.514V209.406Z",
    fill: "#FFC727"
  })), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.13 195.146V196.768L150.436 204.657V201.655L156.788 195.146H158.13Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.126 204.885V206.383L156.272 208.283H154.81L158.126 204.885Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.027 195.146L150.436 197.802V196.299L151.56 195.146H153.027Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.129 202.535V203.013L152.991 208.283H152.52L158.129 202.535Z",
    fill: "#455A64"
  }))), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M159.127 202.872H149.437V203.997H159.127V202.872Z",
    fill: "#455A64"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M175.664 194.017H165.974V209.407H175.664V194.017Z",
    fill: "#455A64"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M174.668 195.142H166.974V208.278H174.668V195.142Z",
    fill: "#37474F"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M177.051 209.406H164.587V211.62H177.051V209.406Z",
    fill: "#FFC727"
  })), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.666 195.146V196.768L166.972 204.657V201.655L173.324 195.146H174.666Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.663 204.885V206.383L172.809 208.283H171.347L174.663 204.885Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.563 195.146L166.972 197.802V196.299L168.096 195.146H169.563Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.667 202.535V203.013L169.529 208.283H169.058L174.667 202.535Z",
    fill: "#455A64"
  }))), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M175.664 202.872H165.974V203.997H175.664V202.872Z",
    fill: "#455A64"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M142.593 217.256H132.902V232.647H142.593V217.256Z",
    fill: "#455A64"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M141.596 218.385H133.901V231.521H141.596V218.385Z",
    fill: "#37474F"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M143.98 232.649H131.516V234.863H143.98V232.649Z",
    fill: "#FFC727"
  })), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.596 218.385V220.011L133.901 227.895V224.898L140.253 218.385H141.596Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.596 228.123V229.626L139.743 231.521H138.28L141.596 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.493 218.385L133.901 221.04V219.542L135.026 218.385H136.493Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.598 225.773V226.256L136.459 231.522H135.988L141.598 225.773Z",
    fill: "#455A64"
  }))), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M142.593 226.109H132.902V227.234H142.593V226.109Z",
    fill: "#455A64"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M159.127 217.256H149.437V232.647H159.127V217.256Z",
    fill: "#455A64"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M158.133 218.385H150.438V231.521H158.133V218.385Z",
    fill: "#37474F"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M160.514 232.649H148.05V234.863H160.514V232.649Z",
    fill: "#FFC727"
  })), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.13 218.385V220.011L150.436 227.895V224.898L156.788 218.385H158.13Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.126 228.123V229.626L156.272 231.521H154.81L158.126 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.027 218.385L150.436 221.04V219.542L151.56 218.385H153.027Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.129 225.773V226.256L152.991 231.522H152.52L158.129 225.773Z",
    fill: "#455A64"
  }))), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M159.127 226.109H149.437V227.234H159.127V226.109Z",
    fill: "#455A64"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M175.664 217.256H165.974V232.647H175.664V217.256Z",
    fill: "#455A64"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M174.668 218.385H166.974V231.521H174.668V218.385Z",
    fill: "#37474F"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M177.051 232.649H164.587V234.863H177.051V232.649Z",
    fill: "#FFC727"
  })), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.666 218.385V220.011L166.972 227.895V224.898L173.324 218.385H174.666Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.663 228.123V229.626L172.809 231.521H171.347L174.663 228.123Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.563 218.385L166.972 221.04V219.542L168.096 218.385H169.563Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.667 225.773V226.256L169.529 231.522H169.058L174.667 225.773Z",
    fill: "#455A64"
  }))), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M175.664 226.109H165.974V227.234H175.664V226.109Z",
    fill: "#455A64"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M126.625 185.812H183.833V182.61H126.625V185.812Z",
    fill: "#FFC727"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.948 240.352H126.624V250.067H181.948V240.352Z",
    fill: "#FFC727"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.943 214.636H126.624V215.415L181.943 215.023V214.636Z",
    fill: "#FFC727"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M181.948 213.552H126.624V214.636H181.948V213.552Z",
    fill: "white"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.682 185.812H126.624V250.067H127.926L130.682 185.812Z",
    fill: "#FFC727"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M118.815 152.285H66.9453V162.638H118.815V152.285Z",
    fill: "#FFC727"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0391 159.326V155.728C72.0485 155.644 72.0874 155.568 72.1485 155.512C72.2096 155.456 72.2885 155.425 72.3702 155.425C72.452 155.425 72.5309 155.456 72.592 155.512C72.653 155.568 72.692 155.644 72.7014 155.728V157.194H74.2483V155.728C74.2477 155.683 74.2558 155.639 74.2721 155.598C74.2884 155.557 74.3126 155.519 74.3433 155.488C74.3739 155.457 74.4104 155.432 74.4506 155.415C74.4908 155.398 74.5338 155.39 74.5772 155.391C74.6649 155.391 74.749 155.426 74.8114 155.489C74.8738 155.552 74.9094 155.638 74.9106 155.728V159.335C74.9106 159.38 74.9019 159.424 74.8851 159.465C74.8683 159.506 74.8437 159.544 74.8127 159.575C74.7817 159.606 74.7449 159.631 74.7045 159.648C74.664 159.665 74.6208 159.673 74.5772 159.672C74.5338 159.673 74.4908 159.664 74.4506 159.648C74.4104 159.631 74.3739 159.606 74.3433 159.575C74.3126 159.543 74.2884 159.506 74.2721 159.465C74.2558 159.424 74.2477 159.38 74.2483 159.335V157.868H72.7014V159.335C72.692 159.418 72.653 159.495 72.592 159.551C72.5309 159.607 72.452 159.637 72.3702 159.637C72.2885 159.637 72.2096 159.607 72.1485 159.551C72.0874 159.495 72.0485 159.418 72.0391 159.335V159.326Z",
    fill: "white"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0176 155.728C76.017 155.683 76.0251 155.639 76.0414 155.598C76.0577 155.557 76.0819 155.519 76.1126 155.488C76.1433 155.457 76.1798 155.432 76.22 155.415C76.2601 155.398 76.3032 155.39 76.3465 155.391C76.4342 155.391 76.5183 155.426 76.5807 155.489C76.6431 155.552 76.6788 155.638 76.6799 155.728V159.335C76.6788 159.425 76.6431 159.511 76.5807 159.574C76.5183 159.637 76.4342 159.672 76.3465 159.672C76.3032 159.673 76.2601 159.664 76.22 159.648C76.1798 159.631 76.1433 159.606 76.1126 159.575C76.0819 159.543 76.0577 159.506 76.0414 159.465C76.0251 159.424 76.017 159.38 76.0176 159.335V155.728Z",
    fill: "white"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6074 157.469C77.6103 157.174 77.6703 156.883 77.7839 156.612C77.8975 156.341 78.0624 156.096 78.2692 155.891C78.4759 155.686 78.7203 155.525 78.9883 155.417C79.2562 155.31 79.5423 155.258 79.83 155.264C80.3203 155.256 80.7991 155.417 81.1902 155.72C81.2307 155.746 81.2655 155.78 81.2922 155.821C81.3189 155.862 81.3371 155.907 81.3454 155.956C81.3537 156.004 81.3521 156.054 81.3406 156.101C81.3291 156.149 81.308 156.193 81.2787 156.232C81.2493 156.271 81.2124 156.303 81.1702 156.326C81.1281 156.349 81.0816 156.363 81.0339 156.367C80.9862 156.37 80.9383 156.364 80.8932 156.347C80.8482 156.331 80.807 156.305 80.7723 156.271C80.5014 156.059 80.1705 155.944 79.83 155.943C79.6299 155.94 79.4315 155.979 79.2466 156.058C79.0617 156.136 78.8942 156.252 78.7543 156.398C78.6126 156.534 78.4997 156.697 78.4225 156.879C78.3452 157.061 78.3054 157.257 78.3054 157.455C78.3054 157.653 78.3452 157.85 78.4225 158.031C78.4997 158.213 78.6126 158.377 78.7543 158.512C78.8942 158.658 79.0617 158.774 79.2466 158.852C79.4315 158.931 79.6299 158.97 79.83 158.967C80.1177 158.964 80.3997 158.884 80.6479 158.735V157.897H79.7944C79.7044 157.897 79.618 157.861 79.5539 157.796C79.4899 157.731 79.4533 157.643 79.4521 157.551C79.4521 157.505 79.461 157.46 79.4783 157.417C79.4955 157.375 79.5208 157.337 79.5526 157.304C79.5845 157.272 79.6223 157.247 79.6638 157.23C79.7053 157.212 79.7497 157.204 79.7944 157.205H80.9812C81.0264 157.203 81.0712 157.211 81.1133 157.228C81.1553 157.245 81.1936 157.27 81.2259 157.303C81.2582 157.335 81.2839 157.374 81.3014 157.416C81.319 157.459 81.328 157.505 81.328 157.551V158.917C81.3308 158.952 81.3308 158.987 81.328 159.022C81.3262 159.033 81.3262 159.043 81.328 159.054C81.3074 159.115 81.2665 159.167 81.2124 159.2C80.8891 159.449 80.5057 159.603 80.1033 159.645C79.701 159.687 79.295 159.616 78.9291 159.44C78.5633 159.263 78.2514 158.987 78.0271 158.642C77.8028 158.297 77.6746 157.896 77.6563 157.482L77.6074 157.469Z",
    fill: "white"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2782 158.598C88.3319 158.532 88.4088 158.491 88.4922 158.483C88.5756 158.475 88.6585 158.502 88.7227 158.557C89.0452 158.832 89.4462 158.992 89.8651 159.012C90.1302 159.016 90.3902 158.938 90.6119 158.789C90.6877 158.741 90.7506 158.674 90.7948 158.594C90.8391 158.515 90.8633 158.425 90.8653 158.334C90.866 158.265 90.8475 158.197 90.8119 158.138C90.7669 158.064 90.7061 158.002 90.6341 157.956C90.3809 157.81 90.1037 157.712 89.8162 157.669C89.5506 157.623 89.2921 157.542 89.0472 157.427C88.8239 157.332 88.6313 157.174 88.4916 156.972C88.4007 156.821 88.3529 156.648 88.3538 156.471C88.3564 156.291 88.4014 156.114 88.485 155.955C88.5686 155.797 88.6882 155.661 88.8339 155.56C89.1359 155.344 89.4967 155.231 89.8651 155.237C90.3371 155.262 90.7908 155.432 91.1675 155.724C91.2007 155.747 91.2291 155.776 91.2511 155.81C91.2731 155.845 91.2882 155.883 91.2957 155.923C91.3031 155.963 91.3027 156.005 91.2944 156.045C91.2862 156.085 91.2702 156.123 91.2475 156.157C91.2264 156.192 91.1984 156.222 91.1654 156.246C91.1324 156.27 91.095 156.286 91.0555 156.295C91.016 156.303 90.9752 156.304 90.9356 156.296C90.8961 156.287 90.8585 156.271 90.8253 156.248C90.5512 156.021 90.2165 155.884 89.8651 155.856C89.6269 155.852 89.3936 155.926 89.1984 156.066C89.131 156.104 89.0747 156.16 89.0349 156.228C88.9951 156.296 88.9734 156.374 88.9717 156.453C88.9668 156.512 88.9808 156.571 89.0117 156.621C89.0547 156.684 89.109 156.738 89.1717 156.781C89.4013 156.919 89.6549 157.01 89.9185 157.049C90.2018 157.101 90.478 157.189 90.7408 157.309C90.9837 157.414 91.191 157.589 91.3364 157.815C91.4308 157.971 91.4816 158.15 91.4831 158.334C91.4771 158.522 91.4271 158.707 91.3374 158.872C91.2477 159.036 91.1209 159.177 90.9675 159.281C90.646 159.516 90.2597 159.639 89.8651 159.632C89.3038 159.603 88.767 159.387 88.336 159.017C88.2804 158.965 88.2442 158.895 88.2337 158.818C88.2231 158.742 88.2389 158.664 88.2782 158.598Z",
    fill: "white"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2061 157.464C92.2166 156.876 92.4522 156.316 92.8622 155.904C93.2721 155.493 93.8236 155.263 94.3975 155.264C94.8935 155.254 95.3786 155.414 95.7754 155.72C95.8438 155.779 95.8878 155.863 95.8985 155.954C95.9092 156.045 95.8859 156.137 95.8332 156.212C95.7773 156.283 95.6966 156.329 95.6079 156.341C95.5193 156.353 95.4296 156.33 95.3576 156.275C95.0852 156.053 94.7456 155.936 94.3975 155.943C93.9954 155.949 93.6106 156.112 93.3218 156.398C93.0426 156.68 92.8828 157.063 92.8773 157.464C92.8787 157.662 92.9187 157.858 92.995 158.041C93.0714 158.223 93.1825 158.388 93.3218 158.525C93.6108 158.812 93.9955 158.975 94.3975 158.981C94.7458 158.985 95.0849 158.866 95.3576 158.644C95.4312 158.593 95.5204 158.572 95.6082 158.585C95.6959 158.597 95.7761 158.643 95.8332 158.712C95.8856 158.786 95.9088 158.877 95.8981 158.967C95.8873 159.058 95.8435 159.141 95.7754 159.199C95.3786 159.505 94.8935 159.665 94.3975 159.655C93.8247 159.657 93.2739 159.429 92.864 159.019C92.454 158.609 92.2177 158.051 92.2061 157.464Z",
    fill: "white"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9934 159.326V155.728C96.9928 155.683 97.0009 155.639 97.0173 155.598C97.0336 155.557 97.0578 155.519 97.0885 155.488C97.1191 155.457 97.1556 155.432 97.1958 155.415C97.236 155.398 97.279 155.39 97.3224 155.391C97.3659 155.39 97.4092 155.398 97.4496 155.415C97.49 155.432 97.5268 155.456 97.5578 155.488C97.5889 155.519 97.6135 155.556 97.6303 155.598C97.6471 155.639 97.6558 155.683 97.6558 155.728V157.194H99.2026V155.728C99.202 155.683 99.2101 155.639 99.2265 155.598C99.2428 155.557 99.267 155.519 99.2977 155.488C99.3283 155.457 99.3648 155.432 99.405 155.415C99.4452 155.398 99.4882 155.39 99.5316 155.391C99.6192 155.391 99.7034 155.426 99.7658 155.489C99.8282 155.552 99.8638 155.638 99.865 155.728V159.335C99.865 159.38 99.8563 159.424 99.8395 159.465C99.8227 159.506 99.7981 159.544 99.767 159.575C99.736 159.606 99.6992 159.631 99.6588 159.648C99.6184 159.665 99.5751 159.673 99.5316 159.672C99.4882 159.673 99.4452 159.664 99.405 159.648C99.3648 159.631 99.3283 159.606 99.2977 159.575C99.267 159.543 99.2428 159.506 99.2265 159.465C99.2101 159.424 99.202 159.38 99.2026 159.335V157.868H97.6558V159.335C97.6564 159.38 97.6481 159.424 97.6315 159.466C97.6149 159.507 97.5903 159.545 97.5592 159.576C97.5281 159.608 97.491 159.633 97.4503 159.649C97.4096 159.666 97.3661 159.673 97.3224 159.672C97.2782 159.673 97.2344 159.664 97.1937 159.647C97.1529 159.63 97.116 159.604 97.0852 159.572C97.0544 159.539 97.0304 159.501 97.0146 159.459C96.9988 159.416 96.9916 159.371 96.9934 159.326Z",
    fill: "white"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M104.342 155.915C104.727 156.334 104.943 156.888 104.946 157.464C104.947 158.039 104.73 158.592 104.342 159.008C104.162 159.213 103.942 159.377 103.696 159.49C103.45 159.603 103.184 159.662 102.915 159.664C102.64 159.663 102.369 159.604 102.117 159.491C101.866 159.378 101.64 159.214 101.453 159.008C101.068 158.591 100.856 158.037 100.861 157.464C100.858 156.889 101.069 156.335 101.453 155.915C101.64 155.709 101.866 155.546 102.118 155.434C102.369 155.322 102.641 155.264 102.915 155.264C103.184 155.265 103.45 155.323 103.695 155.436C103.941 155.548 104.161 155.711 104.342 155.915ZM104.266 157.464C104.265 157.067 104.119 156.685 103.857 156.393C103.737 156.257 103.589 156.149 103.425 156.074C103.261 156 103.083 155.961 102.904 155.961C102.724 155.961 102.547 156 102.383 156.074C102.219 156.149 102.071 156.257 101.95 156.393C101.685 156.683 101.539 157.066 101.542 157.464C101.537 157.859 101.684 158.24 101.95 158.525C102.07 158.664 102.216 158.775 102.381 158.851C102.545 158.927 102.724 158.966 102.904 158.966C103.084 158.966 103.263 158.927 103.427 158.851C103.591 158.775 103.738 158.664 103.857 158.525C104.121 158.237 104.267 157.858 104.266 157.464Z",
    fill: "white"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M109.356 155.915C109.741 156.334 109.957 156.888 109.961 157.464C109.961 158.039 109.744 158.592 109.356 159.008C109.176 159.213 108.956 159.377 108.71 159.49C108.464 159.603 108.198 159.662 107.929 159.664C107.655 159.662 107.385 159.604 107.134 159.491C106.883 159.378 106.657 159.214 106.471 159.008C106.085 158.592 105.873 158.038 105.88 157.464C105.875 156.889 106.086 156.334 106.471 155.915C106.658 155.71 106.883 155.546 107.134 155.434C107.385 155.322 107.656 155.264 107.929 155.264C108.198 155.265 108.464 155.323 108.71 155.436C108.955 155.548 109.175 155.711 109.356 155.915ZM109.281 157.464C109.281 157.068 109.137 156.686 108.876 156.393C108.755 156.257 108.607 156.148 108.443 156.074C108.278 155.999 108.1 155.961 107.92 155.961C107.74 155.961 107.563 155.999 107.398 156.074C107.233 156.148 107.086 156.257 106.965 156.393C106.703 156.685 106.558 157.067 106.56 157.464C106.556 157.858 106.701 158.238 106.965 158.525C107.084 158.664 107.231 158.775 107.396 158.851C107.561 158.927 107.74 158.966 107.92 158.966C108.101 158.966 108.28 158.927 108.444 158.851C108.609 158.775 108.756 158.664 108.876 158.525C109.138 158.237 109.283 157.857 109.281 157.464Z",
    fill: "white"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M111.103 159.326V155.728C111.103 155.638 111.137 155.553 111.199 155.489C111.261 155.426 111.344 155.391 111.432 155.391C111.519 155.391 111.603 155.426 111.666 155.489C111.728 155.552 111.764 155.638 111.765 155.728V158.993H113.383C113.464 159.003 113.539 159.043 113.594 159.106C113.648 159.168 113.678 159.249 113.678 159.333C113.678 159.417 113.648 159.497 113.594 159.56C113.539 159.623 113.464 159.662 113.383 159.672H111.432C111.388 159.672 111.344 159.663 111.304 159.646C111.263 159.628 111.226 159.602 111.196 159.57C111.165 159.538 111.141 159.5 111.125 159.458C111.109 159.416 111.101 159.371 111.103 159.326Z",
    fill: "white"
  })), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4131 236.549H7.80371V237.824H11.4131V236.549Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39887 239.436C8.33205 239.436 6.85184 239.487 5.79391 239.487H5.75391V238.12H5.81169C6.87407 238.12 8.37206 238.12 9.41666 238.147H9.44777V238.17L9.41666 239.45L9.39887 239.436ZM9.39887 239.436L9.3722 238.17L9.39887 238.202C8.79879 238.202 8.1987 238.202 7.59862 238.202H5.79391L5.84725 238.143V239.423L5.79836 239.368C6.83406 239.368 8.34983 239.4 9.40332 239.423L9.39887 239.436Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4688 201.048C69.3976 201.048 67.9174 201.098 66.8594 201.098H66.8105V199.731H66.8683C67.9307 199.731 69.4287 199.731 70.4777 199.759H70.5044V199.786L70.4777 201.066L70.4688 201.048ZM70.4688 201.048L70.4377 199.768L70.4688 199.8C69.8643 199.8 69.2642 199.8 68.6641 199.8H66.8594L66.9128 199.741V201.02L66.8639 200.966C67.8996 200.966 69.4198 201.002 70.4733 201.02L70.4688 201.048Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4561 201.382H64.8467V202.657H68.4561V201.382Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4522 201.048C65.381 201.048 63.9008 201.099 62.8428 201.099H62.7939V201.048V199.769V199.714H62.8517C63.9141 199.714 65.4121 199.714 66.4611 199.741H66.4878V199.769L66.4611 201.048H66.4522ZM66.4522 201.048L66.4211 199.769L66.4522 199.8C65.8477 199.8 65.2476 199.8 64.6475 199.8H62.8428L62.8962 199.741V201.021L62.8473 200.966C63.883 200.966 65.4032 201.003 66.4567 201.021L66.4522 201.048Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.168 191.803C177.097 191.803 175.617 191.857 174.559 191.853H174.51V190.486H174.568C175.63 190.486 177.128 190.486 178.177 190.518H178.204V190.546L178.177 191.821L178.168 191.803ZM178.168 191.803L178.137 190.527L178.168 190.555H176.363H174.559L174.612 190.5V191.775L174.563 191.725C175.599 191.725 177.119 191.757 178.173 191.775L178.168 191.803Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.168 217.898C177.097 217.898 175.617 217.953 174.559 217.953H174.51V216.563H174.568C175.63 216.563 177.128 216.563 178.177 216.595H178.204V216.623L178.177 217.898H178.168ZM178.168 217.898L178.137 216.623L178.168 216.65L176.363 216.673H174.559L174.612 216.618V217.893L174.563 217.843C175.599 217.843 177.119 217.875 178.173 217.893L178.168 217.898Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.157 188.91H176.548V190.185H180.157V188.91Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.467 191.557H130.857V192.832H134.467V191.557Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.481 239.105C133.409 239.105 131.929 239.16 130.871 239.155H130.822V239.105V237.83V237.771H130.88C131.942 237.771 133.44 237.771 134.489 237.798H134.516V237.83L134.489 239.105H134.481ZM134.481 239.105L134.449 237.83L134.481 237.857C133.876 237.857 133.276 237.857 132.676 237.857H130.871L130.925 237.802V239.078L130.876 239.023C131.911 239.023 133.432 239.06 134.485 239.078L134.481 239.105Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.464 236.212H132.854V237.487H136.464V236.212Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.149 190.189C175.082 190.189 173.602 190.244 172.544 190.239H172.49V188.873H172.548C173.61 188.873 175.108 188.873 176.153 188.9H176.184V188.928L176.153 190.203L176.149 190.189ZM176.149 190.189L176.122 188.914L176.149 188.941L174.348 188.964H172.544L172.597 188.909V190.185L172.548 190.135C173.584 190.135 175.099 190.167 176.153 190.185L176.149 190.189Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.463 203.616C26.3917 203.616 24.9115 203.671 23.8536 203.671H23.8047V202.305H23.8625C24.9248 202.305 26.4228 202.305 27.4719 202.332H27.4986V202.359L27.4719 203.635L27.463 203.616ZM27.463 203.616L27.4363 202.341L27.463 202.368L25.6583 202.391H23.8536L23.9114 202.332V203.607L23.8625 203.557C24.8982 203.557 26.4184 203.589 27.4719 203.607L27.463 203.616Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4698 238.662C67.3986 238.662 65.9183 238.717 64.8604 238.712H64.8115V237.346H64.8738C65.9361 237.346 67.4341 237.346 68.4832 237.373H68.5098V237.405L68.4832 238.68L68.4698 238.662ZM68.4698 238.662L68.4432 237.387L68.4698 237.414L66.6651 237.437H64.8738L64.9315 237.382V238.657L64.8738 238.626C65.9095 238.626 67.4297 238.657 68.4832 238.676L68.4698 238.662Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4454 203.616C22.3741 203.616 20.8939 203.671 19.836 203.671H19.7871V202.305H19.8405C20.9028 202.305 22.4008 202.305 23.4499 202.332H23.4765V202.359L23.4499 203.635L23.4454 203.616ZM23.4454 203.616L23.4187 202.341L23.4454 202.368L21.6407 202.391H19.836L19.8938 202.332V203.607L19.8449 203.557C20.8806 203.557 22.4008 203.589 23.4543 203.607L23.4454 203.616Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.811 225.594C118.744 225.594 117.259 225.644 116.206 225.644H116.152V224.277H116.21C117.273 224.277 118.766 224.277 119.815 224.305H119.846V224.332L119.815 225.612L119.811 225.594ZM119.811 225.594L119.784 224.314L119.811 224.346C119.211 224.346 118.61 224.346 118.006 224.346H116.228L116.281 224.286V225.566L116.232 225.512C117.268 225.512 118.784 225.548 119.837 225.566L119.811 225.594Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.811 173.2C118.744 173.2 117.259 173.255 116.206 173.25H116.152V171.884H116.21C117.273 171.884 118.766 171.884 119.815 171.911H119.846V171.938L119.815 173.214L119.811 173.2ZM119.811 173.2L119.784 171.925L119.811 171.952H118.006H116.228L116.281 171.897V173.173L116.232 173.123C117.268 173.123 118.784 173.155 119.837 173.173L119.811 173.2Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.822 173.532H118.213V174.808H121.822V173.532Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3135 187.85H37.7041V189.125H41.3135V187.85Z",
    fill: "#FFC727"
  }))), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M118.815 152.287H66.9453V162.64H118.815V152.287Z",
    fill: "#FFC727"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M118.81 153.3H66.9404V153.528H118.81V153.3Z",
    fill: "white"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M118.81 161.396H66.9404V161.623H118.81V161.396Z",
    fill: "white"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0522 250.072C21.0522 250.072 20.6788 248.286 19.932 248.009C19.1853 247.731 18.7274 248.537 18.7274 248.537C18.7274 248.537 18.5541 246.824 17.4917 246.314C16.4293 245.804 15.6381 246.852 15.6381 246.852C15.6381 246.852 14.8246 244.684 13.3711 244.684C11.9176 244.684 11.1886 247.872 11.1886 247.872C11.1886 247.872 10.3307 246.929 9.45054 247.462C8.57041 247.995 8.56152 250.09 8.56152 250.09L21.0522 250.072Z",
    fill: "#37474F"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M144.996 250.072C144.996 250.072 144.623 248.286 143.876 248.009C143.129 247.731 142.676 248.537 142.676 248.537C142.676 248.537 142.498 246.824 141.44 246.314C140.382 245.804 139.586 246.852 139.586 246.852C139.586 246.852 138.773 244.684 137.319 244.684C135.866 244.684 135.132 247.872 135.132 247.872C135.132 247.872 134.279 246.929 133.399 247.462C132.519 247.995 132.51 250.09 132.51 250.09L144.996 250.072Z",
    fill: "#455A64"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0708 250.072H40.9355C40.9355 250.072 41.3801 248.178 42.238 248.041C42.5002 248.017 42.7632 248.076 42.992 248.209C43.2207 248.343 43.4043 248.545 43.5181 248.788C43.5181 248.788 43.4781 246.142 45.105 245.691C46.7319 245.24 48.0921 247.576 48.0921 247.576C48.0921 247.576 49.1145 246.246 50.5014 246.328C51.8882 246.41 52.2483 248.606 52.2483 248.606C52.2483 248.606 53.5107 247.854 54.0708 250.072Z",
    fill: "#37474F"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3789 250.073H2.4668C2.4668 250.073 2.4668 249.02 3.16023 248.738C3.34503 248.656 3.55069 248.638 3.74629 248.687C3.94189 248.735 4.11684 248.848 4.24483 249.007C4.24483 249.007 4.52043 247.066 5.78727 247.066C7.05412 247.066 7.6631 248.738 7.6631 248.738C7.77056 248.578 7.92127 248.455 8.09663 248.382C8.27199 248.309 8.46433 248.29 8.64991 248.328C9.35223 248.424 9.3789 250.073 9.3789 250.073Z",
    fill: "#455A64"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4932 250.073H52.5811C52.5811 250.073 52.5811 249.02 53.2745 248.738C53.4593 248.656 53.665 248.638 53.8605 248.687C54.0561 248.735 54.2311 248.848 54.3591 249.007C54.3591 249.007 54.6391 247.066 55.906 247.066C57.1728 247.066 57.7596 248.738 57.7596 248.738C57.867 248.578 58.0177 248.455 58.1931 248.382C58.3685 248.309 58.5608 248.29 58.7464 248.328C59.4665 248.424 59.4932 250.073 59.4932 250.073Z",
    fill: "#455A64"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M173.198 250.073H166.286C166.286 250.073 166.286 249.02 166.98 248.738C167.164 248.656 167.37 248.638 167.566 248.687C167.761 248.735 167.936 248.848 168.064 249.007C168.064 249.007 168.34 247.066 169.607 247.066C170.873 247.066 171.482 248.738 171.482 248.738C171.589 248.578 171.74 248.454 171.916 248.381C172.091 248.308 172.284 248.29 172.469 248.328C173.172 248.424 173.198 250.073 173.198 250.073Z",
    fill: "#455A64"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M183.284 250.073H171.887C171.887 250.073 171.913 248.337 173.034 247.873C173.338 247.741 173.676 247.715 173.997 247.797C174.317 247.879 174.603 248.065 174.812 248.328C174.812 248.328 175.256 245.14 177.359 245.14C179.461 245.14 180.444 247.873 180.444 247.873C180.621 247.609 180.869 247.405 181.158 247.284C181.447 247.163 181.764 247.132 182.07 247.194C183.239 247.349 183.284 250.073 183.284 250.073Z",
    fill: "#37474F"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M683.502 57.4766H685.209C681.45 57.4766 678.405 60.6456 678.405 64.5545C678.405 68.4634 681.449 71.6359 685.209 71.6359H683.502C679.743 71.6359 676.697 68.4669 676.697 64.5545C676.697 60.6421 679.743 57.4766 683.502 57.4766Z",
    fill: "#0A8200"
  })), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.469 57.4756H685.177C681.418 57.4756 678.373 60.6446 678.373 64.5535C678.373 68.4624 681.417 71.6349 685.177 71.6349H683.469C679.71 71.6349 676.665 68.4659 676.665 64.5535C676.665 60.6412 679.71 57.4756 683.469 57.4756Z",
    fill: "black"
  }))), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M685.211 91.7221H683.503C690.41 83.4764 696.88 74.437 695.93 64.4569C695.311 57.9923 691.026 51.5537 683.503 51.5537H685.211C692.735 51.5537 697.019 57.9923 697.636 64.4569C698.594 74.437 692.125 83.4764 685.211 91.7221Z",
    fill: "#0A8200"
  })), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.229 91.7202H683.521C690.429 83.4744 696.898 74.4351 695.948 64.4549C695.329 57.9903 691.044 51.5518 683.521 51.5518H685.229C692.754 51.5518 697.037 57.9903 697.654 64.4549C698.613 74.4351 692.144 83.4744 685.229 91.7202Z",
    fill: "black"
  }))), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M695.929 64.4571C696.881 74.4373 690.412 83.4766 683.505 91.7241C676.606 83.4766 670.136 74.4373 671.086 64.4571C671.705 57.9925 675.99 51.5557 683.505 51.5557C691.019 51.5557 695.312 57.9925 695.929 64.4571ZM683.505 71.6355C687.272 71.6355 690.317 68.4665 690.317 64.5541C690.317 60.6418 687.274 57.4762 683.505 57.4762C679.735 57.4762 676.7 60.6452 676.7 64.5541C676.7 68.463 679.744 71.6355 683.505 71.6355Z",
    fill: "#0A8200"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M587.135 148.069H588.443C585.565 148.069 583.233 150.496 583.233 153.489C583.233 156.482 585.563 158.912 588.443 158.912H587.135C584.257 158.912 581.925 156.485 581.925 153.489C581.925 150.493 584.257 148.069 587.135 148.069Z",
    fill: "#0A8200"
  })), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.108 148.069H588.416C585.537 148.069 583.205 150.496 583.205 153.489C583.205 156.482 585.536 158.912 588.416 158.912H587.108C584.229 158.912 581.897 156.485 581.897 153.489C581.897 150.493 584.229 148.069 587.108 148.069Z",
    fill: "black"
  }))), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M588.442 174.293H587.134C592.423 167.979 597.377 161.057 596.649 153.415C596.175 148.464 592.894 143.534 587.134 143.534H588.442C594.203 143.534 597.483 148.464 597.956 153.415C598.69 161.057 593.736 167.979 588.442 174.293Z",
    fill: "#0A8200"
  })), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.456 174.29H587.148C592.438 167.976 597.392 161.054 596.664 153.412C596.19 148.462 592.909 143.531 587.148 143.531H588.456C594.218 143.531 597.498 148.462 597.97 153.412C598.705 161.054 593.751 167.976 588.456 174.29Z",
    fill: "black"
  }))), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M596.649 153.415C597.378 161.058 592.424 167.979 587.135 174.295C581.852 167.979 576.898 161.058 577.626 153.415C578.1 148.465 581.381 143.536 587.135 143.536C592.889 143.536 596.177 148.465 596.649 153.415ZM587.135 158.912C590.02 158.912 592.352 156.485 592.352 153.49C592.352 150.494 590.021 148.07 587.135 148.07C584.249 148.07 581.925 150.496 581.925 153.49C581.925 156.483 584.255 158.912 587.135 158.912Z",
    fill: "#0A8200"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M246.126 181.492H246.742C245.387 181.492 244.29 182.634 244.29 184.042C244.29 185.451 245.387 186.594 246.742 186.594H246.126C244.772 186.594 243.675 185.452 243.675 184.042C243.675 182.633 244.772 181.492 246.126 181.492Z",
    fill: "#0A8200"
  })), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.116 181.493H246.731C245.377 181.493 244.279 182.635 244.279 184.043C244.279 185.452 245.376 186.595 246.731 186.595H246.116C244.761 186.595 243.664 185.453 243.664 184.043C243.664 182.634 244.761 181.493 246.116 181.493Z",
    fill: "black"
  }))), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M246.743 193.832H246.128C248.617 190.861 250.948 187.604 250.605 184.008C250.382 181.679 248.838 179.359 246.128 179.359H246.743C249.454 179.359 250.998 181.679 251.22 184.008C251.565 187.604 249.234 190.861 246.743 193.832Z",
    fill: "#0A8200"
  })), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.75 193.83H246.135C248.624 190.859 250.955 187.602 250.612 184.006C250.389 181.677 248.845 179.357 246.135 179.357H246.75C249.461 179.357 251.004 181.677 251.227 184.006C251.572 187.602 249.241 190.859 246.75 193.83Z",
    fill: "black"
  }))), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M250.604 184.008C250.947 187.604 248.616 190.861 246.127 193.832C243.641 190.861 241.31 187.604 241.653 184.008C241.876 181.679 243.42 179.359 246.127 179.359C248.835 179.359 250.381 181.679 250.604 184.008ZM246.127 186.594C247.484 186.594 248.582 185.452 248.582 184.043C248.582 182.633 247.485 181.493 246.127 181.493C244.769 181.493 243.675 182.634 243.675 184.043C243.675 185.451 244.772 186.594 246.127 186.594Z",
    fill: "#0A8200"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M364.56 110.567H366.86C361.799 110.567 357.698 114.834 357.698 120.098C357.698 125.361 361.796 129.633 366.86 129.633H364.56C359.499 129.633 355.398 125.366 355.398 120.098C355.398 114.83 359.499 110.567 364.56 110.567Z",
    fill: "#0A8200"
  })), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.515 110.567H366.815C361.754 110.567 357.653 114.834 357.653 120.098C357.653 125.361 361.751 129.633 366.815 129.633H364.515C359.454 129.633 355.354 125.366 355.354 120.098C355.354 114.83 359.454 110.567 364.515 110.567Z",
    fill: "black"
  }))), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M366.863 156.68H364.563C373.864 145.577 382.575 133.406 381.296 119.968C380.462 111.263 374.693 102.594 364.563 102.594H366.863C376.995 102.594 382.762 111.263 383.593 119.968C384.884 133.406 376.173 145.577 366.863 156.68Z",
    fill: "#0A8200"
  })), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.885 156.677H364.585C373.886 145.574 382.597 133.403 381.317 119.965C380.484 111.26 374.714 102.591 364.585 102.591H366.885C377.016 102.591 382.783 111.26 383.614 119.965C384.905 133.403 376.194 145.574 366.885 156.677Z",
    fill: "black"
  }))), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M381.292 119.967C382.574 133.405 373.863 145.577 364.562 156.682C355.273 145.577 346.562 133.405 347.841 119.967C348.675 111.263 354.444 102.596 364.562 102.596C374.68 102.596 380.461 111.263 381.292 119.967ZM364.562 129.633C369.635 129.633 373.735 125.366 373.735 120.098C373.735 114.83 369.637 110.568 364.562 110.568C359.487 110.568 355.4 114.835 355.4 120.098C355.4 125.361 359.499 129.633 364.562 129.633Z",
    fill: "#0A8200"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M649.582 256.303H650.304L650.123 236.394H649.763L649.582 256.303Z",
    fill: "#FFC727"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M649.582 256.303H650.304L650.123 236.394H649.763L649.582 256.303Z",
    fill: "black"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M649.764 236.411L654.075 233.952V234.074L650.081 236.534L649.764 236.411Z",
    fill: "#FFC727"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M649.764 236.411L654.075 233.952V234.074L650.081 236.534L649.764 236.411Z",
    fill: "black"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M653.672 233.845L653.721 234.28H655.651V233.561L653.672 233.845Z",
    fill: "#FFC727"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M650.093 236.411L645.782 233.952V234.074L649.773 236.534L650.093 236.411Z",
    fill: "#FFC727"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M650.093 236.411L645.782 233.952V234.074L649.773 236.534L650.093 236.411Z",
    fill: "black"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M646.181 233.845L646.132 234.28H644.202V233.561L646.181 233.845Z",
    fill: "#FFC727"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M650.444 256.304H649.44L649.537 250.936H650.344L650.444 256.304Z",
    fill: "#FFC727"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M710.944 256.303H711.667L711.485 236.394H711.125L710.944 256.303Z",
    fill: "#FFC727"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M710.944 256.303H711.667L711.485 236.394H711.125L710.944 256.303Z",
    fill: "black"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M711.128 236.411L715.439 233.952V234.074L711.445 236.534L711.128 236.411Z",
    fill: "#FFC727"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M711.128 236.411L715.439 233.952V234.074L711.445 236.534L711.128 236.411Z",
    fill: "black"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M715.039 233.845L715.088 234.28H717.016V233.561L715.039 233.845Z",
    fill: "#FFC727"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M711.457 236.411L707.146 233.952V234.074L711.14 236.534L711.457 236.411Z",
    fill: "#FFC727"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M711.457 236.411L707.146 233.952V234.074L711.14 236.534L711.457 236.411Z",
    fill: "black"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M707.547 233.845L707.498 234.28H705.57V233.561L707.547 233.845Z",
    fill: "#FFC727"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M711.809 256.304H710.805L710.901 250.936H711.71L711.809 256.304Z",
    fill: "#FFC727"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M772.312 256.303H773.032L772.854 236.394H772.491L772.312 256.303Z",
    fill: "#FFC727"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M772.312 256.303H773.032L772.854 236.394H772.491L772.312 256.303Z",
    fill: "black"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M772.491 236.411L776.802 233.952V234.074L772.809 236.534L772.491 236.411Z",
    fill: "#FFC727"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M772.491 236.411L776.802 233.952V234.074L772.809 236.534L772.491 236.411Z",
    fill: "black"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M776.404 233.845L776.453 234.28H778.383V233.561L776.404 233.845Z",
    fill: "#FFC727"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M776.404 233.845L776.453 234.28H778.383V233.561L776.404 233.845Z",
    fill: "white"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M772.823 236.411L768.512 233.952V234.074L772.505 236.534L772.823 236.411Z",
    fill: "#FFC727"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M772.823 236.411L768.512 233.952V234.074L772.505 236.534L772.823 236.411Z",
    fill: "black"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M768.911 233.845L768.862 234.28H766.933V233.561L768.911 233.845Z",
    fill: "#FFC727"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M768.911 233.845L768.862 234.28H766.933V233.561L768.911 233.845Z",
    fill: "white"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M773.176 256.304H772.172L772.268 250.936H773.075L773.176 256.304Z",
    fill: "#FFC727"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M643.574 242.71C643.574 242.71 647.152 250.88 641.302 250.887C635.453 250.894 639.232 242.438 639.232 242.438C639.232 242.438 637.875 241.828 639.456 237.267C641.036 232.705 641.727 232.705 642.38 232.705C643.205 232.705 643.977 234.678 643.415 237.707C643.404 237.702 645.47 241.48 643.574 242.71Z",
    fill: "#37474F"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M640.789 256.305L641.341 243.992L641.918 256.302L640.789 256.305Z",
    fill: "#263238"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M641.117 249.155L643.244 246.603L641.576 249.492L641.117 249.155Z",
    fill: "#263238"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M773.357 243.587C773.357 243.587 771.684 242.899 770.361 245.275C769.004 247.701 770.71 249.296 772.062 248.343C772.062 248.343 773.124 250.634 775.246 250.08C777.368 249.525 777.706 247.788 777.706 247.788C777.706 247.788 779.591 247.924 779.642 246.483C779.693 245.041 778.3 243.765 778.3 243.765C778.3 243.765 778.218 240.177 775.937 240.207C773.656 240.237 773.357 243.587 773.357 243.587Z",
    fill: "#455A64"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M774.925 256.298L775.39 245.621L775.88 256.298H774.925Z",
    fill: "#263238"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M775.253 249.633L773.784 246.641L775.492 249.165L775.253 249.633Z",
    fill: "#263238"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M700.783 243.587C700.783 243.587 699.11 242.899 697.787 245.275C696.429 247.701 698.135 249.296 699.488 248.343C699.488 248.343 700.552 250.634 702.672 250.08C704.792 249.525 705.131 247.788 705.131 247.788C705.131 247.788 707.014 247.924 707.066 246.483C707.117 245.041 705.735 243.765 705.735 243.765C705.735 243.765 705.652 240.177 703.372 240.207C701.091 240.237 700.783 243.587 700.783 243.587Z",
    fill: "#455A64"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M702.352 256.298L702.817 245.621L703.306 256.298H702.352Z",
    fill: "#263238"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M702.682 249.633L701.215 246.641L702.921 249.165L702.682 249.633Z",
    fill: "#263238"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M725.473 244.388C725.473 244.388 722.343 251.55 727.485 251.543C732.628 251.536 729.274 244.141 729.274 244.141C729.274 244.141 730.461 243.602 729.079 239.611C727.698 235.62 727.08 235.62 726.508 235.62C725.784 235.62 725.113 237.35 725.614 240.005C725.611 240.005 723.809 243.318 725.473 244.388Z",
    fill: "#37474F"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M727.943 256.291L727.435 245.507L726.952 256.293L727.943 256.291Z",
    fill: "#263238"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M727.641 250.028L725.774 247.797L727.239 250.324L727.641 250.028Z",
    fill: "#263238"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M779.689 244.388C779.689 244.388 776.558 251.55 781.701 251.543C786.844 251.536 783.49 244.141 783.49 244.141C783.49 244.141 784.677 243.602 783.293 239.611C781.909 235.62 781.296 235.62 780.724 235.62C779.999 235.62 779.329 237.35 779.83 240.005C779.827 240.005 778.025 243.318 779.689 244.388Z",
    fill: "#37474F"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M782.151 256.291L781.646 245.507L781.163 256.293L782.151 256.291Z",
    fill: "#263238"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M781.852 250.028L779.985 247.797L781.45 250.324L781.852 250.028Z",
    fill: "#263238"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M541.581 103.769C541.581 104.177 541.258 104.508 540.86 104.508C540.462 104.508 540.139 104.177 540.139 103.769C540.139 103.361 540.462 103.03 540.86 103.03C541.258 103.03 541.581 103.361 541.581 103.769Z",
    fill: "#2C87D3"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M540.848 103.795C540.848 103.782 540.837 103.771 540.824 103.771C540.812 103.771 540.801 103.782 540.801 103.795C540.801 103.808 540.812 103.819 540.824 103.819C540.837 103.819 540.848 103.808 540.848 103.795Z",
    fill: "white"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M540.956 103.819C540.969 103.819 540.979 103.808 540.979 103.795C540.979 103.782 540.969 103.771 540.956 103.771C540.943 103.771 540.933 103.782 540.933 103.795C540.933 103.808 540.943 103.819 540.956 103.819Z",
    fill: "white"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M540.89 103.892C540.918 103.892 540.941 103.872 540.948 103.847H540.832C540.839 103.872 540.862 103.892 540.89 103.892Z",
    fill: "white"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M541.157 103.581C541.099 103.517 541.04 103.575 541.017 103.603C540.981 103.575 540.935 103.557 540.886 103.557C540.833 103.557 540.786 103.576 540.748 103.608C540.728 103.582 540.666 103.513 540.605 103.581C540.605 103.581 540.626 103.654 540.715 103.644C540.687 103.681 540.671 103.727 540.671 103.778C540.671 103.899 540.767 103.998 540.886 103.998C541.004 103.998 541.1 103.899 541.1 103.778C541.1 103.728 541.084 103.682 541.057 103.645C541.138 103.648 541.157 103.581 541.157 103.581ZM540.886 103.944C540.796 103.944 540.723 103.869 540.723 103.778C540.723 103.765 540.724 103.754 540.727 103.742H540.831L540.83 103.697L540.875 103.742H541.044C541.047 103.754 541.048 103.765 541.048 103.778C541.048 103.869 540.975 103.944 540.886 103.944Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 547.027,
    cy: 106.727,
    rx: 0.721076,
    ry: 0.738876,
    fill: "#6900AA"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M547.092 106.74C547.073 106.722 547.048 106.712 547.022 106.712C546.996 106.712 546.971 106.722 546.952 106.74L546.868 106.822C546.82 106.867 546.855 106.953 546.92 106.949C546.955 106.948 546.984 106.93 547.022 106.931C547.062 106.93 547.091 106.946 547.127 106.949C547.191 106.951 547.224 106.866 547.176 106.822L547.092 106.74Z",
    fill: "white"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M547.237 106.62C547.204 106.613 547.179 106.651 547.173 106.683C547.153 106.783 547.248 106.802 547.27 106.705C547.279 106.664 547.264 106.626 547.237 106.62V106.62Z",
    fill: "white"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M547.097 106.674C547.13 106.674 547.157 106.636 547.157 106.589C547.153 106.477 547.041 106.477 547.038 106.589C547.038 106.636 547.065 106.674 547.097 106.674V106.674Z",
    fill: "white"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M546.872 106.683C546.866 106.651 546.84 106.613 546.807 106.62C546.746 106.636 546.772 106.769 546.832 106.769C546.866 106.768 546.881 106.728 546.872 106.683V106.683Z",
    fill: "white"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M546.947 106.674C546.98 106.674 547.006 106.636 547.006 106.589C547.003 106.477 546.891 106.477 546.888 106.589C546.888 106.636 546.914 106.674 546.947 106.674V106.674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalContentCity);
export default __webpack_public_path__ + "static/media/LocalContentCity.b448652f393f91a6ef31b006d1aa9aa6.svg";
export { ForwardRef as ReactComponent };